/**
 * wco-orders
 * The purpose of this is to retrieve all orders for a given customer
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program then edited by us.
 * https://github.com/swagger-api/swagger-codegen.git
 */

import { type TierUpgrade } from '@/constants/bookings'

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
  (url: string, init?: any): Promise<Response>
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
  url: string
  options: any
}

/**
 *
 * @export
 * @interface AcdcTdtsLambdaRequest
 */
export interface AcdcTdtsLambdaRequest {
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  emptyStringIfNull?: string
  /**
   *
   * @type {Date}
   * @memberof AcdcTdtsLambdaRequest
   */
  epochDateIfNull?: Date
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  sessionId?: string
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  pmid?: string
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  codeHotel?: string
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  codeLangueHotel?: string
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  languageCode?: string
  /**
   *
   * @type {Date}
   * @memberof AcdcTdtsLambdaRequest
   */
  birthDate?: Date
  /**
   *
   * @type {Date}
   * @memberof AcdcTdtsLambdaRequest
   */
  date?: Date
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  numResa?: string
  /**
   *
   * @type {boolean}
   * @memberof AcdcTdtsLambdaRequest
   */
  isLoyaltyCardMember?: boolean
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  leahReturnCode?: string
  /**
   *
   * @type {string}
   * @memberof AcdcTdtsLambdaRequest
   */
  npaiEmail?: string
  /**
   *
   * @type {Array<ContactCardModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  contactCards?: Array<ContactCardModel>
  /**
   *
   * @type {Array<SearchBookingModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  searchBookings?: Array<SearchBookingModel>
  /**
   *
   * @type {Array<AddressModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  addresses?: Array<AddressModel>
  /**
   *
   * @type {Array<AggregateSegmentModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  aggregateSegments?: Array<AggregateSegmentModel>
  /**
   *
   * @type {Array<AwardTypeModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  awardTypes?: Array<AwardTypeModel>
  /**
   *
   * @type {Array<ComputePointModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  computePoints?: Array<ComputePointModel>
  /**
   *
   * @type {Array<ConsultBookingModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  consultBookings?: Array<ConsultBookingModel>
  /**
   *
   * @type {Array<MobileModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  mobiles?: Array<MobileModel>
  /**
   *
   * @type {Array<PreferenceModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  preferences?: Array<PreferenceModel>
  /**
   *
   * @type {Array<SatisfactionSurveyModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  satisfactionSurveys?: Array<SatisfactionSurveyModel>
  /**
   *
   * @type {Array<TarsModel>}
   * @memberof AcdcTdtsLambdaRequest
   */
  tars?: Array<TarsModel>
}
/**
 *
 * @export
 * @interface AcdcTdtsLambdaResponse
 */
export interface AcdcTdtsLambdaResponse {
  /**
   *
   * @type {Array<ResponseChoiceModel>}
   * @memberof AcdcTdtsLambdaResponse
   */
  choices?: Array<ResponseChoiceModel>
}
/**
 * address
 * @export
 * @interface Address
 */
export interface Address {
  /**
   * Address street
   * @type {string}
   * @memberof Address
   */
  street?: string
  /**
   * Address zip code
   * @type {string}
   * @memberof Address
   */
  zipCode?: string
  /**
   * Address city
   * @type {string}
   * @memberof Address
   */
  city?: string
  /**
   * Address country / translated using language query param (en by default)
   * @type {string}
   * @memberof Address
   */
  country?: string
  /**
   * Address country code iso alpha-2
   * @type {string}
   * @memberof Address
   */
  countryCode?: string
  /**
   * Address state code iso
   * @type {string}
   * @memberof Address
   */
  stateCode?: string
}
/**
 *
 * @export
 * @interface AddressModel
 */
export interface AddressModel {
  /**
   *
   * @type {string}
   * @memberof AddressModel
   */
  npaiFlag?: string
  /**
   *
   * @type {string}
   * @memberof AddressModel
   */
  usage?: string
}
/**
 *
 * @export
 * @interface AggregateSegmentModel
 */
export interface AggregateSegmentModel {
  /**
   *
   * @type {string}
   * @memberof AggregateSegmentModel
   */
  aggregateCode?: string
  /**
   *
   * @type {string}
   * @memberof AggregateSegmentModel
   */
  aggregateValue?: string
}
/**
 *
 * @export
 * @interface AwardTypeModel
 */
export interface AwardTypeModel {
  /**
   *
   * @type {string}
   * @memberof AwardTypeModel
   */
  awardId?: string
  /**
   *
   * @type {string}
   * @memberof AwardTypeModel
   */
  type?: string
  /**
   *
   * @type {string}
   * @memberof AwardTypeModel
   */
  awardTypeName?: string
  /**
   *
   * @type {string}
   * @memberof AwardTypeModel
   */
  status?: string
}
/**
 * will contain the sum of booking with points (aka loyalty vouchers) used in the hotel booking, excluding non valid loyalty vouchers.
 * @export
 * @interface Awards
 */
export interface Awards {
  /**
   * sum of orderItems[*].hotelBooking.awards.length() in the order.
   * @type {number}
   * @memberof Awards
   */
  totalAwardsUsed?: number
  /**
   * Value of awards in the order's currency. sum of orderItems[*].hotelBooking.awards.amount.value in the order.
   * @type {CurrencyValue}
   * @memberof Awards
   */
  totalAmount?: CurrencyValue
}
/**
 * will contain the sum of booking with points (aka loyalty vouchers) used in the hotel booking, excluding non valid loyalty vouchers.
 * @export
 * @interface BookingWithPoints
 */
export interface BookingWithPoints {
  /**
   * sum of orderItems[hotelBooking.loyaltyVoucher.valid===true].hotelBooking.loyaltyVoucher.pointNumber in the order.
   * @type {number}
   * @memberof BookingWithPoints
   */
  totalPointsRedeemed?: number
  /**
   *
   * @type {BookingWithPointsTotalAmountsRedeemed}
   * @memberof BookingWithPoints
   */
  totalAmountsRedeemed?: BookingWithPointsTotalAmountsRedeemed
}
/**
 *
 * @export
 * @interface BookingWithPointsTotalAmountsRedeemed
 */
export interface BookingWithPointsTotalAmountsRedeemed {
  /**
   * Value of points in the order's currency. sum of orderItems[hotelBooking.loyaltyVoucher.valid===true].hotelBooking.loyaltyVoucher.tarsAmount.value in the order.
   * @type {CurrencyValue}
   * @memberof BookingWithPointsTotalAmountsRedeemed
   */
  tarsAmount?: CurrencyValue
  /**
   * Value of points in the referrence currency (should be EUR, no other values since 2023-01-01). sum of orderItems[hotelBooking.loyaltyVoucher.valid===true].hotelBooking.loyaltyVoucher.emissionAmount.value in the order.
   * @type {CurrencyValue}
   * @memberof BookingWithPointsTotalAmountsRedeemed
   */
  emissionAmount?: CurrencyValue
}
/**
 *
 * @export
 * @interface BurnLocation
 */
export interface BurnLocation {
  /**
   *
   * @type {string}
   * @memberof BurnLocation
   */
  code?: string
  /**
   *
   * @type {string}
   * @memberof BurnLocation
   */
  label?: string
}
/**
 *
 * @export
 * @interface BusinessError
 */
export interface BusinessError {
  /**
   *
   * @type {string}
   * @memberof BusinessError
   */
  errorCode?: string
  /**
   *
   * @type {string}
   * @memberof BusinessError
   */
  errorMessage?: string
  /**
   *
   * @type {string}
   * @memberof BusinessError
   */
  description?: string
  /**
   *
   * @type {string}
   * @memberof BusinessError
   */
  executionId?: string
}
/**
 *
 * @export
 * @interface CdvData
 */
export interface CdvData {
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  codeHotel?: string
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  codeTarsKey?: string
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  codeTypeTarsKey?: string
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  codeTarif?: string
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  codeCDV?: string
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  dateDebut?: string
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  dateFin?: string
  /**
   *
   * @type {number}
   * @memberof CdvData
   */
  numjour?: number
  /**
   *
   * @type {number}
   * @memberof CdvData
   */
  numTranche?: number
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  indPublication?: string
  /**
   *
   * @type {number}
   * @memberof CdvData
   */
  nbJourDeb?: number
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  heureDeb?: string
  /**
   *
   * @type {number}
   * @memberof CdvData
   */
  nbJourFin?: number
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  heureFin?: string
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  status?: string
  /**
   *
   * @type {number}
   * @memberof CdvData
   */
  amount?: number
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  codeDevise?: string
  /**
   *
   * @type {string}
   * @memberof CdvData
   */
  flagInterdit?: string
}
/**
 *
 * @export
 * @interface CdvDescData
 */
export interface CdvDescData {
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeCDV?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  dateDebut?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  dateFin?: string
  /**
   *
   * @type {number}
   * @memberof CdvDescData
   */
  numjour?: number
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeHotel?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeTypeTarsKey?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeTarsKey?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeTarif?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeInterface?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeSysteme?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeFonction?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeLangue?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  codeTypeScript?: string
  /**
   *
   * @type {string}
   * @memberof CdvDescData
   */
  libelle?: string
}
/**
 * This type represents the dynamodb item of a cdv in the database for 'tars_cdvmodclx_desc' table. It's declared here for generating TypeScript code, or Avro Schema
 * @export
 * @interface CdvDescDynamodb
 */
export interface CdvDescDynamodb {
  /**
   * Hash key
   * @type {string}
   * @memberof CdvDescDynamodb
   */
  id: string
  /**
   * Sort key
   * @type {string}
   * @memberof CdvDescDynamodb
   */
  codeLangue: string
  /**
   *
   * @type {CdvDescData}
   * @memberof CdvDescDynamodb
   */
  data: CdvDescData
}
/**
 * This type represents the dynamodb item of a cdv in the database for 'tars_cdvmodclx' table. It's declared here for generating TypeScript code, or Avro Schema
 * @export
 * @interface CdvDynamodb
 */
export interface CdvDynamodb {
  /**
   * Hash key
   * @type {string}
   * @memberof CdvDynamodb
   */
  id: string
  /**
   * Sort key
   * @type {string}
   * @memberof CdvDynamodb
   */
  uniqueIdentifier: string
  /**
   *
   * @type {CdvData}
   * @memberof CdvDynamodb
   */
  data: CdvData
}
/**
 * code and label of the parent object
 * @export
 * @interface CodeLabel
 */
export interface CodeLabel {
  /**
   * code
   * @type {string}
   * @memberof CodeLabel
   */
  code?: string
  /**
   * label
   * @type {string}
   * @memberof CodeLabel
   */
  label?: string
}
/**
 *
 * @export
 * @interface ComputePointModel
 */
export interface ComputePointModel {
  /**
   *
   * @type {string}
   * @memberof ComputePointModel
   */
  leahReturnCode?: string
  /**
   *
   * @type {string}
   * @memberof ComputePointModel
   */
  cardNumber?: string
  /**
   *
   * @type {string}
   * @memberof ComputePointModel
   */
  campaignCode?: string
  /**
   *
   * @type {number}
   * @memberof ComputePointModel
   */
  points?: number
  /**
   *
   * @type {string}
   * @memberof ComputePointModel
   */
  bonusType?: string
  /**
   *
   * @type {string}
   * @memberof ComputePointModel
   */
  animationName?: string
  /**
   *
   * @type {string}
   * @memberof ComputePointModel
   */
  subscriptionRequired?: string
  /**
   *
   * @type {string}
   * @memberof ComputePointModel
   */
  targetCardType?: string
  /**
   *
   * @type {string}
   * @memberof ComputePointModel
   */
  ruleName?: string
}
/**
 *
 * @export
 * @interface ConsultBookingModel
 */
export interface ConsultBookingModel {
  /**
   *
   * @type {string}
   * @memberof ConsultBookingModel
   */
  resaObsHotel?: string
  /**
   *
   * @type {string}
   * @memberof ConsultBookingModel
   */
  resaObs?: string
  /**
   *
   * @type {string}
   * @memberof ConsultBookingModel
   */
  codeCivi?: string
}
/**
 * contact information
 * @export
 * @interface Contact
 */
export interface Contact {
  /**
   * Contact's phone prefix
   * @type {string}
   * @memberof Contact
   */
  phonePrefix?: string
  /**
   * Contact's phone
   * @type {string}
   * @memberof Contact
   */
  phone?: string
  /**
   * Contact's fax prefix
   * @type {string}
   * @memberof Contact
   */
  faxPrefix?: string
  /**
   * Contact's fax
   * @type {string}
   * @memberof Contact
   */
  fax?: string
  /**
   * Contact's mail
   * @type {string}
   * @memberof Contact
   */
  mail?: string
  /**
   *
   * @type {ContactGeneralManager}
   * @memberof Contact
   */
  generalManager?: ContactGeneralManager
}
/**
 *
 * @export
 * @interface ContactCardModel
 */
export interface ContactCardModel {
  /**
   *
   * @type {string}
   * @memberof ContactCardModel
   */
  cardNumber?: string
  /**
   *
   * @type {string}
   * @memberof ContactCardModel
   */
  cardType?: string
  /**
   *
   * @type {Date}
   * @memberof ContactCardModel
   */
  expirationDate?: Date
}
/**
 * Hotel manager information
 * @export
 * @interface ContactGeneralManager
 */
export interface ContactGeneralManager {
  /**
   * Hotel manager first name
   * @type {string}
   * @memberof ContactGeneralManager
   */
  firstName?: string
  /**
   * Hotel manager last name
   * @type {string}
   * @memberof ContactGeneralManager
   */
  lastName?: string
  /**
   * Hotel manager's phone prefix
   * @type {string}
   * @memberof ContactGeneralManager
   */
  phonePrefix?: string
  /**
   * Hotel manager's phone number
   * @type {string}
   * @memberof ContactGeneralManager
   */
  phone?: string
  /**
   * Hotel manager's email
   * @type {string}
   * @memberof ContactGeneralManager
   */
  email?: string
}
/**
 *
 * @export
 * @interface ContactMedium
 */
export interface ContactMedium {
  /**
   * email of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  email?: string
  /**
   * address of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  address1?: string
  /**
   * complementary address of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  address2?: string
  /**
   * complementary address3 of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  address3?: string
  /**
   * zipCode of the address of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  zipCode?: string
  /**
   * city of the address of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  city?: string
  /**
   * state code of the address of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  stateCode?: string
  /**
   * state name of the address of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  stateName?: string
  /**
   * country code of the address of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  countryCode?: string
  /**
   * country name of the address of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  countryName?: string
  /**
   * phone type of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  phoneType?: string
  /**
   * phone number of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  number?: string
  /**
   * prefix phone number of the mainbeneficiary
   * @type {string}
   * @memberof ContactMedium
   */
  prefix?: string
  /**
   * fax number of the mainbeneficiary, contactMediums[type=TELEPHONE & phoneType=\"FAX\"].number
   * @type {string}
   * @memberof ContactMedium
   */
  faxNumber?: string
  /**
   * fax phone number of the mainbeneficiary, contactMediums[type=TELEPHONE & phoneType=\"FAX\"].prefix
   * @type {string}
   * @memberof ContactMedium
   */
  faxPrefix?: string
}
/**
 * currency code and value
 * @export
 * @interface CurrencyValue
 */
export interface CurrencyValue {
  /**
   *
   * @type {string}
   * @memberof CurrencyValue
   */
  currencyCode?: string
  /**
   *
   * @type {string}
   * @memberof CurrencyValue
   */
  value?: string
}
/**
 * Digital gift to consume during the stay
 * @export
 * @interface DigitalGift
 */
export interface DigitalGift {
  /**
   * Main typology of the digital gift
   * @type {string}
   * @memberof DigitalGift
   */
  type?: string
  /**
   * unique number to identify the digital gift
   * @type {string}
   * @memberof DigitalGift
   */
  number?: string
  /**
   * identify the step in the life cycle of the gift
   * @type {string}
   * @memberof DigitalGift
   */
  status?: string
  /**
   * date of the status. Main usage for REDEEMED status to know when the digital gift has been burned
   * @type {string}
   * @memberof DigitalGift
   */
  statusDate?: string
  /**
   * Begin date to burn the digital gift
   * @type {string}
   * @memberof DigitalGift
   */
  beginValidityDate?: string
  /**
   * End date to burn the digital gift
   * @type {string}
   * @memberof DigitalGift
   */
  endValidityDate?: string
  /**
   * location where the digital gift can be burned
   * @type {BurnLocation}
   * @memberof DigitalGift
   */
  burnLocation?: BurnLocation
  /**
   * A node that encapsulates both the rule's code and the associated label responsible for generating the digital gift
   * @type {DigitalGiftRule}
   * @memberof DigitalGift
   */
  rule?: DigitalGiftRule
  /**
   * an array of profit choice available from the voucher
   * @type {Array<DigitalGiftProfit>}
   * @memberof DigitalGift
   */
  profit?: Array<DigitalGiftProfit>
}
/**
 *
 * @export
 * @interface DigitalGiftHistory
 */
export interface DigitalGiftHistory {
  /**
   * order folder number
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  orderId?: string
  /**
   * hotel code associated to the order
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  hotelCode?: string
  /**
   * hotel brand code
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  hotelBrandCode?: string
  /**
   * Address hotel country code - country code iso alpha-2
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  hotelCountryCode?: string
  /**
   * order Check-in date
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  arrivalDate?: string
  /**
   * order Check-out date
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  departureDate?: string
  /**
   * Unique ID in all Accor IT system
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  pmid?: string
  /**
   * loyalty card from order
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  loyaltyCard?: string
  /**
   * number of physical person booked in order
   * @type {number}
   * @memberof DigitalGiftHistory
   */
  nbPax?: number
  /**
   * status of order life cycle associated
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  orderStatus?: string
  /**
   * Origin for booking the order. CLUSTER, GDS, Accor Web
   * @type {string}
   * @memberof DigitalGiftHistory
   */
  orderOrigin?: string
  /**
   * an array of digital gifts associated to the order
   * @type {Array<DigitalGiftHistoryDigitalGifts>}
   * @memberof DigitalGiftHistory
   */
  digitalGifts?: Array<DigitalGiftHistoryDigitalGifts>
}
/**
 *
 * @export
 * @interface DigitalGiftHistoryDigitalGifts
 */
export interface DigitalGiftHistoryDigitalGifts {
  /**
   * typology of the digital welcome gift returned
   * @type {string}
   * @memberof DigitalGiftHistoryDigitalGifts
   */
  type?: string
  /**
   * uniq number og the digital gift voucher
   * @type {string}
   * @memberof DigitalGiftHistoryDigitalGifts
   */
  number?: string
  /**
   * life cycle status of the digital gift voucher
   * @type {string}
   * @memberof DigitalGiftHistoryDigitalGifts
   */
  status?: string
  /**
   * GMT date-time of the status of the digital gift voucher
   * @type {Date}
   * @memberof DigitalGiftHistoryDigitalGifts
   */
  statusDate?: Date
  /**
   * begin date when the member may be redeemed the voucher
   * @type {string}
   * @memberof DigitalGiftHistoryDigitalGifts
   */
  beginValidityDate?: string
  /**
   * end date when the member may be redeemed the voucher
   * @type {string}
   * @memberof DigitalGiftHistoryDigitalGifts
   */
  endValidityDate?: string
  /**
   * location where the digital gift can be burned
   * @type {BurnLocation}
   * @memberof DigitalGiftHistoryDigitalGifts
   */
  burnLocation?: BurnLocation
}
/**
 *
 * @export
 * @interface DigitalGiftProfit
 */
export interface DigitalGiftProfit {
  /**
   * profit type
   * @type {string}
   * @memberof DigitalGiftProfit
   */
  type?: string
  /**
   * profit code regarding profit type
   * @type {string}
   * @memberof DigitalGiftProfit
   */
  code?: string
  /**
   * profit label regarding profit code translate within input language
   * @type {string}
   * @memberof DigitalGiftProfit
   */
  label?: string
  /**
   * include code benefit or exlude code benefit
   * @type {string}
   * @memberof DigitalGiftProfit
   */
  operator?: string
}
/**
 *
 * @export
 * @interface DigitalGiftRule
 */
export interface DigitalGiftRule {
  /**
   * Code of the rule that has generated the digital gift
   * @type {string}
   * @memberof DigitalGiftRule
   */
  code?: string
  /**
   * Label corresponding to the rule
   * @type {string}
   * @memberof DigitalGiftRule
   */
  label?: string
}
/**
 *
 * @export
 * @interface DirectHotelError
 */
export interface DirectHotelError {
  /**
   *
   * @type {string}
   * @memberof DirectHotelError
   */
  errorCode: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelError
   */
  errorMessage: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelError
   */
  description: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelError
   */
  subSystemErrorCode?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelError
   */
  executionId?: string
}
/**
 *
 * @export
 * @interface DirectHotelOrderDb
 */
export interface DirectHotelOrderDb {
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  orderId?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  orderItemId?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  hotelCode?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  pmid?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  checkinDate?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  checkoutDate?: string
  /**
   *
   * @type {number}
   * @memberof DirectHotelOrderDb
   */
  nbPax?: number
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  cro?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  subCro?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  creationDate?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  callerApp?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  callerOperator?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderDb
   */
  traceId?: string
}
/**
 *
 * @export
 * @interface DirectHotelOrderInput
 */
export interface DirectHotelOrderInput {
  /**
   * Id of the booking in the hotel's PMS. Will be used to generate the orderId and the orderItemId.<br />
   * @type {string}
   * @memberof DirectHotelOrderInput
   */
  pmsOrderReference: string
  /**
   * Personal Member Id
   * @type {string}
   * @memberof DirectHotelOrderInput
   */
  pmid: string
  /**
   * Date of the beginning of the stay<br/><b>Format YYYY-MM-DD</b>
   * @type {string}
   * @memberof DirectHotelOrderInput
   */
  checkInDate: string
  /**
   * Date of the end of the stay<br/><b>Format YYYY-MM-DD</b>
   * @type {string}
   * @memberof DirectHotelOrderInput
   */
  checkOutDate: string
  /**
   * Number of persons in the same room as the card holder (including the card holder)
   * @type {number}
   * @memberof DirectHotelOrderInput
   */
  nbPax: number
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderInput
   */
  cro?: string
  /**
   *
   * @type {string}
   * @memberof DirectHotelOrderInput
   */
  subCro?: string
}
/**
 *
 * @export
 * @interface DirectHotelOrderOutput
 */
export interface DirectHotelOrderOutput {
  /**
   * Id of the order created (will be equal to the pmsOrderReference given in input)
   * @type {string}
   * @memberof DirectHotelOrderOutput
   */
  orderId: string
}
/**
 * acdc information of the customer
 * @export
 * @interface GetACDCResponse
 */
export interface GetACDCResponse {
  /**
   * booking id
   * @type {string}
   * @memberof GetACDCResponse
   */
  numResa?: string
  /**
   * Personal Member IDentifier. Unique id in all ACCOR's information system
   * @type {string}
   * @memberof GetACDCResponse
   */
  pmId?: string
  /**
   * loyalty card number
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyNum?: string
  /**
   * tars type of the loyalty card
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyType?: string
  /**
   * loyalty card endDate
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyDate?: string
  /**
   * civility of the customer
   * @type {string}
   * @memberof GetACDCResponse
   */
  codeCiv?: string
  /**
   * lastName of the customer
   * @type {string}
   * @memberof GetACDCResponse
   */
  lastName?: string
  /**
   * firstname of the customer
   * @type {string}
   * @memberof GetACDCResponse
   */
  firstName?: string
  /**
   * language of the customer
   * @type {string}
   * @memberof GetACDCResponse
   */
  langCtc?: string
  /**
   * is first time in the hotel
   * @type {string}
   * @memberof GetACDCResponse
   */
  isFirstTimer?: string
  /**
   * booking eligible to earn points
   * @type {string}
   * @memberof GetACDCResponse
   */
  eligibleStay?: string
  /**
   * nb earn point for the booking
   * @type {string}
   * @memberof GetACDCResponse
   */
  earnNbPoints?: string
  /**
   * expiration date of the points
   * @type {string}
   * @memberof GetACDCResponse
   */
  datePoints?: string
  /**
   * nb status point of the customer loyalty account
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyStatusPoints?: string
  /**
   * nb night needed for the next tier
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyNextStatusNbNights?: string
  /**
   * nb reward point of the customer loyalty account
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyNbPoints?: string
  /**
   * status of the customer loyalty account
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyStatus?: string
  /**
   * date of the full enrolment loyalty
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyFullEnrolmentDate?: string
  /**
   * expiration date of the pre-enrolment
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyPreEnrollExpirationDate?: string
  /**
   * is GDPR
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyEnrolledBeforeGDPRCompliancy?: string
  /**
   * is reminder email sent
   * @type {string}
   * @memberof GetACDCResponse
   */
  loyaltyEnrollCompletionReminderEmailSent?: string
  /**
   * is meetingPlanner
   * @type {string}
   * @memberof GetACDCResponse
   */
  isMeetingPlanner?: string
  /**
   * customer preference
   * @type {string}
   * @memberof GetACDCResponse
   */
  hasPreferences?: string
  /**
   * date of the last stay of the customer
   * @type {string}
   * @memberof GetACDCResponse
   */
  dateLastStay?: string
  /**
   * LastStaySatMark
   * @type {string}
   * @memberof GetACDCResponse
   */
  lastStaySatMark?: string
  /**
   * date of LastStaySatMark
   * @type {string}
   * @memberof GetACDCResponse
   */
  dateLastStaySatMark?: string
  /**
   * LastStaySatMarkInMyHotel
   * @type {string}
   * @memberof GetACDCResponse
   */
  lastStaySatMarkInMyHotel?: string
  /**
   * date of LastStaySatMarkInMyHotel
   * @type {string}
   * @memberof GetACDCResponse
   */
  dateLastStaySatMarkInMyHotel?: string
  /**
   * GlobalSatMark
   * @type {string}
   * @memberof GetACDCResponse
   */
  globalSatMark?: string
  /**
   * isRelevant
   * @type {string}
   * @memberof GetACDCResponse
   */
  relevanceInd?: string
  /**
   * primary email of the customer
   * @type {string}
   * @memberof GetACDCResponse
   */
  profilEmail?: string
  /**
   * date of the last stay in the hotel
   * @type {string}
   * @memberof GetACDCResponse
   */
  dateLastStayHotel?: string
  /**
   * nb stay in the hotel
   * @type {string}
   * @memberof GetACDCResponse
   */
  nbStayHotel?: string
  /**
   * nb stay in the same brand of the hotel
   * @type {string}
   * @memberof GetACDCResponse
   */
  nbStayMark?: string
  /**
   * label of the civility in asked language
   * @type {string}
   * @memberof GetACDCResponse
   */
  labelCiv?: string
  /**
   * HasFavoritePreferences
   * @type {string}
   * @memberof GetACDCResponse
   */
  hasFavoritePreferences?: string
  /**
   * reward points of the loyalty account
   * @type {string}
   * @memberof GetACDCResponse
   */
  rewardPoints?: string
  /**
   * logo of the loyalty card
   * @type {string}
   * @memberof GetACDCResponse
   */
  logo?: string
  /**
   *
   * @type {GetACDCResponseChildren}
   * @memberof GetACDCResponse
   */
  children?: GetACDCResponseChildren
  /**
   * list of subscription cards not expired
   * @type {Array<GetACDCResponseListOfCards>}
   * @memberof GetACDCResponse
   */
  listOfCards?: Array<GetACDCResponseListOfCards>
  /**
   * list of TDTS
   * @type {Array<GetACDCResponseListOfTDTS>}
   * @memberof GetACDCResponse
   */
  listOfTDTS?: Array<GetACDCResponseListOfTDTS>
}
/**
 * children of the customer
 * @export
 * @interface GetACDCResponseChildren
 */
export interface GetACDCResponseChildren {
  /**
   * list of child
   * @type {Array<GetACDCResponseChildrenChild>}
   * @memberof GetACDCResponseChildren
   */
  child?: Array<GetACDCResponseChildrenChild>
}
/**
 *
 * @export
 * @interface GetACDCResponseChildrenChild
 */
export interface GetACDCResponseChildrenChild {
  /**
   * id of the child
   * @type {string}
   * @memberof GetACDCResponseChildrenChild
   */
  id?: string
  /**
   * birthdate of the child
   * @type {string}
   * @memberof GetACDCResponseChildrenChild
   */
  birthdate?: string
}
/**
 *
 * @export
 * @interface GetACDCResponseListOfCards
 */
export interface GetACDCResponseListOfCards {
  /**
   * subscription card number
   * @type {string}
   * @memberof GetACDCResponseListOfCards
   */
  otherCardNum?: string
  /**
   * subscription card tars type
   * @type {string}
   * @memberof GetACDCResponseListOfCards
   */
  otherCardType?: string
  /**
   * subscription card end date
   * @type {string}
   * @memberof GetACDCResponseListOfCards
   */
  otherCardDate?: string
}
/**
 *
 * @export
 * @interface GetACDCResponseListOfTDTS
 */
export interface GetACDCResponseListOfTDTS {
  /**
   * label of the TDTS
   * @type {string}
   * @memberof GetACDCResponseListOfTDTS
   */
  todotosayText1?: string
  /**
   * tooltip of the TDTS
   * @type {string}
   * @memberof GetACDCResponseListOfTDTS
   */
  todotosayText2?: string
  /**
   * rank of the TDTS
   * @type {string}
   * @memberof GetACDCResponseListOfTDTS
   */
  todotosayRank?: string
}
/**
 *
 * @export
 * @interface GetContactOrdersResponse
 */
export interface GetContactOrdersResponse {
  /**
   *
   * @type {LoyaltySavingsDatasResponse}
   * @memberof GetContactOrdersResponse
   */
  loyaltySavings?: LoyaltySavingsDatasResponse
  /**
   * returns all orders for the given contact. An order can contain multiple bookings.
   * @type {Array<Order>}
   * @memberof GetContactOrdersResponse
   */
  orders?: Array<Order>
}
/**
 * GetGEXResponse
 * @export
 * @interface GetGEXResponse
 */
export interface GetGEXResponse {
  /**
   * Personal Member IDentifier. Unique id in all ACCOR's information system
   * @type {string}
   * @memberof GetGEXResponse
   */
  GEXPMID?: string
  /**
   *
   * @type {ListOfGEX}
   * @memberof GetGEXResponse
   */
  listOfGEX?: ListOfGEX
}
/**
 * true if has order else false
 * @export
 * @interface GetHasOrderResponse
 */
export interface GetHasOrderResponse {
  /**
   *
   * @type {string}
   * @memberof GetHasOrderResponse
   */
  pmid?: string
  /**
   *
   * @type {boolean}
   * @memberof GetHasOrderResponse
   */
  hasOrder?: boolean
}
/**
 * return getInfoClient response for the given contact
 * @export
 * @interface GetInfoClientRequest
 */
export interface GetInfoClientRequest {
  /**
   * id of the calling application
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  applicationId?: string
  /**
   * id of the client calling application
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  applicationIdCustomerService?: string
  /**
   * id of the hotel
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  hotelCode?: string
  /**
   * LastName of teh customer
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  lastName?: string
  /**
   * Name of the customer
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  name?: string
  /**
   * family code
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  familyCode?: string
  /**
   * user login
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  userLogin?: string
  /**
   * language
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  language?: string
  /**
   * city
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  city?: string
  /**
   * country
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  country?: string
  /**
   * BookingId
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  bookingId?: string
  /**
   * Amount
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  amount?: string
  /**
   * Currency
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  currency?: string
  /**
   * loyalty card number of the customer
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  loyaltyNumber?: string
  /**
   * email of the customer
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  email?: string
  /**
   * HomCode
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  homCode?: string
  /**
   * DateIn of the booking
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  dateIn?: string
  /**
   * DateOut of the booking
   * @type {string}
   * @memberof GetInfoClientRequest
   */
  dateOut?: string
}
/**
 * return getInfoClient response for the given contact
 * @export
 * @interface GetInfoClientResponse
 */
export interface GetInfoClientResponse {
  /**
   *
   * @type {GetInfoClientResponseRoot}
   * @memberof GetInfoClientResponse
   */
  root?: GetInfoClientResponseRoot
}
/**
 * root element of getInfoClient
 * @export
 * @interface GetInfoClientResponseRoot
 */
export interface GetInfoClientResponseRoot {
  /**
   *
   * @type {GetInfoClientResponseRootReplyClientInfo}
   * @memberof GetInfoClientResponseRoot
   */
  replyClientInfo?: GetInfoClientResponseRootReplyClientInfo
}
/**
 * return customer, bookling and legal information for the given contact
 * @export
 * @interface GetInfoClientResponseRootReplyClientInfo
 */
export interface GetInfoClientResponseRootReplyClientInfo {
  /**
   *
   * @type {GetInfoClientResponseRootReplyClientInfoClient}
   * @memberof GetInfoClientResponseRootReplyClientInfo
   */
  client?: GetInfoClientResponseRootReplyClientInfoClient
  /**
   *
   * @type {GetInfoClientResponseRootReplyClientInfoIndividualLegalIdentifications}
   * @memberof GetInfoClientResponseRootReplyClientInfo
   */
  individualLegalIdentifications?: GetInfoClientResponseRootReplyClientInfoIndividualLegalIdentifications
  /**
   *
   * @type {Reservation}
   * @memberof GetInfoClientResponseRootReplyClientInfo
   */
  reservation?: Reservation
}
/**
 * return customer information
 * @export
 * @interface GetInfoClientResponseRootReplyClientInfoClient
 */
export interface GetInfoClientResponseRootReplyClientInfoClient {
  /**
   * id of the contact
   * @type {string}
   * @memberof GetInfoClientResponseRootReplyClientInfoClient
   */
  contactID?: string
  /**
   * Personal Member IDentifier. Unique id in all ACCOR's information system
   * @type {string}
   * @memberof GetInfoClientResponseRootReplyClientInfoClient
   */
  pmId?: string
  /**
   * Loyalty T&C acceptance date
   * @type {string}
   * @memberof GetInfoClientResponseRootReplyClientInfoClient
   */
  loyaltyTermsAndConditionsAcceptanceDate?: string
  /**
   *
   * @type {GetPreferenceDataResponse}
   * @memberof GetInfoClientResponseRootReplyClientInfoClient
   */
  getPreferenceDataResponse?: GetPreferenceDataResponse
  /**
   *
   * @type {GetACDCResponse}
   * @memberof GetInfoClientResponseRootReplyClientInfoClient
   */
  getACDCResponse?: GetACDCResponse
  /**
   *
   * @type {GetGEXResponse}
   * @memberof GetInfoClientResponseRootReplyClientInfoClient
   */
  getGEXResponse?: GetGEXResponse
  /**
   *
   * @type {GetPartnerCardResponse}
   * @memberof GetInfoClientResponseRootReplyClientInfoClient
   */
  getPartnerCardResponse?: GetPartnerCardResponse
}
/**
 * legal identifications of the customer
 * @export
 * @interface GetInfoClientResponseRootReplyClientInfoIndividualLegalIdentifications
 */
export interface GetInfoClientResponseRootReplyClientInfoIndividualLegalIdentifications {
  /**
   *
   * @type {IndividualLegalIdentification}
   * @memberof GetInfoClientResponseRootReplyClientInfoIndividualLegalIdentifications
   */
  individualLegalIdentification?: IndividualLegalIdentification
}
/**
 *
 * @export
 * @interface GetOrderSearch
 */
export interface GetOrderSearch {
  /**
   * id of the hotel
   * @type {string}
   * @memberof GetOrderSearch
   */
  hotelCode?: string
  /**
   * the bookingNumber of the searched booking. Can be either the initial number or the current one. (only for HOTEL_BOOKING type)
   * @type {string}
   * @memberof GetOrderSearch
   */
  bookingNumber?: string
  /**
   * either the externalConfiguration number or externalId in orderItem.hotelBooking?.reservation?.externalConnectivity
   * @type {string}
   * @memberof GetOrderSearch
   */
  externalConfigurationNumber?: string
}
/**
 * partner cards of the customer
 * @export
 * @interface GetPartnerCardResponse
 */
export interface GetPartnerCardResponse {
  /**
   * not mapped
   * @type {string}
   * @memberof GetPartnerCardResponse
   */
  mapCards?: string
}
/**
 * preference of the customer
 * @export
 * @interface GetPreferenceDataResponse
 */
export interface GetPreferenceDataResponse {
  /**
   *
   * @type {ListOfPreferenceFamily}
   * @memberof GetPreferenceDataResponse
   */
  listOfPreferenceFamily?: ListOfPreferenceFamily
}
/**
 * gps coordinates
 * @export
 * @interface Gps
 */
export interface Gps {
  /**
   * longitude
   * @type {string}
   * @memberof Gps
   */
  lng?: string
  /**
   * latitude
   * @type {string}
   * @memberof Gps
   */
  lat?: string
}
/**
 * This type represents the dynamodb row in the database for 'has_order' table. It's declared here for generating TypeScript code, or Avro Schema
 * @export
 * @interface HasOrderDynamodb
 */
export interface HasOrderDynamodb {
  /**
   * Hash key
   * @type {string}
   * @memberof HasOrderDynamodb
   */
  pmid: string
  /**
   * true if the pmid has a least 1 order
   * @type {boolean}
   * @memberof HasOrderDynamodb
   */
  hasOrder: boolean
}
/**
 * filled using WC-REF /catalog/v1/hotels/{hotelCode}. The id is always valued, everything else can be null because sometimes the hotel is unknown from ACCOR
 * @export
 * @interface Hotel
 */
export interface Hotel {
  /**
   * the hotel's code. Is always valued, cannot be null. !Every other fields in the hotel node can be null!
   * @type {string}
   * @memberof Hotel
   */
  id?: string
  /**
   * the hotel's name
   * @type {string}
   * @memberof Hotel
   */
  name?: string
  /**
   * label filled using WC-REF /referentials/v1/brands
   * @type {CodeLabel}
   * @memberof Hotel
   */
  brand?: CodeLabel
  /**
   * label filled using WC-REF /referentials/v1/brands
   * @type {CodeLabel}
   * @memberof Hotel
   */
  chain?: CodeLabel
  /**
   * the hotel's description / translated using language query param (en by default)
   * @type {string}
   * @memberof Hotel
   */
  description?: string
  /**
   * the hotel's enhanced description  / translated using language query param (en by default)
   * @type {string}
   * @memberof Hotel
   */
  enhancedDescription?: string
  /**
   * the hotel's destination description  / translated using language query param (en by default)
   * @type {string}
   * @memberof Hotel
   */
  destinationDescription?: string
  /**
   *
   * @type {HotelSeo}
   * @memberof Hotel
   */
  seo?: HotelSeo
  /**
   * the hotel's status
   * @type {string}
   * @memberof Hotel
   */
  status?: string
  /**
   * the hotel's advantages (array of strings) / translated using language query param (en by default)
   * @type {Array<string>}
   * @memberof Hotel
   */
  advantages?: Array<string>
  /**
   * the manager's message / translated using language query param (en by default)
   * @type {string}
   * @memberof Hotel
   */
  managerMessage?: string
  /**
   * the flash info / translated using language query param (en by default)
   * @type {string}
   * @memberof Hotel
   */
  flashInfo?: string
  /**
   * label filled using WC-REF /referentials/v1/lodgings
   * @type {CodeLabel}
   * @memberof Hotel
   */
  lodging?: CodeLabel
  /**
   * label filled using WC-REF /referentials/v1/hotel-scales
   * @type {CodeLabel}
   * @memberof Hotel
   */
  scale?: CodeLabel
  /**
   *
   * @type {HotelCurrency}
   * @memberof Hotel
   */
  currency?: HotelCurrency
  /**
   *
   * @type {HotelRoomOccupancy}
   * @memberof Hotel
   */
  roomOccupancy?: HotelRoomOccupancy
  /**
   * the hotel's staff spoken languages
   * @type {Array<string>}
   * @memberof Hotel
   */
  spokenLanguages?: Array<string>
  /**
   *
   * @type {HotelCheckin}
   * @memberof Hotel
   */
  checkin?: HotelCheckin
  /**
   *
   * @type {HotelLoyaltyProgram}
   * @memberof Hotel
   */
  loyaltyProgram?: HotelLoyaltyProgram
  /**
   * the hotel's labels, filled using WC-REF /referentials/v1/hotel-labels
   * @type {Array<CodeLabel>}
   * @memberof Hotel
   */
  labels?: Array<CodeLabel>
  /**
   *
   * @type {HotelAmenity}
   * @memberof Hotel
   */
  amenity?: HotelAmenity
  /**
   *
   * @type {HotelMedia}
   * @memberof Hotel
   */
  media?: HotelMedia
  /**
   *
   * @type {Contact}
   * @memberof Hotel
   */
  contact?: Contact
  /**
   *
   * @type {HotelLocalization}
   * @memberof Hotel
   */
  localization?: HotelLocalization
  /**
   * Fact sheet url / translated using language query param (en by default)
   * @type {string}
   * @memberof Hotel
   */
  factsheetUrl?: string
  /**
   *
   * @type {HotelRating}
   * @memberof Hotel
   */
  rating?: HotelRating
  /**
   * check-in hour
   * @type {string}
   * @memberof Hotel
   */
  checkInHour?: string
  /**
   * check-out hour
   * @type {string}
   * @memberof Hotel
   */
  checkOutHour?: string
  /**
   *
   * @type {HotelInsurance}
   * @memberof Hotel
   */
  insurance?: HotelInsurance
  /**
   * Indicates, in minutes, the diff between the hotel timeZone and UTC timeZone, First get the hotel timeZone from Paris :from local..hotel.decalage where codehotel = hotelBooking.hotel.id Then calculate the hotel time zone UTC beware summer time/winter time
   * @type {string}
   * @memberof Hotel
   */
  hotelTimeZoneUTC?: string
}
/**
 * the hotel's amenities
 * @export
 * @interface HotelAmenity
 */
export interface HotelAmenity {
  /**
   * Hotel's free amenities
   * @type {Array<HotelAmenity>}
   * @memberof HotelAmenity
   */
  free?: Array<HotelAmenity>
  /**
   * Hotel's paying amenities
   * @type {Array<HotelAmenity>}
   * @memberof HotelAmenity
   */
  paying?: Array<HotelAmenity>
}
/**
 * only present if the aminity is a 'top' service
 * @export
 * @interface HotelAmenityTop
 */
export interface HotelAmenityTop {
  /**
   * code
   * @type {string}
   * @memberof HotelAmenityTop
   */
  code?: string
  /**
   * label / translated using language query param (en by default). Filled using WC-REF /referentials/v2/amenities
   * @type {string}
   * @memberof HotelAmenityTop
   */
  label?: string
  /**
   * order of the top service
   * @type {number}
   * @memberof HotelAmenityTop
   */
  order?: number
}
/**
 *
 * @export
 * @interface HotelBooking
 */
export interface HotelBooking {
  /**
   *
   * @type {HotelBookingAggregate}
   * @memberof HotelBooking
   */
  aggregates?: HotelBookingAggregate
  /**
   * order's id. aka Folder number for bookings. can be null for Stays without reservations (walk-in, direct call to hotel...).
   * @type {string}
   * @memberof HotelBooking
   */
  folderNumber?: string
  /**
   * booking id in it’s latest version, also known as numResa_fin, bookingNumber. Is always valued, cannot be null
   * @type {string}
   * @memberof HotelBooking
   */
  latestVersionId?: string
  /**
   *
   * @type {Hotel}
   * @memberof HotelBooking
   */
  hotel?: Hotel
  /**
   * ACTIVE_INITIAL = A, ACTIVE_MODIFIED = M, OBSOLETE = O, CANCELLED = D
   * @type {string}
   * @memberof HotelBooking
   */
  status?: string
  /**
   * Public comments transmitted to the Hotel and displayed in customer's confirmation communications.
   * @type {string}
   * @memberof HotelBooking
   */
  publicComment?: string
  /**
   * Internal use comments transmitted to the Hotel but not shown to customer's. Can be null
   * @type {string}
   * @memberof HotelBooking
   */
  internalUseComment?: string
  /**
   * flag which indicates that the booking has been forced (whatever price forced, availability forced or other), model:Resa.forcee
   * @type {boolean}
   * @memberof HotelBooking
   */
  forced?: boolean
  /**
   * indicate the reason of forcing the booking, model:Resa.txtforcee
   * @type {string}
   * @memberof HotelBooking
   */
  reasonForForcing?: string
  /**
   * Date de la prise d'option, Note : s'il est aujourd'hui spécifique aux réservations groupes LOL, le workflow de prise de commande pourrait être extrapolé à n'importe quel type d'élément de commande, raison pour laquelle ce champ n'a pas été mis dans les informations spécifiques aux réservations groupes. Physique : ResaGsi.DateOption
   * @type {string}
   * @memberof HotelBooking
   */
  optionDate?: string
  /**
   * an array of external Ids. Can be null
   * @type {Array<HotelBookingExternalUniqueIds>}
   * @memberof HotelBooking
   */
  externalUniqueIds?: Array<HotelBookingExternalUniqueIds>
  /**
   *
   * @type {HotelBookingOrigins}
   * @memberof HotelBooking
   */
  origin?: HotelBookingOrigins
  /**
   *
   * @type {HotelBookingCancellationInfo}
   * @memberof HotelBooking
   */
  cancellationInfo?: HotelBookingCancellationInfo
  /**
   *
   * @type {HotelBookingLoyaltyVoucher}
   * @memberof HotelBooking
   */
  loyaltyVoucher?: HotelBookingLoyaltyVoucher
  /**
   *
   * @type {Array<HotelBookingAward>}
   * @memberof HotelBooking
   */
  awards?: Array<HotelBookingAward>
  /**
   *
   * @type {HotelBookingGuaranty}
   * @memberof HotelBooking
   */
  guaranty?: HotelBookingGuaranty
  /**
   *
   * @type {HotelBookingReservation}
   * @memberof HotelBooking
   */
  reservation: HotelBookingReservation
  /**
   * list of party roles. Always valued, cannot be null
   * @type {Array<PartyRole>}
   * @memberof HotelBooking
   */
  partyRoles?: Array<PartyRole>
  /**
   *
   * @type {HotelBookingSalesConditions}
   * @memberof HotelBooking
   */
  salesConditions?: HotelBookingSalesConditions
  /**
   *
   * @type {HotelBookingLoyaltySimulationPoints}
   * @memberof HotelBooking
   */
  loyaltySimulationPoints?: HotelBookingLoyaltySimulationPoints
  /**
   *
   * @type {HotelBookingSoftBenefits}
   * @memberof HotelBooking
   */
  softBenefits?: HotelBookingSoftBenefits
  /**
   *
   * @type {Tdts}
   * @memberof HotelBooking
   */
  tdts?: Tdts
  /**
   * list of digital gift
   * @type {Array<DigitalGift>}
   * @memberof HotelBooking
   */
  digitalGifts?: Array<DigitalGift>
  /**
   * list of stays (from LUKE) that have been associated with this orderItem.
   * @type {Array<StayItem>}
   * @memberof HotelBooking
   */
  stayDetails?: Array<StayItem>
  /**
   * list of payment transactions for this orderItem.
   * @type {Array<HotelBookingPaymentTransaction>}
   * @memberof HotelBooking
   */
  paymentTransactions?: Array<HotelBookingPaymentTransaction>
}
/**
 * all the aggregated or calculated info on the reservation, according to all its order-items.hotelBooking.reservation, paiement - prix - TVA - prépaiment
 * @export
 * @interface HotelBookingAggregate
 */
export interface HotelBookingAggregate {
  /**
   *
   * @type {HotelBookingAggregateTotalHotelBookingPrice}
   * @memberof HotelBookingAggregate
   */
  totalHotelBookingPrice?: HotelBookingAggregateTotalHotelBookingPrice
}
/**
 * aggregated and calculated payment data, todo after calculating all price and fees by rate
 * @export
 * @interface HotelBookingAggregateTotalHotelBookingPrice
 */
export interface HotelBookingAggregateTotalHotelBookingPrice {
  /**
   * the currency code of the order, hotelBooking.reservation.amounts.netPriceIncludingTaxes.currencyCode
   * @type {string}
   * @memberof HotelBookingAggregateTotalHotelBookingPrice
   */
  currencyCode?: string
  /**
   * taxAndFees of the orderItem reservation,if netPriceIncludingTaxes exists and >0 then if tarsPriceAndVat exists and >0 then diff between the netPriceIncludingTaxes and tarsPriceAndVat of orderItem else diff between the netPriceIncludingTaxes and tarsPrice else vide, = if netPriceIncludingTaxes exists and >0 {if tarsPriceAndVat exists and >0 {hotelBooking.reservation.amounts.netPriceIncludingTaxes.value - hotelBooking.reservation.amounts.tarsPriceAndVat.value} else {hotelBooking.reservation.amounts.netPriceIncludingTaxes.value - hotelBooking.reservation.amounts.tarsPrice.value}} else vide
   * @type {number}
   * @memberof HotelBookingAggregateTotalHotelBookingPrice
   */
  taxAndFees?: number
  /**
   * fee of the orderItem reservation, sum of all fee of orderItem, = sum(hotelBooking.reservation.roomStays[0].rateDetails[*].totalFees.fee)
   * @type {number}
   * @memberof HotelBookingAggregateTotalHotelBookingPrice
   */
  fees?: number
  /**
   * array of feeType, list of all feeType of the orderItem reservation
   * @type {Array<string>}
   * @memberof HotelBookingAggregateTotalHotelBookingPrice
   */
  feeTypes?: Array<string>
  /**
   * remainingPayment of the orderItem reservation to be paid at the hotel , remainingPayment = hotelBooking.reservation.amounts.netPriceIncludingTaxes.value - hotelBooking.reservation.amounts.prepaidAmount.value - sum(hotelBooking.awards[*].amount.value) - hotelBooking.loyaltyVoucher.tarsAmount.value
   * @type {number}
   * @memberof HotelBookingAggregateTotalHotelBookingPrice
   */
  remainingPayment?: number
  /**
   * remainingPayment of the orderItem reservation after , evoucherAmountAfterBurn = hotelBooking.reservation.amounts.netPriceIncludingTaxes.value - hotelBooking.loyaltyVoucher.tarsAmount.value
   * @type {number}
   * @memberof HotelBookingAggregateTotalHotelBookingPrice
   */
  evoucherAmountAfterBurn?: number
  /**
   * remainingPayment of the orderItem reservation to be paid at the hotel , remainingPayment = hotelBooking.reservation.amounts.netPriceExcludingTaxes.value - sum(hotelBooking.awards[*].amount.value) - hotelBooking.loyaltyVoucher.tarsAmount.value, needed for simulation point
   * @type {number}
   * @memberof HotelBookingAggregateTotalHotelBookingPrice
   */
  priceExcludingTaxesWithoutAwards?: number
}
/**
 * contain the different amounts for the booking
 * @export
 * @interface HotelBookingAmounts
 */
export interface HotelBookingAmounts {
  /**
   * Prix HT net (non unitaire, tenant donc compte de la quantité de produit)
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  netPriceExcludingTaxes?: CurrencyValue
  /**
   * Prix HT brut (non unitaire, tenant donc compte de la quantité de produit)
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  grossPriceExcludingTaxes?: CurrencyValue
  /**
   * Prix TARS
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  tarsPrice?: CurrencyValue
  /**
   * Prix TARS TVA incluse. Correspond à resamontants avec type_montant à TARTVA. Note : ceux qui ne sont pas renseigné sont en général arrivés par connectivité externe
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  tarsPriceAndVat?: CurrencyValue
  /**
   * Prix TTC net de rémunération. Correspond à resamontants avec type_montant à TTC
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  netPriceIncludingTaxes?: CurrencyValue
  /**
   * Prix TTC brut de rémunération. Correspond à resamontants avec type_montant à TTCBRU
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  grossPriceIncludingTaxes?: CurrencyValue
  /**
   * Montant prépayé Correspond à resamontants avec type_montant à PREPAY
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  prepaidAmount?: CurrencyValue
  /**
   * Montant prépayable (non unitaire, tenant donc compte de la quantité de produit). Correspondance MPD : correspond à resaprodmontantjour avec type_montant à PREPAB
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  prepayableAmount?: CurrencyValue
  /**
   * amount to be prepaid when semi-flex. will be paid at orderItem[].hotelBooking.guaranty.guarantyMedium.paymentDate date
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  ccSurcharge?: CurrencyValue
  /**
   * Montant des charges. Correspond à resamontants avec type_montant à FEES
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  feesAmount?: CurrencyValue
  /**
   * Chiffre d'affaire attaché à la résa exprimé dans la devise de l'hôtel au moment de la prise de réservation. Correspondance MPD : Resa.catotal. Note : peut être à null en base pour des raisons inconnues. La devise n’est pas fournie en soit, néanmoins on peut considérer qu’il s’agit de la devise de l’hôtel (local..hotel.codedevise avec codehotel=resa.codehotel). A noter que si l’hôtel change de devise en cours de vie, l’information de la devise ne sera pas correcte.
   * @type {CurrencyValue}
   * @memberof HotelBookingAmounts
   */
  totalSalesRevenue?: CurrencyValue
}
/**
 * information about the awards used during booking. Can be null
 * @export
 * @interface HotelBookingAward
 */
export interface HotelBookingAward {
  /**
   * when the award will be consumed (YYYY-MM-DD)
   * @type {string}
   * @memberof HotelBookingAward
   */
  useDate?: string
  /**
   * award id (or number)
   * @type {string}
   * @memberof HotelBookingAward
   */
  id?: string
  /**
   *
   * @type {CurrencyValue}
   * @memberof HotelBookingAward
   */
  amount?: CurrencyValue
  /**
   * amount type of the award
   * @type {string}
   * @memberof HotelBookingAward
   */
  amountType?: string
}
/**
 * object containing information on the cancellation. Can be null
 * @export
 * @interface HotelBookingCancellationInfo
 */
export interface HotelBookingCancellationInfo {
  /**
   *
   * @type {HotelBookingOrigin}
   * @memberof HotelBookingCancellationInfo
   */
  origin?: HotelBookingOrigin
  /**
   * in basicsweb (tars referrential) - local..TYPEREFUS.CODEREFUS
   * @type {number}
   * @memberof HotelBookingCancellationInfo
   */
  category?: number
  /**
   * in basicsweb (tars referrential) - local..TYPEREFUS.TYPEREFUS
   * @type {string}
   * @memberof HotelBookingCancellationInfo
   */
  type?: string
  /**
   * need to retrieve labels from basicsweb (tars referrential) - local..TYPEREFUS.NOMREFUS WHERE category = local..TYPEREFUS.CODEREFUS AND type = local..TYPEREFUS.TYPEREFUS
   * @type {string}
   * @memberof HotelBookingCancellationInfo
   */
  typeLabel?: string
  /**
   * cancellation reason
   * @type {string}
   * @memberof HotelBookingCancellationInfo
   */
  reason?: string
  /**
   * cancellation number
   * @type {string}
   * @memberof HotelBookingCancellationInfo
   */
  cancellationNumber?: string
  /**
   * system or operator that cancelled the booking
   * @type {string}
   * @memberof HotelBookingCancellationInfo
   */
  userInfo?: string
  /**
   * date and time the cancellation occured
   * @type {string}
   * @memberof HotelBookingCancellationInfo
   */
  datetime?: string
  /**
   * information on the interlocutor that operated the cancellation
   * @type {string}
   * @memberof HotelBookingCancellationInfo
   */
  contact?: string
}
/**
 *
 * @export
 * @interface HotelBookingExternalUniqueIds
 */
export interface HotelBookingExternalUniqueIds {
  /**
   * the system where the original order came from. Applies when the source system (example TARS), was himself fed by another source system (example ORS)
   * @type {string}
   * @memberof HotelBookingExternalUniqueIds
   */
  application?: string
  /**
   * the order's id in the source \"application\"
   * @type {string}
   * @memberof HotelBookingExternalUniqueIds
   */
  id?: string
}
/**
 * Guaranty information for this boooking. Can be null
 * @export
 * @interface HotelBookingGuaranty
 */
export interface HotelBookingGuaranty {
  /**
   * indicates the code of the guaranty. ref TARS local..garantie.CODEGARANTIE for guaranties that or not credit/debit cards, WC-REF /referentials/v1/payment-means for credit/debit cards
   * @type {string}
   * @memberof HotelBookingGuaranty
   */
  code?: string
  /**
   * indicates the label of the guaranty (local..garantie.NOMGARANTIE or /referentials/v1/payment-means)
   * @type {string}
   * @memberof HotelBookingGuaranty
   */
  label?: string
  /**
   * indicates the family code of the payment mean if relevant (/referentials/v1/payment-means)
   * @type {string}
   * @memberof HotelBookingGuaranty
   */
  familyCode?: string
  /**
   * indicates the family label of the payment mean if relevant (/referentials/v1/payment-means)
   * @type {string}
   * @memberof HotelBookingGuaranty
   */
  familyLabel?: string
  /**
   *
   * @type {HotelBookingGuarantyDeferredInfo}
   * @memberof HotelBookingGuaranty
   */
  deferredInfo?: HotelBookingGuarantyDeferredInfo
  /**
   *
   * @type {HotelBookingGuarantyGuarantyMedium}
   * @memberof HotelBookingGuaranty
   */
  guarantyMedium?: HotelBookingGuarantyGuarantyMedium
}
/**
 * contains information about a deferred guaranty or payment
 * @export
 * @interface HotelBookingGuarantyDeferredInfo
 */
export interface HotelBookingGuarantyDeferredInfo {
  /**
   * confirmation deadline YYYY-MM-DDTHH:MM:SSZ (UTC)
   * @type {string}
   * @memberof HotelBookingGuarantyDeferredInfo
   */
  confirmationDeadline?: string
  /**
   * email for deferred payment
   * @type {string}
   * @memberof HotelBookingGuarantyDeferredInfo
   */
  email?: string
  /**
   * message language code
   * @type {CodeLabel}
   * @memberof HotelBookingGuarantyDeferredInfo
   */
  messageLanguage?: CodeLabel
  /**
   * Payer name
   * @type {string}
   * @memberof HotelBookingGuarantyDeferredInfo
   */
  payerName?: string
}
/**
 * describes the medium by which the guaranty is given
 * @export
 * @interface HotelBookingGuarantyGuarantyMedium
 */
export interface HotelBookingGuarantyGuarantyMedium {
  /**
   * DEPOSIT - CREDIT_CARD - SPECIFIC
   * @type {string}
   * @memberof HotelBookingGuarantyGuarantyMedium
   */
  type?: string
  /**
   * for DEPOSIT ONLY. can be V (Virement/Transfer) or C (Cheque)
   * @type {string}
   * @memberof HotelBookingGuarantyGuarantyMedium
   */
  mode?: string
  /**
   * for DEPOSIT ONLY. the name of the person that will make the deposit.
   * @type {string}
   * @memberof HotelBookingGuarantyGuarantyMedium
   */
  depositorName?: string
  /**
   * for CREDIT_CARD only. expiration date format MMDD
   * @type {string}
   * @memberof HotelBookingGuarantyGuarantyMedium
   */
  expirationDate?: string
  /**
   * for CREDIT_CARD only. obfuscated credit card number
   * @type {string}
   * @memberof HotelBookingGuarantyGuarantyMedium
   */
  cardNumber?: string
  /**
   * for CREDIT_CARD only. card holder's name
   * @type {string}
   * @memberof HotelBookingGuarantyGuarantyMedium
   */
  cardHolderName?: string
  /**
   * for CREDIT_CARD only. only when SEMI_FLEX rate. Represents when the customer will be debited. format YYYY-MM-DD
   * @type {string}
   * @memberof HotelBookingGuarantyGuarantyMedium
   */
  paymentDate?: string
  /**
   * for SPECIFIC only. some guaranties necessitate additional information which will be in this free text
   * @type {string}
   * @memberof HotelBookingGuarantyGuarantyMedium
   */
  description?: string
}
/**
 * Loyalty points simulation on the order item. Beware it is just a simulation. The points will be credited after checkout
 * @export
 * @interface HotelBookingLoyaltySimulationPoints
 */
export interface HotelBookingLoyaltySimulationPoints {
  /**
   * Card Number of the customer
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPoints
   */
  cardNumber?: string
  /**
   * Sum of points of all operations in the simulation
   * @type {number}
   * @memberof HotelBookingLoyaltySimulationPoints
   */
  totalRewardsPoints?: number
  /**
   * Sum of earn_hotel points
   * @type {number}
   * @memberof HotelBookingLoyaltySimulationPoints
   */
  totalStatusPoints?: number
  /**
   * list of operations
   * @type {Array<HotelBookingLoyaltySimulationPointsCampaignOperation>}
   * @memberof HotelBookingLoyaltySimulationPoints
   */
  campaignOperation?: Array<HotelBookingLoyaltySimulationPointsCampaignOperation>
}
/**
 *
 * @export
 * @interface HotelBookingLoyaltySimulationPointsCampaignOperation
 */
export interface HotelBookingLoyaltySimulationPointsCampaignOperation {
  /**
   * code campaign of the operation
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperation
   */
  campaignCode?: string
  /**
   * Name of the animation triggered by LUKE
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperation
   */
  animationName?: string
  /**
   * nb points of the operation
   * @type {number}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperation
   */
  points?: number
  /**
   * Name of the ryule triggered by LUKE
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperation
   */
  ruleName?: string
  /**
   * new tier of the Card if upgraded or downgraded
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperation
   */
  targetCardType?: string
  /**
   * bonus type
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperation
   */
  bonusType?: string
  /**
   * subscription required
   * @type {boolean}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperation
   */
  subscriptionRequired?: boolean
  /**
   * list of subOperations
   * @type {Array<HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations>}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperation
   */
  subOperations?: Array<HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations>
}
/**
 *
 * @export
 * @interface HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations
 */
export interface HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations {
  /**
   * Name of the animation triggered by LUKE
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations
   */
  animationName?: string
  /**
   * Name of the ryule triggered by LUKE
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations
   */
  ruleName?: string
  /**
   * new tier of the Card if upgraded or downgraded
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations
   */
  targetCardType?: string
  /**
   * bonus type
   * @type {string}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations
   */
  bonusType?: string
  /**
   * subscription required
   * @type {boolean}
   * @memberof HotelBookingLoyaltySimulationPointsCampaignOperationSubOperations
   */
  subscriptionRequired?: boolean
}
/**
 * information about the loyalty voucher, aka booking with points. Can be null
 * @export
 * @interface HotelBookingLoyaltyVoucher
 */
export interface HotelBookingLoyaltyVoucher {
  /**
   * voucher number
   * @type {string}
   * @memberof HotelBookingLoyaltyVoucher
   */
  voucherNumber?: string
  /**
   * voucher number
   * @type {string}
   * @memberof HotelBookingLoyaltyVoucher
   */
  voucherSecurityNumber?: string
  /**
   * number of points
   * @type {number}
   * @memberof HotelBookingLoyaltyVoucher
   */
  pointNumber?: number
  /**
   * Value of points in the order's currency
   * @type {CurrencyValue}
   * @memberof HotelBookingLoyaltyVoucher
   */
  tarsAmount?: CurrencyValue
  /**
   * Value of points in the referrence currency (should be EUR, no other values since 2023-01-01)
   * @type {CurrencyValue}
   * @memberof HotelBookingLoyaltyVoucher
   */
  emissionAmount?: CurrencyValue
  /**
   * is the voucher valid
   * @type {boolean}
   * @memberof HotelBookingLoyaltyVoucher
   */
  valid?: boolean
}
/**
 *
 * @export
 * @interface HotelBookingOrigin
 */
export interface HotelBookingOrigin {
  /**
   * Is always valued, cannot be null. When the booking was retrieved from TARS, will contain 'TARS'. Also, in this case, the hotelBooking.folderNumber will be valued. If it does not contain TARS, then it is a Stay without a booking (walk-in, direct call to hotel...). In this case, the hotelBooking.folderNumber will be null. If the order-item is a mix between Stay info (retrieved from the PMS) and TARS, it will contain both sources concatenated like 'TARS - bf-imagefinale' for example
   * @type {string}
   * @memberof HotelBookingOrigin
   */
  type?: string
  /**
   * For TARS orders only. Cro that initiated the booking. Will also be valued for stays retrieved from a PMS that also has this CRO/SUBCRO classification. ref basicsweb : local..CRO.CODECRORAT. Will 'mostly' be valued but can be null
   * @type {string}
   * @memberof HotelBookingOrigin
   */
  cro?: string
  /**
   * For TARS orders only. Cro that initiated the booking. Will also be valued for stays retrieved from a PMS that also has this CRO/SUBCRO classification. ref basicsweb : local..CRO.CODECRO. Will 'mostly' be valued but can be null
   * @type {string}
   * @memberof HotelBookingOrigin
   */
  subCro?: string
  /**
   * description of the combinaison cro / subcro. ref basicsweb : local..CRO.NOMCRO
   * @type {string}
   * @memberof HotelBookingOrigin
   */
  description?: string
  /**
   * name of the flagCro. ref : local..CRO.FLAGCRO and then local..CROFLAG.FLAGNAME using CRO.FLAGCRO == CROFLAG.FLAGCODE
   * @type {string}
   * @memberof HotelBookingOrigin
   */
  channelName?: string
  /**
   * name of the flagCro. ref : local..CRO.FLAGCRO
   * @type {string}
   * @memberof HotelBookingOrigin
   */
  channelCode?: string
  /**
   *
   * @type {HotelBookingOriginChannelDetails}
   * @memberof HotelBookingOrigin
   */
  channelDetails?: HotelBookingOriginChannelDetails
  /**
   * flag the booking as stay when reconciliation is done. true for Staybookings and solo stays
   * @type {boolean}
   * @memberof HotelBookingOrigin
   */
  isStay?: boolean
}
/**
 * Entité contenant les informations de l’application (au sens application mobile) utilisée pour réaliser la commande..
 * @export
 * @interface HotelBookingOriginApplication
 */
export interface HotelBookingOriginApplication {
  /**
   * Physique : ResAppli.IDAPP - seems to be always 1...
   * @type {number}
   * @memberof HotelBookingOriginApplication
   */
  applicationId?: number
  /**
   * Physique : ResAppli.NAME
   * @type {string}
   * @memberof HotelBookingOriginApplication
   */
  name?: string
  /**
   * Physique : ResAppli.VERSION
   * @type {string}
   * @memberof HotelBookingOriginApplication
   */
  version?: string
  /**
   * Physique : ResAppli.CANAL - WEB/APP...
   * @type {string}
   * @memberof HotelBookingOriginApplication
   */
  channel?: string
  /**
   * Physique : ResAppli.USERAGENT
   * @type {string}
   * @memberof HotelBookingOriginApplication
   */
  userAgent?: string
  /**
   * Physique : ResAppli.BRAND - ALL/ACCOR
   * @type {string}
   * @memberof HotelBookingOriginApplication
   */
  brand?: string
  /**
   * Physique : ResAppli.ACTIVENOTIFICATIONS
   * @type {boolean}
   * @memberof HotelBookingOriginApplication
   */
  pushActive?: boolean
  /**
   * Physique : ResAppli.PUSHID - seems to be always null
   * @type {string}
   * @memberof HotelBookingOriginApplication
   */
  pushId?: string
  /**
   * Physique : ResAppli.LASTCONNECTIONDATE
   * @type {string}
   * @memberof HotelBookingOriginApplication
   */
  lastConnectionDate?: string
}
/**
 * Entité permettant de stocker des informations de contexte métier demandées par la BI à des fins d'exploitation ultérieure.
 * @export
 * @interface HotelBookingOriginBusiness
 */
export interface HotelBookingOriginBusiness {
  /**
   * Indique que le tariff WDR était disponible au moment de la prise de commande. Physique : stocké dans resainfo BI/WDR_AVAILABLE (note : si pas trouvé est à false)
   * @type {boolean}
   * @memberof HotelBookingOriginBusiness
   */
  wdrAvailable?: boolean
  /**
   * Indique que le wallet a été utilisé dans le cadre de la prise de commande. Physique : stocké dans resainfo WALLET_USED (0 ou 1) ==> à noter qu'aujourd'hui la notion est stockée dans resainfo avec un sous-type = statut au moment de la modification => ceci est inutile d'un point de vue BI => pour un code hotel / num résa donné, s'il existe une valeur à 1 dans resainfo alors on renvoie true, sinon on renvoie false
   * @type {boolean}
   * @memberof HotelBookingOriginBusiness
   */
  walletUsed?: boolean
  /**
   * Indique que l’élément de commande était éligible à la garantie paiement différé (à noter : même si la garantie paiement différée n'est pas choisie, ce flag pourrait être à Vrai) A noter que, lors du paiement différé effectif, ce flag est passé à Faux. Physique : ResaDeferred.FLAGSDEFERRED
   * @type {boolean}
   * @memberof HotelBookingOriginBusiness
   */
  eligibleDeferredPaymentOrGuaranty?: boolean
}
/**
 * another channel classification, directly link to CRO / SUBCRO
 * @export
 * @interface HotelBookingOriginChannelDetails
 */
export interface HotelBookingOriginChannelDetails {
  /**
   * Referrential in : BASICSweb (local..REP_CANAL.CODE and local..REP_CANAL.LIBELLE using CRO.CODECANAL == REP_CANAL.CODE)
   * @type {CodeLabel}
   * @memberof HotelBookingOriginChannelDetails
   */
  channel?: CodeLabel
  /**
   * Referrential in : BASICSweb (local..REP_FAMILLE.CODE and local..REP_FAMILLE.LIBELLE using REP_CANAL.CODEFAMILLE == REP_FAMILLE.CODE )
   * @type {CodeLabel}
   * @memberof HotelBookingOriginChannelDetails
   */
  family?: CodeLabel
}
/**
 * Entité contenant les informations de l’appareil (portable etc...) ayant permis la réalisation de la commande (spécificité AH/Mobile).
 * @export
 * @interface HotelBookingOriginDevice
 */
export interface HotelBookingOriginDevice {
  /**
   * Physique : ResaDevice.BRAND
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  brand?: string
  /**
   * Physique : ResaDevice.MODEL
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  model?: string
  /**
   * Physique : ResaDevice.DEVICEID
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  deviceId?: string
  /**
   * Physique : ResaDevice.MARKETINGMODEL
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  marketingModel?: string
  /**
   * Physique : ResaDevice.TYPE - smartphone/tablet...
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  type?: string
  /**
   * Physique : ResaDevice.OSDEVICE
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  os?: string
  /**
   * Physique : ResaDevice.OSVERSION
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  osVersion?: string
  /**
   * Physique : ResaDevice.LASTCONNECTIONDATE
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  lastConnectionDate?: string
  /**
   * does not exist... yet
   * @type {string}
   * @memberof HotelBookingOriginDevice
   */
  fingerprint?: string
}
/**
 * Informations liées au site (par exemple un métamoteur ou un agrégateur de type kayak) ayant aiguillé le client vers le site AH
 * @export
 * @interface HotelBookingOriginReferer
 */
export interface HotelBookingOriginReferer {
  /**
   * Physique : ResaSource.SourceID
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  sourceId?: string
  /**
   * Physique : ResaSource.MerchantID
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  merchantId?: string
  /**
   * Physique : ResaSource.Referer
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  httpReferer?: string
  /**
   * Physique : ResaSource.IPAddress
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  ipAddress?: string
  /**
   * Physique : ResaSource.SessionSourceId
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  sessionSourceId?: string
  /**
   * Physique : ResaSource.SessionMerchantId
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  sessionMerchantId?: string
  /**
   * Physique : ResaSource.codeTypeFichier
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  fileTypeCode?: string
  /**
   * Physique : ResaSource.numIdent
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  numIdent?: string
  /**
   * Physique : ResaSource.marchePOS
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  posMarket?: string
  /**
   * Physique : ResaSource.codePaysPOS
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  posCountryCode?: string
  /**
   * Physique : ResaSource.codeLanguePOS
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  posLanguageCode?: string
  /**
   * Physique : ResaSource.jsessionid
   * @type {string}
   * @memberof HotelBookingOriginReferer
   */
  jsessionid?: string
}
/**
 * information about the origin of the booking or the stay. Is always valued, cannot be null
 * @export
 * @interface HotelBookingOrigins
 */
export interface HotelBookingOrigins {
  /**
   *
   * @type {HotelBookingOrigin}
   * @memberof HotelBookingOrigins
   */
  first?: HotelBookingOrigin
  /**
   *
   * @type {HotelBookingOrigin}
   * @memberof HotelBookingOrigins
   */
  latestVersion?: HotelBookingOrigin
  /**
   * code of the user that created the order item version (VIDEOT for AH, OTA-xxx for GDS xxx, Hxxxx for a hotel user, RW for resaweb...). Is always valued, cannot be null
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  creationUserInfo?: string
  /**
   * from local..UTILISATEUR.NickName where CODEUSER = hotelBooking.origin.creationUserInfo if not null or empty else local..UTILISATEUR.PRENOMUSER where CODEUSER = hotelBooking.origin.creationUserInfo
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  creationUserName?: string
  /**
   * code of the user that modify the order item version (VIDEOT for AH, OTA-xxx for GDS xxx, Hxxxx for a hotel user, RW for resaweb...).
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  lastModificationUserInfo?: string
  /**
   * from local..UTILISATEUR.NickName where CODEUSER = hotelBooking.origin.lastModificationUserInfo if not null or empty else local..UTILISATEUR.PRENOMUSER where CODEUSER = hotelBooking.origin.lastModificationUserInfo
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  lastModificationUserName?: string
  /**
   * time and date the order item version was created in the source system. Is always valued, cannot be null
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  creationDate?: string
  /**
   * initial time and date the order item version was created in the source system.
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  initialCreationDate?: string
  /**
   * Date à laquelle la modification a été réalisée sur la version courante de l'élément de commande : - Si la modification est une annulation : date de l'annulation - Si la modification est une modification : date à laquelle la version a été rendue obsolète par la nouvelle version, Correspondance MPD : resa.datemodifresa
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  lastModificationDate?: string
  /**
   * the context of the booking creation (walk-in, phone, fax...), model:Resa.modresa
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  processingMode?: string
  /**
   * from local_uni..seg_dis.libdis where CODEDIS = hotelBooking.origin.processingMode
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  processingModeLabel?: string
  /**
   * from local..modresa.nommodresa where codemodresa = hotelBooking.origin.processingMode and codelangue = 'GB' if null or empty then from local_uni..seg_dis.libdis where CODEDIS = hotelBooking.origin.processingMode
   * @type {string}
   * @memberof HotelBookingOrigins
   */
  modeName?: string
  /**
   *
   * @type {HotelBookingOriginReferer}
   * @memberof HotelBookingOrigins
   */
  referer?: HotelBookingOriginReferer
  /**
   *
   * @type {HotelBookingOriginDevice}
   * @memberof HotelBookingOrigins
   */
  device?: HotelBookingOriginDevice
  /**
   *
   * @type {HotelBookingOriginApplication}
   * @memberof HotelBookingOrigins
   */
  application?: HotelBookingOriginApplication
  /**
   *
   * @type {HotelBookingOriginBusiness}
   * @memberof HotelBookingOrigins
   */
  businessContext?: HotelBookingOriginBusiness
}
/**
 * object containing information on apsTransaction. Can be null
 * @export
 * @interface HotelBookingPaymentTransaction
 */
export interface HotelBookingPaymentTransaction {
  /**
   * name of the payment provider
   * @type {string}
   * @memberof HotelBookingPaymentTransaction
   */
  provider?: string
  /**
   * payment id
   * @type {string}
   * @memberof HotelBookingPaymentTransaction
   */
  paymentId?: string
  /**
   * operation type (PA, NO_ALIAS, ALIAS, DR, PP)
   * @type {string}
   * @memberof HotelBookingPaymentTransaction
   */
  operation?: string
  /**
   *
   * @type {HotelBookingPaymentTransactionTransaction}
   * @memberof HotelBookingPaymentTransaction
   */
  transaction?: HotelBookingPaymentTransactionTransaction
}
/**
 * APS transaction details, retrieve the data by calling aps transaction endpoint via apigee https://api.accor.com/payment/v1/transaction?traceId={{$guid}}&transactionId={{apsId}}{{operation}}&partnerCode=WCC
 * @export
 * @interface HotelBookingPaymentTransactionTransaction
 */
export interface HotelBookingPaymentTransactionTransaction {
  /**
   * APS transaction response code, 0= OK, 60, 47= PENDING, >=100 technical error, < 30  request error, other KO
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  responseCode?: string
  /**
   * APS transaction response message
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  responseMessage?: string
  /**
   * payId
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  payId?: string
  /**
   * transactionId concat of apsId and operation
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  transactionId?: string
  /**
   * amount of the transaction
   * @type {CurrencyValue}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  amount?: CurrencyValue
  /**
   * attempt number of the payment
   * @type {number}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  attemptNumber?: number
  /**
   * pspCode
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  pspCode?: string
  /**
   * cardType
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  cardType?: string
  /**
   * eci
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  eci?: string
  /**
   * maskedPAN
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  maskedPAN?: string
  /**
   * pspMerchantId
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  pspMerchantId?: string
  /**
   * subCardType
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  subCardType?: string
  /**
   * transactionMode
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  transactionMode?: string
  /**
   * APS transaction Result
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  transactionResult?: string
  /**
   * APS transaction status
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  transactionStatus?: string
  /**
   * APS transaction date
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  checkTransactionDate?: string
  /**
   * APS transaction functional status
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  functionalStatus?: string
  /**
   * APS transaction holder name
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  holderName?: string
  /**
   * pspAcceptanceCode
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  pspAcceptanceCode?: string
  /**
   * pspErrorCode
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  pspErrorCode?: string
  /**
   * pspErrorMessage
   * @type {string}
   * @memberof HotelBookingPaymentTransactionTransaction
   */
  pspErrorMessage?: string
}
/**
 *
 * @export
 * @interface HotelBookingRate
 */
export interface HotelBookingRate {
  /**
   * REF TARS LOCAL..TYPECODERESA.TYPECODERESERVATION
   * @type {string}
   * @memberof HotelBookingRate
   */
  typeCode?: string
  /**
   * REF TARS LOCAL..TYPECODERESA.NOMCODERESERVATION
   * @type {string}
   * @memberof HotelBookingRate
   */
  typeLabel?: string
  /**
   * REF TARS LOCAL..CONTRATACCOR.codecontrat
   * @type {string}
   * @memberof HotelBookingRate
   */
  code?: string
  /**
   * REF TARS LOCAL..CONTRATACCOR.libellecontrat
   * @type {string}
   * @memberof HotelBookingRate
   */
  label?: string
  /**
   * REF TARS LOCAL..CONTRATACCOR.DescMkt
   * @type {string}
   * @memberof HotelBookingRate
   */
  description?: string
  /**
   *
   * @type {HotelBookingRateClass}
   * @memberof HotelBookingRate
   */
  _class?: HotelBookingRateClass
  /**
   *
   * @type {HotelBookingRateFamily}
   * @memberof HotelBookingRate
   */
  family?: HotelBookingRateFamily
}
/**
 *
 * @export
 * @interface HotelBookingRateClass
 */
export interface HotelBookingRateClass {
  /**
   * REF TARS LOCAL..CONTRATACCOR.codeTKCLass (WHERE codecontrat =  $codecontrat)
   * @type {string}
   * @memberof HotelBookingRateClass
   */
  code?: string
  /**
   * REF TARS LOCAL..TKCLASS.libelleTKClass
   * @type {string}
   * @memberof HotelBookingRateClass
   */
  label?: string
}
/**
 *
 * @export
 * @interface HotelBookingRateFamily
 */
export interface HotelBookingRateFamily {
  /**
   * REF TARS LOCAL..TKCLASS.codeTKFamily (WHERE codeTKCLass =  $codeTKCLass)
   * @type {string}
   * @memberof HotelBookingRateFamily
   */
  code?: string
  /**
   * REF TARS LOCAL..TKFAMILY
   * @type {string}
   * @memberof HotelBookingRateFamily
   */
  label?: string
}
/**
 * The price for this rate
 * @export
 * @interface HotelBookingRatePrice
 */
export interface HotelBookingRatePrice {
  /**
   * values to consider are NORMAL,INCLUDED,FREE,HIDDEN and ONREQUEST (equivalent to HIDDEN). No need to fetch from referrential but for information, these values are in LOCAL..STATUT_PRIX.NOMSTATUT
   * @type {string}
   * @memberof HotelBookingRatePrice
   */
  priceType?: string
  /**
   * only when the priceType is INCLUDED, values to consider are INCLUDED_IN_RATE, ADD_TO_RATE_COMBINED and ADD_TO_RATE_SEPARATE
   * @type {string}
   * @memberof HotelBookingRatePrice
   */
  inclusionType?: string
  /**
   * Rate level de l'offre de reference, Correspondance MPD : ResaDiscountRef.codeTarif, Correspondance Ref BasicsWeb : LOCAL..TARIF.CODETARIF and LOCAL..TARIF.NOMTARIF
   * @type {CodeLabel}
   * @memberof HotelBookingRatePrice
   */
  rateLevel?: CodeLabel
  /**
   * unit type, REF BasicsWeb in LOCAL..UNITEPRIX_BIS.codeunite AND LOCAL..UNITEPRIX_BIS.nomunite
   * @type {CodeLabel}
   * @memberof HotelBookingRatePrice
   */
  unitType?: CodeLabel
  /**
   * Pourcentage de remise WDR resaprod.pourcentageremise
   * @type {number}
   * @memberof HotelBookingRatePrice
   */
  discountPercentage?: number
  /**
   *
   * @type {HotelBookingAmounts}
   * @memberof HotelBookingRatePrice
   */
  amounts?: HotelBookingAmounts
  /**
   *
   * @type {HotelBookingUnitaryAmounts}
   * @memberof HotelBookingRatePrice
   */
  unitaryAmounts?: HotelBookingUnitaryAmounts
  /**
   * will always be null. WCO has no plans of synchronizing this data for the moment. If you have the need for it, please let us know so we can add it to our backlog. will require referrential FASTCOMweb synchronization also...
   * @type {any}
   * @memberof HotelBookingRatePrice
   */
  remunerations?: any
  /**
   *
   * @type {Array<HotelBookingRatePriceTaxes>}
   * @memberof HotelBookingRatePrice
   */
  taxes?: Array<HotelBookingRatePriceTaxes>
}
/**
 * Informations liées aux taxes Physique : jointure entre resaprod et resaprodtax. Attention les taxes semblent être un objet qui modélise non seulement les taxes mais aussi d’autres éléments constitutifs du prix (charges etc…).
 * @export
 * @interface HotelBookingRatePriceTaxes
 */
export interface HotelBookingRatePriceTaxes {
  /**
   * Correspondance MPD : resaprodtax.codetaxe / REF BASICSWEB : LOCAL..TAXE.CODETAXE
   * @type {string}
   * @memberof HotelBookingRatePriceTaxes
   */
  code?: string
  /**
   * REF BASICSWEB : LOCAL..TAXE.NOMTAXE
   * @type {string}
   * @memberof HotelBookingRatePriceTaxes
   */
  label?: string
  /**
   * Correspondance MPD : resaprodtax.famillecode. REF BASICSWEB : LOCAL..familles_taxe.FAMILLECODE + LOCAL..familles_taxe.FAMILLENOM
   * @type {CodeLabel}
   * @memberof HotelBookingRatePriceTaxes
   */
  family?: CodeLabel
  /**
   * Correspondance MPD : ResaProdTax.STATUT. values to consider are AMOUNT and PERCENTAGE. Affected the value field (amount or percentage)
   * @type {string}
   * @memberof HotelBookingRatePriceTaxes
   */
  type?: string
  /**
   * Lien vers la table local..modetaxe qui permet de déterminer comment la taxe doit être calculée (par séjour, par chambre, par nuit, par personne ou une combinaison de ceux ci : par séjour et par personne, par chambre et par nuit etc...) Correspondance MPD : ResaProdTax.CODEMODETAXE. REF BASICSWEB : LOCAL..MODETAXE.CODEMODETAXE + LOCAL..MODETAXE.NOMMODETAXE
   * @type {CodeLabel}
   * @memberof HotelBookingRatePriceTaxes
   */
  computationMode?: CodeLabel
  /**
   * Correspondance MPD : ResaProdTax.STATUT. values to consider are AMOUNT and PERCENTAGE. Affected the value field (amount or percentage)
   * @type {number}
   * @memberof HotelBookingRatePriceTaxes
   */
  value?: number
  /**
   * Si true, le montant de la taxe est incluse au prix TARS Correspondance MPD : ResaProdTax.INCLUSE
   * @type {boolean}
   * @memberof HotelBookingRatePriceTaxes
   */
  included?: boolean
  /**
   * Le montant de cette taxe peut-il être inclu au montant prépayable ? Correspondance MPD : ResaProdTax.PREPAI
   * @type {boolean}
   * @memberof HotelBookingRatePriceTaxes
   */
  prepayable?: boolean
  /**
   * Le montant de cette taxe est-il remboursable ? Correspondance MPD : ResaProdTax.REMBOURSABLE
   * @type {boolean}
   * @memberof HotelBookingRatePriceTaxes
   */
  refundable?: boolean
  /**
   * Correspondance MPD : ResaProdTax.MONTANTTAXE/codedevise
   * @type {CurrencyValue}
   * @memberof HotelBookingRatePriceTaxes
   */
  effectiveAmount?: CurrencyValue
}
/**
 * information about the reservation. Is always valued for hotelBookings.
 * @export
 * @interface HotelBookingReservation
 */
export interface HotelBookingReservation {
  /**
   * INDIVIDUAL or GROUP. Can be null
   * @type {string}
   * @memberof HotelBookingReservation
   */
  type?: string
  /**
   * indicates the customer segment which is  calculated right after booking. REF/Meaning TBD (BasicsWeb). Can be null
   * @type {string}
   * @memberof HotelBookingReservation
   */
  codeSegment?: string
  /**
   * from local..hotel.FLAGREDESCENTEPMS where codehotel = hotelBooking.hotel.id
   * @type {number}
   * @memberof HotelBookingReservation
   */
  hotelPmsFlag?: number
  /**
   * from local..hotel.codepolitiquesegment where codehotel = hotelBooking.hotel.id
   * @type {string}
   * @memberof HotelBookingReservation
   */
  hotelSegmentCodePolicy?: string
  /**
   * from local_uni..seg_rev.librev where CODEREV = hotelBooking.reservation.codeSegment and CODELANGUE = GB
   * @type {string}
   * @memberof HotelBookingReservation
   */
  revLabel?: string
  /**
   * from local..SEGMENTCLIENT.NOMSEGMENT where CODESEGMENT = hotelBooking.reservation.codeSegment and CODELANGUE = GB if null or empty then from local_uni..seg_rev.librev where CODEREV = hotelBooking.reservation.codeSegment and CODELANGUE = GB
   * @type {string}
   * @memberof HotelBookingReservation
   */
  segGuestLabel?: string
  /**
   * dayUse flag. Can be null
   * @type {boolean}
   * @memberof HotelBookingReservation
   */
  dayUse?: boolean
  /**
   *
   * @type {HotelBookingReservationStayInfo}
   * @memberof HotelBookingReservation
   */
  stayInfo: HotelBookingReservationStayInfo
  /**
   *
   * @type {HotelBookingReservationWelcomeInfo}
   * @memberof HotelBookingReservation
   */
  welcomeInfo?: HotelBookingReservationWelcomeInfo
  /**
   * The vast majority of order-items contain only 1 room (other room = other order-item). However there are exception when the booking is a family offer or a group booking (LOL). Can be null for stays. Always valued for TARS bookings
   * @type {Array<ReservationRoomStay>}
   * @memberof HotelBookingReservation
   */
  roomStays?: Array<ReservationRoomStay>
  /**
   * contains the aggregated amounts for the room and all the products for the order-item. Detailed amounts information are available in reservation.roomStays. Can be null
   * @type {HotelBookingAmounts}
   * @memberof HotelBookingReservation
   */
  amounts?: HotelBookingAmounts
  /**
   *
   * @type {HotelBookingReservationDiscount}
   * @memberof HotelBookingReservation
   */
  discount?: HotelBookingReservationDiscount
  /**
   * list of preferences for the order (or orderItem)
   * @type {Array<ReservationPreference>}
   * @memberof HotelBookingReservation
   */
  preferences?: Array<ReservationPreference>
  /**
   *
   * @type {ReservationExternalConnectivity}
   * @memberof HotelBookingReservation
   */
  externalConnectivity?: ReservationExternalConnectivity
  /**
   * suppressRate flag, indique si le prix négocié par les intermédiaire doit être affiché sur les front, si true prix non affiché
   * @type {boolean}
   * @memberof HotelBookingReservation
   */
  suppressRate?: boolean
}
/**
 * information on the discount offer if there is one. Can be null
 * @export
 * @interface HotelBookingReservationDiscount
 */
export interface HotelBookingReservationDiscount {
  /**
   *
   * @type {ReservationReferenceOffer}
   * @memberof HotelBookingReservationDiscount
   */
  referenceOffer?: ReservationReferenceOffer
  /**
   * Pourcentage de remise calculé pour l’offre choisie par rapport à l’offre de reference, Correspondance MPD : ResaDiscountRef.pourcentageremise
   * @type {number}
   * @memberof HotelBookingReservationDiscount
   */
  discountPercentage?: number
}
/**
 *
 * @export
 * @interface HotelBookingReservationStayInfo
 */
export interface HotelBookingReservationStayInfo {
  /**
   * arrival time format HH:MM. Can be null
   * @type {string}
   * @memberof HotelBookingReservationStayInfo
   */
  arrivalTime?: string
  /**
   * is the arrival considered late (after 7pm). Can be null
   * @type {boolean}
   * @memberof HotelBookingReservationStayInfo
   */
  lateArrival?: boolean
  /**
   * arrival date format YYYY-MM-DD. Is always valued, cannot be null
   * @type {string}
   * @memberof HotelBookingReservationStayInfo
   */
  arrivalDate: string
  /**
   * arrival date format YYYY-MM-DD. Is always valued, cannot be null
   * @type {string}
   * @memberof HotelBookingReservationStayInfo
   */
  departureDate: string
  /**
   * night count. Is always valued, cannot be null
   * @type {number}
   * @memberof HotelBookingReservationStayInfo
   */
  nightCount?: number
  /**
   * child count. Can be null
   * @type {number}
   * @memberof HotelBookingReservationStayInfo
   */
  childCount?: number
  /**
   * child count. Can be null
   * @type {number}
   * @memberof HotelBookingReservationStayInfo
   */
  adultCount?: number
  /**
   * is checked in. Can be null
   * @type {boolean}
   * @memberof HotelBookingReservationStayInfo
   */
  checkedIn?: boolean
  /**
   * is checked in. Can be null
   * @type {boolean}
   * @memberof HotelBookingReservationStayInfo
   */
  checkedOut?: boolean
  /**
   * indicates the flight number by which the customer arrives at the hotel. Can be null
   * @type {string}
   * @memberof HotelBookingReservationStayInfo
   */
  transportNumber?: string
  /**
   * type of transportation used to access the hotel. Ref LOCAL..ACCES.CODETYPEACCES. Can be null
   * @type {string}
   * @memberof HotelBookingReservationStayInfo
   */
  transportCode?: string
  /**
   * type of transportation used to access the hotel. Ref LOCAL..ACCES.NOMTYPEACCES. Can be null
   * @type {string}
   * @memberof HotelBookingReservationStayInfo
   */
  transportLabel?: string
  /**
   * BUSINESS or PERSONAL. Can be null
   * @type {string}
   * @memberof HotelBookingReservationStayInfo
   */
  purposeOfStay?: string
}
/**
 * information about the online check-in feature. Can be null
 * @export
 * @interface HotelBookingReservationWelcomeInfo
 */
export interface HotelBookingReservationWelcomeInfo {
  /**
   * status for online checking.<br/>TO_BE_CHECKED - potentially eligible but could not be verified during booking for connectivity reasons<br/>YES - eligible to online check-in / check-in not done yet<br/>DONE - check-in is done<br/>KO - Booking was eligible to online check-in but not anymore - guaranty might have been refused or an ulterior booking update has rendered the online check-in impossible<br/>NO - Booking is not eligible to online chek-in<br/>
   * @type {string}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  checkinStatus?: string
  /**
   * date the online checkin was done - YYYY-MM-DDTHH:MM:SSZ (UTC)
   * @type {string}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  checkinDate?: string
  /**
   * when a booking is eligible to online check-in, the customer can ask to receive a welcome SMS upon arrival
   * @type {boolean}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  sms?: boolean
  /**
   * date the online checkin opens - YYYY-MM-DDTHH:MM:SSZ (UTC)
   * @type {string}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  dateMin?: string
  /**
   * date the online checkin closes
   * @type {string}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  dateMax?: string
  /**
   * YES - Booking is eligible to a pre-authorization<br/>NO - Booking is not eligible to a pre-authorization<br/>OK_CLIENT - checkin is done and customer filled the pre-authorization info<br/>TO_CANCEL - Booking was canceled after ab OK_CLIENT. signals the Hotel to cancel the pre-authorization
   * @type {string}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  preAuthorizationStatus?: string
  /**
   * date the pre-authorization was given - YYYY-MM-DDTHH:MM:SSZ (UTC)
   * @type {string}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  preAuthorizationDate?: string
  /**
   *
   * @type {CurrencyValue}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  preAuthorizationAmount?: CurrencyValue
  /**
   *
   * @type {string}
   * @memberof HotelBookingReservationWelcomeInfo
   */
  welcomeUrl?: string
}
/**
 *
 * @export
 * @interface HotelBookingSaleCondition
 */
export interface HotelBookingSaleCondition {
  /**
   * code. ref BasicsWeb : LOCAL..CONDITIONVENTE.CodeCDV
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  code?: string
  /**
   * name of the salesCondition. ref BasicsWeb : LOCAL..CONDITIONVENTE.NomCDV
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  codeLabel?: string
  /**
   * start of the segment
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  begin?: string
  /**
   * end of the segment
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  end?: string
  /**
   * language code
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  languageCode?: string
  /**
   * Tars key type (RA or ASA)
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  tarsKeyTypeCode?: string
  /**
   * Tars key code
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  tarsKeyCode?: string
  /**
   * product code
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  productCode?: string
  /**
   * text of the sale condition
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  label?: string
  /**
   * level of priority for display
   * @type {string}
   * @memberof HotelBookingSaleCondition
   */
  publicationLevel?: string
  /**
   * used in CANPOL only. Indicates if the booking is cancellable or not. Please note if the CANPOL salesCondition does not exist, it means there is no policy and front-ends should process it as cancellable by default unless proven otherwise by this field.
   * @type {boolean}
   * @memberof HotelBookingSaleCondition
   */
  isCancellable?: boolean
  /**
   * used in MODPOL only. Indicates if the booking is modifiable or not. Please note if the MODPOL salesCondition does not exist, it means there is no policy and front-ends should process it as modifiable by default unless proven otherwise by this field.
   * @type {boolean}
   * @memberof HotelBookingSaleCondition
   */
  isModifiable?: boolean
  /**
   * CANPOL and MODPOL salesCondition can both have penalties applied for cancelling/modifying the booking, depending on when the action occurs. if one or more penalties are present, it means cancellation/modification is not free
   * @type {Array<HotelBookingSaleConditionPenalty>}
   * @memberof HotelBookingSaleCondition
   */
  penalty?: Array<HotelBookingSaleConditionPenalty>
}
/**
 * the begin and end dates when the penalty applies
 * @export
 * @interface HotelBookingSaleConditionEffectiveDates
 */
export interface HotelBookingSaleConditionEffectiveDates {
  /**
   * date from which the penalty applies
   * @type {string}
   * @memberof HotelBookingSaleConditionEffectiveDates
   */
  begin?: string
  /**
   * date from which the penalty does not apply anymore
   * @type {string}
   * @memberof HotelBookingSaleConditionEffectiveDates
   */
  end?: string
}
/**
 * a penalty for CANPOL or MODPOL
 * @export
 * @interface HotelBookingSaleConditionPenalty
 */
export interface HotelBookingSaleConditionPenalty {
  /**
   * will the penaly apply right now, if the customer cancels or modifies his booking ?
   * @type {boolean}
   * @memberof HotelBookingSaleConditionPenalty
   */
  isApplicable?: boolean
  /**
   * the type of penalty. Penalties can be expressed in N (Nights), % (Percentage of the bookings'global amount) or M (Amount)
   * @type {CodeLabel}
   * @memberof HotelBookingSaleConditionPenalty
   */
  type?: CodeLabel
  /**
   * amount of the penalty (expressed in N,% or M)
   * @type {string}
   * @memberof HotelBookingSaleConditionPenalty
   */
  amount?: string
  /**
   * currency of the penalty, usefull when type M
   * @type {string}
   * @memberof HotelBookingSaleConditionPenalty
   */
  currency?: string
  /**
   *
   * @type {HotelBookingSaleConditionEffectiveDates}
   * @memberof HotelBookingSaleConditionPenalty
   */
  effectiveDates?: HotelBookingSaleConditionEffectiveDates
}
/**
 * Object containing the sales conditions. can be null
 * @export
 * @interface HotelBookingSalesConditions
 */
export interface HotelBookingSalesConditions {
  /**
   * contains descriptions in relevant languages for the booking of all the sales conditions applied to the booking
   * @type {Array<HotelBookingSaleCondition>}
   * @memberof HotelBookingSalesConditions
   */
  summary?: Array<HotelBookingSaleCondition>
}
/**
 *
 * @export
 * @interface HotelBookingSoftBenefit
 */
export interface HotelBookingSoftBenefit {
  /**
   * code of the soft benefit
   * @type {string}
   * @memberof HotelBookingSoftBenefit
   */
  code?: string
  /**
   * type of the soft benefit
   * @type {string}
   * @memberof HotelBookingSoftBenefit
   */
  type?: string
  /**
   * label of the soft benefit
   * @type {string}
   * @memberof HotelBookingSoftBenefit
   */
  label?: string
  /**
   * rank of the soft benefit
   * @type {number}
   * @memberof HotelBookingSoftBenefit
   */
  rank?: number
}
/**
 * the soft benefits the guest can expect upon arrival
 * @export
 * @interface HotelBookingSoftBenefits
 */
export interface HotelBookingSoftBenefits {
  /**
   * a macro label to describe all softBenefits (unclear)
   * @type {string}
   * @memberof HotelBookingSoftBenefits
   */
  label?: string
  /**
   *
   * @type {Array<HotelBookingSoftBenefit>}
   * @memberof HotelBookingSoftBenefits
   */
  softBenefit?: Array<HotelBookingSoftBenefit>
}
/**
 * contain the different amounts for the booking
 * @export
 * @interface HotelBookingUnitaryAmounts
 */
export interface HotelBookingUnitaryAmounts {
  /**
   * Prix TARS théorique (avant application WDR ou modification via tarif modif). Pour un produit attaché il s’agit du prix unitaire. Pour une chambre il s’agit du prix incluant les produits attachés inclus ce jour-là. Correspondance MPD : resaprod.oldprix
   * @type {CurrencyValue}
   * @memberof HotelBookingUnitaryAmounts
   */
  unitaryTheoricPrice?: CurrencyValue
  /**
   * Prix TARS réel (après application WDR ou modification via tarif modif). Pour un produit attaché il s’agit du prix unitaire. Pour une chambre il s’agit du prix incluant les produits attachés inclus ce jour-là. A noter enfin que, dans le cas d’une réservation venant d’un partenaire de connectivité externe (OTA/GDS), ce prix pourra pour certains partenaires être en fait le prix théorique. Correspondance MPD : resaprod.prixmodif
   * @type {CurrencyValue}
   * @memberof HotelBookingUnitaryAmounts
   */
  unitarySalePrice?: CurrencyValue
}
/**
 *
 * @export
 * @interface HotelCheckin
 */
export interface HotelCheckin {
  /**
   * is check-in available
   * @type {boolean}
   * @memberof HotelCheckin
   */
  available?: boolean
  /**
   * represents welcome programme level ['FULL','NONE','ACCESS'], LOCAL_UNI..HOT_WELCOME_PARAM.code_check_in where codehotel = hotelBooking.hotel.id
   * @type {string}
   * @memberof HotelCheckin
   */
  welcomeProgram?: string
  /**
   * Limit hour for online checkin, LOCAL_UNI..HOT_WELCOME_PARAM.online_checking where codehotel = hotelBooking.hotel.id
   * @type {string}
   * @memberof HotelCheckin
   */
  onlineCheckinLimitHour?: string
  /**
   * Flag represents the hotel membership to welcome multiRoom program, flag = true if(LOCAL..HOTPROGEXTERNE.codeprogext == 'WM' where codehotel = hotelBooking.hotel.id) else false
   * @type {boolean}
   * @memberof HotelCheckin
   */
  welcomeMultiRoomFlag?: boolean
}
/**
 * Hotel's currency, filled using WC-REF /referentials/v1/currencies
 * @export
 * @interface HotelCurrency
 */
export interface HotelCurrency {
  /**
   * Hotel's currency code
   * @type {string}
   * @memberof HotelCurrency
   */
  code?: string
  /**
   * Hotel's currency label
   * @type {string}
   * @memberof HotelCurrency
   */
  label?: string
  /**
   * Hotel's currency symbol
   * @type {string}
   * @memberof HotelCurrency
   */
  symbol?: string
  /**
   * Hotel's currency euro rate
   * @type {string}
   * @memberof HotelCurrency
   */
  euroRate?: string
}
/**
 * Hotel's insurance information
 * @export
 * @interface HotelInsurance
 */
export interface HotelInsurance {
  /**
   * insurance's name
   * @type {string}
   * @memberof HotelInsurance
   */
  name?: string
  /**
   *
   * @type {Contact}
   * @memberof HotelInsurance
   */
  contact?: Contact
  /**
   *
   * @type {HotelInsuranceLocalization}
   * @memberof HotelInsurance
   */
  localization?: HotelInsuranceLocalization
}
/**
 *
 * @export
 * @interface HotelInsuranceLocalization
 */
export interface HotelInsuranceLocalization {
  /**
   *
   * @type {Address}
   * @memberof HotelInsuranceLocalization
   */
  address?: Address
  /**
   *
   * @type {Gps}
   * @memberof HotelInsuranceLocalization
   */
  gps?: Gps
}
/**
 * Hotel's localization
 * @export
 * @interface HotelLocalization
 */
export interface HotelLocalization {
  /**
   *
   * @type {Address}
   * @memberof HotelLocalization
   */
  address?: Address
  /**
   * filled using WC-REF /referentials/v1/hotel-environments
   * @type {CodeLabel}
   * @memberof HotelLocalization
   */
  environment?: CodeLabel
  /**
   *
   * @type {Gps}
   * @memberof HotelLocalization
   */
  gps?: Gps
}
/**
 * Hotel's loyalty program features
 * @export
 * @interface HotelLoyaltyProgram
 */
export interface HotelLoyaltyProgram {
  /**
   * is advantage allowed
   * @type {boolean}
   * @memberof HotelLoyaltyProgram
   */
  advantageAllowed?: boolean
  /**
   * eligibility to burn points in ALL program
   * @type {boolean}
   * @memberof HotelLoyaltyProgram
   */
  burnAllowed?: boolean
  /**
   * eligibility to earn points in ALL program
   * @type {boolean}
   * @memberof HotelLoyaltyProgram
   */
  earnAllowed?: boolean
  /**
   * eligibility for Huazhu program point gain
   * @type {boolean}
   * @memberof HotelLoyaltyProgram
   */
  huazhuRewards?: boolean
  /**
   * Hotel's status of participation in the ALL program
   * @type {string}
   * @memberof HotelLoyaltyProgram
   */
  status?: string
  /**
   * is member rate allowed
   * @type {boolean}
   * @memberof HotelLoyaltyProgram
   */
  memberRate?: boolean
}
/**
 * a small selection of medias to display in customer's booking list. for more medias such as room images, consult /catalog/v1/hotels/{hotelCode}/medias
 * @export
 * @interface HotelMedia
 */
export interface HotelMedia {
  /**
   * medias size
   * @type {number}
   * @memberof HotelMedia
   */
  count?: number
  /**
   * Hotel's medias detail
   * @type {Array<{ [key: string]: string; }>}
   * @memberof HotelMedia
   */
  medias?: Array<{ [key: string]: string }>
}
/**
 * Hotel's ratings
 * @export
 * @interface HotelRating
 */
export interface HotelRating {
  /**
   *
   * @type {HotelRating}
   * @memberof HotelRating
   */
  star?: HotelRating
  /**
   *
   * @type {HotelRating}
   * @memberof HotelRating
   */
  tripadvisor?: HotelRating
}
/**
 * Hotel's room occupancy
 * @export
 * @interface HotelRoomOccupancy
 */
export interface HotelRoomOccupancy {
  /**
   * Hotel's maximum number of adults
   * @type {number}
   * @memberof HotelRoomOccupancy
   */
  maxAdult?: number
  /**
   * Hotel's maximum number of children
   * @type {number}
   * @memberof HotelRoomOccupancy
   */
  maxChild?: number
  /**
   * Hotel's age limit for beeing considered as a child
   * @type {number}
   * @memberof HotelRoomOccupancy
   */
  maxChildAge?: number
  /**
   * Hotel's maximum number guests per room (? TBC)
   * @type {number}
   * @memberof HotelRoomOccupancy
   */
  maxPax?: number
  /**
   * Hotel's number of available rooms (? TBC)
   * @type {number}
   * @memberof HotelRoomOccupancy
   */
  maxRoom?: number
}
/**
 * meta information (to fill html tags) for seo purposes
 * @export
 * @interface HotelSeo
 */
export interface HotelSeo {
  /**
   *
   * @type {string}
   * @memberof HotelSeo
   */
  metaDescription?: string
  /**
   *
   * @type {string}
   * @memberof HotelSeo
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof HotelSeo
   */
  description?: string
}
/**
 * legal identification of the customer
 * @export
 * @interface IndividualLegalIdentification
 */
export interface IndividualLegalIdentification {
  /**
   * id of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  id?: string
  /**
   * type of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  type?: string
  /**
   * number of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  number?: string
  /**
   * issuedDate of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  issuedDate?: string
  /**
   * issuingCountry of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  issuingCountry?: string
  /**
   * issuingPlace of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  issuingPlace?: string
  /**
   * validationDate of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  validationDate?: string
  /**
   * expirationDate of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  expirationDate?: string
  /**
   * nationalityCode of the legal identification
   * @type {string}
   * @memberof IndividualLegalIdentification
   */
  nationalityCode?: string
}
/**
 * list of GEX (hotel comment on the customer)
 * @export
 */
export type ListOfGEX = Array<ListOfGEXInner>
/**
 *
 * @export
 * @interface ListOfGEXInner
 */
export interface ListOfGEXInner {
  /**
   * hotel code of the GEX
   * @type {string}
   * @memberof ListOfGEXInner
   */
  hotelCode?: string
  /**
   * category of the GEX
   * @type {string}
   * @memberof ListOfGEXInner
   */
  category?: string
  /**
   * reason of the GEX
   * @type {string}
   * @memberof ListOfGEXInner
   */
  reason?: string
  /**
   * compensation of the GEX
   * @type {string}
   * @memberof ListOfGEXInner
   */
  compensation?: string
  /**
   * comment of the GEX
   * @type {string}
   * @memberof ListOfGEXInner
   */
  comment?: string
  /**
   * language of the GEX
   * @type {string}
   * @memberof ListOfGEXInner
   */
  language?: string
  /**
   * creation date of the GEX
   * @type {string}
   * @memberof ListOfGEXInner
   */
  createdDate?: string
}
/**
 * list of preference
 * @export
 */
export type ListOfPreference = Array<ListOfPreferenceInner>
/**
 * list of preference family
 * @export
 */
export type ListOfPreferenceFamily = Array<ListOfPreferenceFamilyInner>
/**
 *
 * @export
 * @interface ListOfPreferenceFamilyInner
 */
export interface ListOfPreferenceFamilyInner {
  /**
   * family code of the preference
   * @type {string}
   * @memberof ListOfPreferenceFamilyInner
   */
  familyCode?: string
  /**
   *
   * @type {ListOfPreference}
   * @memberof ListOfPreferenceFamilyInner
   */
  listOfPreference?: ListOfPreference
}
/**
 *
 * @export
 * @interface ListOfPreferenceInner
 */
export interface ListOfPreferenceInner {
  /**
   * name of the preference
   * @type {string}
   * @memberof ListOfPreferenceInner
   */
  prefName?: string
  /**
   * code of the preference
   * @type {string}
   * @memberof ListOfPreferenceInner
   */
  prefCode?: string
  /**
   * type of teh preference
   * @type {string}
   * @memberof ListOfPreferenceInner
   */
  prefType?: string
  /**
   * Mono or Multi preference
   * @type {string}
   * @memberof ListOfPreferenceInner
   */
  prefMonoMulti?: string
  /**
   *
   * @type {ListOfPreferenceValue}
   * @memberof ListOfPreferenceInner
   */
  listOfPreferenceValue?: ListOfPreferenceValue
}
/**
 * list of values of the preference
 * @export
 */
export type ListOfPreferenceValue = Array<ListOfPreferenceValueInner>
/**
 *
 * @export
 * @interface ListOfPreferenceValueInner
 */
export interface ListOfPreferenceValueInner {
  /**
   * name of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  valueName?: string
  /**
   * code of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  valueCode?: string
  /**
   * type of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  valueType?: string
  /**
   * segment of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  valueSegment?: string
  /**
   * nature of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  valueNature?: string
  /**
   * hotel code creation of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  createdByHotelCode?: string
  /**
   * favorite central
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  favoriteCentral?: string
  /**
   * integration id of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  valueIntegrationId?: string
  /**
   * comments of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  comments?: string
  /**
   * creation date of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  created?: string
  /**
   * uipdate date of the value preference
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  updated?: string
  /**
   * account which create the preference value
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  createdBy?: string
  /**
   * account which update the preference value
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  updatedBy?: string
  /**
   * favorite client
   * @type {string}
   * @memberof ListOfPreferenceValueInner
   */
  favoriteClient?: string
  /**
   * list of favorite local hotel code
   * @type {Array<any>}
   * @memberof ListOfPreferenceValueInner
   */
  listOfFavoriteLocal?: Array<any>
}
/**
 * all the aggregated or calculated loyalty information for the order.
 * @export
 * @interface LoyaltyInfo
 */
export interface LoyaltyInfo {
  /**
   *
   * @type {Simulation}
   * @memberof LoyaltyInfo
   */
  simulation?: Simulation
  /**
   *
   * @type {BookingWithPoints}
   * @memberof LoyaltyInfo
   */
  bookingWithPoints?: BookingWithPoints
  /**
   *
   * @type {Awards}
   * @memberof LoyaltyInfo
   */
  awards?: Awards
  /**
   * one of the order-items has a freenight in it. orderItems[*].hotelBooking.reservation.roomStays[*].rateDetails[*].freeNightNumber?true:false
   * @type {boolean}
   * @memberof LoyaltyInfo
   */
  hasFreenights?: boolean
  /**
   * if the hotel is not participating, there will be no EARN (this is not an aberrante). orderItems[*].hotelBooking.hotel.loyaltyProgram.status == 'PARTICIPATING_HOTEL' ? true:false
   * @type {boolean}
   * @memberof LoyaltyInfo
   */
  isHotelParticipating?: boolean
  /**
   *
   * @type {StayResults}
   * @memberof LoyaltyInfo
   */
  stayResults?: StayResults
}
/**
 * the operation that resulted from the rule, if there is one.
 * @export
 * @interface LoyaltyOperation
 */
export interface LoyaltyOperation {
  /**
   * the id of the operation. LUKEDB : OPERATION.OPERATION_ID
   * @type {number}
   * @memberof LoyaltyOperation
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof LoyaltyOperation
   */
  creationDate?: string
  /**
   * reward points that can only be used for burning. LUKEDB :OPERATION.POINTS
   * @type {number}
   * @memberof LoyaltyOperation
   */
  rewardPoints?: number
  /**
   * status points that can only be used for tiering up. LUKEDB :OPERATION.STATUS_POINTS
   * @type {number}
   * @memberof LoyaltyOperation
   */
  statusPoints?: number
  /**
   * number of nights that can only be used for tiering up. LUKEDB :OPERATION.NUMBER_OF_NIGHTS
   * @type {number}
   * @memberof LoyaltyOperation
   */
  nbNights?: number
  /**
   * indicates the operation has been cancelled, and the presence of a linkedOperation.
   * @type {boolean}
   * @memberof LoyaltyOperation
   */
  isCancelled?: boolean
  /**
   * labels filled using LUKEDB table ANIMATION (use OPERATION.ANIMATION_ID). code = ANIMATION.ANIMATION_CODE ; label = ANIMATION.NAME
   * @type {CodeLabel}
   * @memberof LoyaltyOperation
   */
  animation?: CodeLabel
  /**
   * labels filled using LUKEDB table CAMPAIGN (use ANIMATION.CAMPAIGN_ID). code = CAMPAIGN.CAMPAIGN_CODE ; label = CAMPAIGN.NAME
   * @type {CodeLabel}
   * @memberof LoyaltyOperation
   */
  campaign?: CodeLabel
}
/**
 * savings summary based on bookings with points, consumed freenights, number of used DIN, and number of SNU used
 * @export
 * @interface LoyaltyReviews
 */
export interface LoyaltyReviews {
  /**
   * points used for bookings
   * @type {number}
   * @memberof LoyaltyReviews
   */
  bookingWithPoints?: number
  /**
   * number of consumed freen nights
   * @type {number}
   * @memberof LoyaltyReviews
   */
  freeNights?: number
  /**
   * number of consumed DIN
   * @type {number}
   * @memberof LoyaltyReviews
   */
  DIN?: number
  /**
   * number of consumed SNU
   * @type {number}
   * @memberof LoyaltyReviews
   */
  SNU?: number
}
/**
 * savings summary based on memberRate, awards usage, and rewards usage in requested currency
 * @export
 * @interface LoyaltySavings
 */
export interface LoyaltySavings {
  /**
   * sum of savings made thanks to memberRate, awards and rewards
   * @type {number}
   * @memberof LoyaltySavings
   */
  totalAmount?: number
  /**
   * savings made thanks to memberRate
   * @type {number}
   * @memberof LoyaltySavings
   */
  memberRateAmount?: number
  /**
   *
   * @type {LoyaltySavingsAwardsUsageAmount}
   * @memberof LoyaltySavings
   */
  awardsUsageAmount?: LoyaltySavingsAwardsUsageAmount
  /**
   * savings made by using rewards
   * @type {number}
   * @memberof LoyaltySavings
   */
  rewardsUsageAmount?: number
  /**
   * savings made by ALL Plus Card
   * @type {number}
   * @memberof LoyaltySavings
   */
  allPlusAmount?: number
}
/**
 * savings made by using DIN and SNU
 * @export
 * @interface LoyaltySavingsAwardsUsageAmount
 */
export interface LoyaltySavingsAwardsUsageAmount {
  /**
   * savings made by using DIN
   * @type {number}
   * @memberof LoyaltySavingsAwardsUsageAmount
   */
  DINAmount?: number
  /**
   * savings made by using SNU
   * @type {number}
   * @memberof LoyaltySavingsAwardsUsageAmount
   */
  SNUAmount?: number
}
/**
 * savings summary of a specific year
 * @export
 * @interface LoyaltySavingsDatas
 */
export interface LoyaltySavingsDatas {
  /**
   * loyalty savings will be calcuated in this currency
   * @type {string}
   * @memberof LoyaltySavingsDatas
   */
  currencyCode?: string
  /**
   * year of the calculated savings
   * @type {number}
   * @memberof LoyaltySavingsDatas
   */
  year?: number
  /**
   *
   * @type {LoyaltySavings}
   * @memberof LoyaltySavingsDatas
   */
  loyaltySavings?: LoyaltySavings
  /**
   *
   * @type {LoyaltyReviews}
   * @memberof LoyaltySavingsDatas
   */
  loyaltyReviews?: LoyaltyReviews
}
/**
 * total loyalty savings and loyalty savings by year
 * @export
 * @interface LoyaltySavingsDatasResponse
 */
export interface LoyaltySavingsDatasResponse {
  /**
   * loyalty-savings grouped by year
   * @type {Array<LoyaltySavingsDatas>}
   * @memberof LoyaltySavingsDatasResponse
   */
  byYear?: Array<LoyaltySavingsDatas>
  /**
   *
   * @type {LoyaltySavings}
   * @memberof LoyaltySavingsDatasResponse
   */
  loyaltySavingsTotal?: LoyaltySavings
  /**
   *
   * @type {LoyaltyReviews}
   * @memberof LoyaltySavingsDatasResponse
   */
  loyaltyReviewsTotal?: LoyaltyReviews
}
/**
 * all the aggregated or calculated info on the order, according to all its order-items, paiement - prix - TVA - prépaiment
 * @export
 * @interface MetaInfo
 */
export interface MetaInfo {
  /**
   * for hotelBookings only, will indicate that the order contains several order-items in different hotels. Difficult to manage on front-end side. Is always valued, cannot be null
   * @type {boolean}
   * @memberof MetaInfo
   */
  isMultiHotelOrder?: boolean
  /**
   * nb adult in the order, totalAdult =  sum(orderItems[*].hotelBooking.reservation.stayInfo.adultCount)
   * @type {number}
   * @memberof MetaInfo
   */
  totalAdult?: number
  /**
   * nb child in the order, totalChild =  sum(orderItems[*].hotelBooking.reservation.stayInfo.childCount)
   * @type {number}
   * @memberof MetaInfo
   */
  totalChild?: number
  /**
   *
   * @type {TotalOrderPrice}
   * @memberof MetaInfo
   */
  totalOrderPrice?: TotalOrderPrice
  /**
   *
   * @type {LoyaltyInfo}
   * @memberof MetaInfo
   */
  loyaltyInfo?: LoyaltyInfo
}
/**
 *
 * @export
 * @interface MobileModel
 */
export interface MobileModel {
  /**
   *
   * @type {string}
   * @memberof MobileModel
   */
  deviceId?: string
  /**
   *
   * @type {string}
   * @memberof MobileModel
   */
  packageName?: string
}
/**
 * ex karhoo
 * @export
 * @interface MobilityBooking
 */
export interface MobilityBooking {
  /**
   *
   * @type {string}
   * @memberof MobilityBooking
   */
  id?: string
  /**
   *
   * @type {MobilityBookingPassengers}
   * @memberof MobilityBooking
   */
  passengers?: MobilityBookingPassengers
  /**
   * accor's PMID
   * @type {string}
   * @memberof MobilityBooking
   */
  partnerTravellerId?: string
  /**
   * CONFIRMED  The request has been accepted by Dispatch and they will allocate a driver.<br/>DRIVER_EN_ROUTE  A driver is “en route” to the start location. This state can occur multiple times in case of a driver re-assignment.<br/>ARRIVED  The driver has arrived. This state might be skipped in some cases.<br/>POB  Passenger is in the vehicle and the ride has “started”.<br/>COMPLETED  Passenger has reached their destination.<br/>NO_DRIVERS_AVAILABLE  The request was unfulfilled because no driver was available.<br/>DRIVER_CANCELLED  The request has been cancelled by Dispatch or driver.<br/>BOOKER_CANCELLED  The request has been cancelled by the rider.<br/>KARHOO_CANCELLED  The request has been cancelled by Karhoo.<br/>FAILED  There was an internal error with the booking.
   * @type {string}
   * @memberof MobilityBooking
   */
  status?: string
  /**
   * Dispatch cancellation reasons <br/>REQUESTED_BY_USER - Dispatch has cancelled the trip by user request.<br/>PASSENGER_DIDNT_SHOW_UP - Dispatch has cancelled the trip because user didn't show up.<br/>DRIVER_CANCELED - Driver has cancelled the trip.<br/>SUPPLIER_CANCELLED - Supplier has cancelled the trip.<br/>DISPATCH_CANCELLED - Dispatch has cancelled the trip.<br/>NO_AVAILABILITY_IN_THE_AREA - Dispatch has cancelled the trip as no availability in the the area.<br/>NO_FEE - Dispatch has cancelled the trip due to some fee issue.<br/>OTHER_DISPATCH_REASON - Other dispatch cancellation reason.<br/>User cancellation reasons<br/>DRIVER_DIDNT_SHOW_UP - User has cancelled the trip because driver didn't show up.<br/>ETA_TOO_LONG - User has cancelled the trip because estimated time of arival too long.<br/>DRIVER_IS_LATE - User has cancelled the trip because driver is late.<br/>CAN_NOT_FIND_VEHICLE - User has cancelled the trip because user can not find vehicle.<br/>NOT_NEEDED_ANYMORE - User has cancelled the trip as not needed anymore.<br/>ASKED_BY_DRIVER_TO_CANCEL - User has cancelled the trip because driver has asked user to cancel the trip.<br/>FOUND_BETTER_PRICE - User has cancelled the trip because found better price.<br/>NOT_CLEAR_MEETING_INSTRUCTIONS - User has cancelled the trip due to not clear meeting instructions.<br/>COULD_NOT_CONTACT_CARRIER - User has cancelled the trip because could not contact carrier.<br/>OTHER_USER_REASON - User has cancelled the trip.<br/>Karhoo cancellation reasons<br/>FRAUD - Karhoo has cancelled the trip as suspicious booking.<br/>NO_AVAILABILITY - Karhoo has cancelled the trip because no availability found.<br/>ASKED_BY_USER - Karhoo has cancelled the trip because user asked to cancel the trip.<br/>ASKED_BY_DISPATCH - Karhoo has cancelled the trip because dispatch asked to cancel the trip.<br/>ASKED_BY_DRIVER - Karhoo has cancelled the trip because driver asked to cancel the trip.<br/>FAILIURE - Karhoo has cancelled the trip becuase booking is failed.<br/>PREAUTH_FAILED - Karhoo has cancelled the trip. There was an issue with payment preauth and Karhoo is investigating it.<br/>OTHER_KARHOO_REASON - Karhoo has cancelled the trip due to unknown reason.
   * @type {string}
   * @memberof MobilityBooking
   */
  stateDetails?: string
  /**
   *
   * @type {MobilityPlace}
   * @memberof MobilityBooking
   */
  origin?: MobilityPlace
  /**
   *
   * @type {MobilityPlace}
   * @memberof MobilityBooking
   */
  destination?: MobilityPlace
  /**
   *
   * @type {MobilityBookingMeetingPoint}
   * @memberof MobilityBooking
   */
  meetingPoint?: MobilityBookingMeetingPoint
  /**
   *
   * @type {string}
   * @memberof MobilityBooking
   */
  dateScheduled?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBooking
   */
  dateBooked?: string
  /**
   *
   * @type {MobilityBookingQuote}
   * @memberof MobilityBooking
   */
  quote?: MobilityBookingQuote
  /**
   *
   * @type {MobilityBookingFare}
   * @memberof MobilityBooking
   */
  fare?: MobilityBookingFare
  /**
   *
   * @type {MobilityBookingFinalFare}
   * @memberof MobilityBooking
   */
  finalFare?: MobilityBookingFinalFare
  /**
   *
   * @type {string}
   * @memberof MobilityBooking
   */
  displayTripId?: string
  /**
   *
   * @type {MobilityBookingFleetInfo}
   * @memberof MobilityBooking
   */
  fleetInfo?: MobilityBookingFleetInfo
  /**
   *
   * @type {MobilityBookingVehicle}
   * @memberof MobilityBooking
   */
  vehicle?: MobilityBookingVehicle
  /**
   *
   * @type {string}
   * @memberof MobilityBooking
   */
  comments?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBooking
   */
  flightNumber?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBooking
   */
  trainNumber?: string
  /**
   *
   * @type {MobilityBookingCancelledBy}
   * @memberof MobilityBooking
   */
  cancelledBy?: MobilityBookingCancelledBy
  /**
   *
   * @type {MobilityBookingMeta}
   * @memberof MobilityBooking
   */
  meta?: MobilityBookingMeta
  /**
   *
   * @type {MobilityBookingServiceLevelAgreements}
   * @memberof MobilityBooking
   */
  serviceLevelAgreements?: MobilityBookingServiceLevelAgreements
}
/**
 *
 * @export
 * @interface MobilityBookingCancelledBy
 */
export interface MobilityBookingCancelledBy {
  /**
   *
   * @type {string}
   * @memberof MobilityBookingCancelledBy
   */
  firstName?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingCancelledBy
   */
  lastName?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingCancelledBy
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingCancelledBy
   */
  email?: string
}
/**
 *
 * @export
 * @interface MobilityBookingFare
 */
export interface MobilityBookingFare {
  /**
   *
   * @type {number}
   * @memberof MobilityBookingFare
   */
  total?: number
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFare
   */
  currency?: string
  /**
   *
   * @type {number}
   * @memberof MobilityBookingFare
   */
  gratuityPercent?: number
}
/**
 *
 * @export
 * @interface MobilityBookingFinalFare
 */
export interface MobilityBookingFinalFare {
  /**
   * The current state of the fare.<br/>PENDING - the fare is not yet final and might be subject to change. It can not yet be charged.<br/>FINAL - the fare is final and its value is now chargeable.<br/>CANCELLED - the trip has been cancelled (with trip statuses being amongst<br/>CANCELLED_BY_DISPATCH, CANCELLED_BY_KARHOO or CANCELLED_BY_USER). The cancellation fee (fare) value is now chargeable.<br/>FAILED - something went wrong with the trip.
   * @type {string}
   * @memberof MobilityBookingFinalFare
   */
  state?: string
  /**
   * The expected RFC3339 timestamp in UTC for fare to turn into FINAL state.
   * @type {string}
   * @memberof MobilityBookingFinalFare
   */
  expectedFinalTime?: string
  /**
   *
   * @type {MobilityBookingFinalFareBreakdown}
   * @memberof MobilityBookingFinalFare
   */
  breakdown?: MobilityBookingFinalFareBreakdown
  /**
   * Total is the total price of the trip. The unit is the cent or penny value of the currency e.g. EUR is in cents, GBP is in pence. The overall total is the sum of each fare component's net_price and tax_amount.
   * @type {number}
   * @memberof MobilityBookingFinalFare
   */
  total?: number
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFinalFare
   */
  currency?: string
}
/**
 * base - Base component of the fare. Its total price is equal to net_amount + tax_amount.<br/>commission - charged by the Marketplace for facilitating the transaction. Its total price is equal to net_amount + tax_amount.Its value depends on base and extras amounts as it's calculated as a percentage of net amounts of those. Commission percentage is configured per partner.<br/>extras - Any additional costs to the base service that might affect the ride's cost, eg. extra passenger, luggage, waiting time, bike, child seat etc.<br/>expenses - Expenses the driver may incur while executing the ride. eg. parking, tolls, cleaning fee, congestion charge etc. No commissions or taxes (as they’re already included in the expense) will be charged on expenses.
 * @export
 * @interface MobilityBookingFinalFareBreakdown
 */
export interface MobilityBookingFinalFareBreakdown {
  /**
   *
   * @type {MobilityPriceBreakdown}
   * @memberof MobilityBookingFinalFareBreakdown
   */
  base?: MobilityPriceBreakdown
  /**
   *
   * @type {MobilityPriceBreakdown}
   * @memberof MobilityBookingFinalFareBreakdown
   */
  commission?: MobilityPriceBreakdown
  /**
   *
   * @type {Array<MobilityPriceBreakdown>}
   * @memberof MobilityBookingFinalFareBreakdown
   */
  extras?: Array<MobilityPriceBreakdown>
  /**
   *
   * @type {Array<MobilityPriceBreakdown>}
   * @memberof MobilityBookingFinalFareBreakdown
   */
  expenses?: Array<MobilityPriceBreakdown>
  /**
   *
   * @type {number}
   * @memberof MobilityBookingFinalFareBreakdown
   */
  total?: number
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFinalFareBreakdown
   */
  currency?: string
}
/**
 *
 * @export
 * @interface MobilityBookingFleetInfo
 */
export interface MobilityBookingFleetInfo {
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFleetInfo
   */
  description?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFleetInfo
   */
  email?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFleetInfo
   */
  fleetId?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFleetInfo
   */
  logoUrl?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFleetInfo
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFleetInfo
   */
  phoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingFleetInfo
   */
  termsConditionsUrl?: string
}
/**
 *
 * @export
 * @interface MobilityBookingMeetingPoint
 */
export interface MobilityBookingMeetingPoint {
  /**
   *
   * @type {MobilityPosition}
   * @memberof MobilityBookingMeetingPoint
   */
  position?: MobilityPosition
  /**
   *
   * @type {string}
   * @memberof MobilityBookingMeetingPoint
   */
  instructions?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingMeetingPoint
   */
  note?: string
}
/**
 *
 * @export
 * @interface MobilityBookingMeta
 */
export interface MobilityBookingMeta {
  [key: string]: string
}

/**
 *
 * @export
 * @interface MobilityBookingPassengerDetail
 */
export interface MobilityBookingPassengerDetail {
  /**
   *
   * @type {string}
   * @memberof MobilityBookingPassengerDetail
   */
  firstName?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingPassengerDetail
   */
  lastName?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingPassengerDetail
   */
  email?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingPassengerDetail
   */
  phoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingPassengerDetail
   */
  locale?: string
}
/**
 *
 * @export
 * @interface MobilityBookingPassengerLuggage
 */
export interface MobilityBookingPassengerLuggage {
  /**
   *
   * @type {number}
   * @memberof MobilityBookingPassengerLuggage
   */
  total?: number
}
/**
 *
 * @export
 * @interface MobilityBookingPassengers
 */
export interface MobilityBookingPassengers {
  /**
   *
   * @type {Array<MobilityBookingPassengerDetail>}
   * @memberof MobilityBookingPassengers
   */
  passengerDetails?: Array<MobilityBookingPassengerDetail>
  /**
   *
   * @type {MobilityBookingPassengerLuggage}
   * @memberof MobilityBookingPassengers
   */
  luggage?: MobilityBookingPassengerLuggage
}
/**
 *
 * @export
 * @interface MobilityBookingQuote
 */
export interface MobilityBookingQuote {
  /**
   * QUOTE_TYPE_NOT_SET - A null status. Never use this.<br/>FIXED - The fare was quoted at a fixed price.<br/>METERED - The fare was quoted as metered.<br/>ESTIMATED - the fare quoted is an estimate and may change
   * @type {string}
   * @memberof MobilityBookingQuote
   */
  type?: string
  /**
   *
   * @type {number}
   * @memberof MobilityBookingQuote
   */
  total?: number
  /**
   *
   * @type {string}
   * @memberof MobilityBookingQuote
   */
  currency?: string
  /**
   *
   * @type {number}
   * @memberof MobilityBookingQuote
   */
  gratuityPercent?: number
  /**
   * Saloon -  A product that provides a standard class of vehicle with a standard service<br/>Exec -  A product that is of an high-end executive class that is providing an premium service<br/>MPV -  A product that provides a larger capacity vehicle with a standard service  <br/>Electric - A product that is of an all electric class providing a standard service<br/>Moto  - A product that is of a rapid, motorcycle class providing a standard service<br/>Taxi -  A product that provides a taxi class service that is licensed within local frameworks<br/>Wheelchair -  A product that provides vehicles that are accessible with a standard service.
   * @type {string}
   * @memberof MobilityBookingQuote
   */
  vehicleClass?: string
  /**
   * quote time of arrival (high)
   * @type {number}
   * @memberof MobilityBookingQuote
   */
  qtaHighMinutes?: number
  /**
   * quote time of arrival (low)
   * @type {number}
   * @memberof MobilityBookingQuote
   */
  qtaLowMinutes?: number
  /**
   *
   * @type {MobilityBookingVehicleAttributes}
   * @memberof MobilityBookingQuote
   */
  vehicleAttributes?: MobilityBookingVehicleAttributes
  /**
   *
   * @type {string}
   * @memberof MobilityBookingQuote
   */
  source?: string
  /**
   *
   * @type {number}
   * @memberof MobilityBookingQuote
   */
  highPrice?: number
  /**
   *
   * @type {number}
   * @memberof MobilityBookingQuote
   */
  lowPrice?: number
}
/**
 *
 * @export
 * @interface MobilityBookingServiceLevelAgreements
 */
export interface MobilityBookingServiceLevelAgreements {
  /**
   *
   * @type {MobilityBookingServiceLevelAgreementsFreeCancellation}
   * @memberof MobilityBookingServiceLevelAgreements
   */
  freeCancellation?: MobilityBookingServiceLevelAgreementsFreeCancellation
  /**
   *
   * @type {MobilityBookingServiceLevelAgreementsFreeWaitingTime}
   * @memberof MobilityBookingServiceLevelAgreements
   */
  freeWaitingTime?: MobilityBookingServiceLevelAgreementsFreeWaitingTime
}
/**
 *
 * @export
 * @interface MobilityBookingServiceLevelAgreementsFreeCancellation
 */
export interface MobilityBookingServiceLevelAgreementsFreeCancellation {
  /**
   * The fleets free cancellation policy will be returned when applicable. If the \"type\" is set to TimeBeforePickup then the minutes field will contain information about the free cancellation period. The cancellation will be free up till X minutes before the scheduled arrival for the pre booked trips and X minutes after making a booking for ASAP trips.<br/>If the type is set to BeforeDriverEnRoute, then the cancellation is free until the driver is en route to the pickup point.
   * @type {string}
   * @memberof MobilityBookingServiceLevelAgreementsFreeCancellation
   */
  type?: string
  /**
   *
   * @type {number}
   * @memberof MobilityBookingServiceLevelAgreementsFreeCancellation
   */
  minutes?: number
}
/**
 *
 * @export
 * @interface MobilityBookingServiceLevelAgreementsFreeWaitingTime
 */
export interface MobilityBookingServiceLevelAgreementsFreeWaitingTime {
  /**
   *
   * @type {number}
   * @memberof MobilityBookingServiceLevelAgreementsFreeWaitingTime
   */
  minutes?: number
}
/**
 *
 * @export
 * @interface MobilityBookingVehicle
 */
export interface MobilityBookingVehicle {
  /**
   * moto -  A vehicle with two wheels.<br/>standard  - The most common or standard vehicle for a local region. For example in the UK standard would be considered a Saloon whereas in the US this is a Sedan.<br/>mpv  - Typically a large or oversized vehicle with additional capacity.<br/>bus -  The largest type of vehicle with capacities greater than 6 passengers or standard pieces of luggage.
   * @type {string}
   * @memberof MobilityBookingVehicle
   */
  type?: string
  /**
   * electric -  A fully battery electric vehicle.<br/>hybrid -  A mixed hybrid combustion vehicle.<br/>wheelchair -  A vehicle equipped to handle wheelchairs.<br/>child-seat -  Provides a child seat.<br/>taxi -  A vehicle with a regulated metered fare.<br/>executive -  Describes a premium model of vehicle.<br/>luxury -  The highest quality vehicle offered in a region.
   * @type {Array<string>}
   * @memberof MobilityBookingVehicle
   */
  tags?: Array<string>
  /**
   * Saloon -  A product that provides a standard class of vehicle with a standard service<br/>Exec -  A product that is of an high-end executive class that is providing an premium service<br/>MPV -  A product that provides a larger capacity vehicle with a standard service  <br/>Electric - A product that is of an all electric class providing a standard service<br/>Moto  - A product that is of a rapid, motorcycle class providing a standard service<br/>Taxi -  A product that provides a taxi class service that is licensed within local frameworks<br/>Wheelchair -  A product that provides vehicles that are accessible with a standard service.
   * @type {string}
   * @memberof MobilityBookingVehicle
   */
  vehicleClass?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingVehicle
   */
  description?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingVehicle
   */
  vehicleLicensePlate?: string
  /**
   *
   * @type {MobilityBookingVehicleDriver}
   * @memberof MobilityBookingVehicle
   */
  driver?: MobilityBookingVehicleDriver
  /**
   *
   * @type {MobilityBookingVehicleAttributes}
   * @memberof MobilityBookingVehicle
   */
  attributes?: MobilityBookingVehicleAttributes
}
/**
 *
 * @export
 * @interface MobilityBookingVehicleAttributes
 */
export interface MobilityBookingVehicleAttributes {
  /**
   *
   * @type {number}
   * @memberof MobilityBookingVehicleAttributes
   */
  passengerCapacity?: number
  /**
   *
   * @type {number}
   * @memberof MobilityBookingVehicleAttributes
   */
  luggageCapacity?: number
  /**
   *
   * @type {boolean}
   * @memberof MobilityBookingVehicleAttributes
   */
  hybrid?: boolean
  /**
   *
   * @type {boolean}
   * @memberof MobilityBookingVehicleAttributes
   */
  electric?: boolean
  /**
   *
   * @type {boolean}
   * @memberof MobilityBookingVehicleAttributes
   */
  childSeat?: boolean
}
/**
 *
 * @export
 * @interface MobilityBookingVehicleDriver
 */
export interface MobilityBookingVehicleDriver {
  /**
   *
   * @type {string}
   * @memberof MobilityBookingVehicleDriver
   */
  firstName?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingVehicleDriver
   */
  lastName?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingVehicleDriver
   */
  phoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingVehicleDriver
   */
  photoUrl?: string
  /**
   *
   * @type {string}
   * @memberof MobilityBookingVehicleDriver
   */
  licenseNumber?: string
}
/**
 * the place of departure for the ride
 * @export
 * @interface MobilityPlace
 */
export interface MobilityPlace {
  /**
   *
   * @type {string}
   * @memberof MobilityPlace
   */
  displayAddress?: string
  /**
   *
   * @type {MobilityPosition}
   * @memberof MobilityPlace
   */
  position?: MobilityPosition
  /**
   *
   * @type {string}
   * @memberof MobilityPlace
   */
  placeId?: string
  /**
   * A \"Point of Interest\" (POI) is a location on the map where there are restrictions to where a driver can pick up a passenger. The type of Point of Interest<br/>NOT_SET_POI_TYPE - Not specified<br/>ENRICHED - Standard Karhoo POI Type that usually defines CURB_SIDE, MEET_AND_GREET or STAND_BY meeting points<br/>REGULATED - POI usually defining restricted PICK_UP and DROP_OFF meeting points<br/>NEAREST - POI usually defining recommended PICK_UP and DROP_OFF meeting points
   * @type {string}
   * @memberof MobilityPlace
   */
  poiType?: string
  /**
   *
   * @type {string}
   * @memberof MobilityPlace
   */
  timezone?: string
}
/**
 * gps coordinates
 * @export
 * @interface MobilityPosition
 */
export interface MobilityPosition {
  /**
   *
   * @type {number}
   * @memberof MobilityPosition
   */
  latitude?: number
  /**
   *
   * @type {number}
   * @memberof MobilityPosition
   */
  longitude?: number
}
/**
 *
 * @export
 * @interface MobilityPriceBreakdown
 */
export interface MobilityPriceBreakdown {
  /**
   * The percentage of tax applied to the item.
   * @type {number}
   * @memberof MobilityPriceBreakdown
   */
  taxPercentage?: number
  /**
   * The percent of a commission applied to the item.
   * @type {number}
   * @memberof MobilityPriceBreakdown
   */
  commissionPercentage?: number
  /**
   * The amount of tax for the item. The unit is the cent or penny value of the currency e.g. EUR is in cents, GBP is in pence.
   * @type {number}
   * @memberof MobilityPriceBreakdown
   */
  taxAmount?: number
  /**
   * The net price of the item. The unit is the cent or penny value of the currency e.g. EUR is in cents, GBP is in pence.
   * @type {number}
   * @memberof MobilityPriceBreakdown
   */
  netPrice?: number
  /**
   * An English name of the item describing its meaning.<br/>Warning - it shouldn't be treated as an enumeration. Names can change in the future therefore it's not recommended to use it for any automatic mapping.
   * @type {string}
   * @memberof MobilityPriceBreakdown
   */
  name?: string
}
/**
 *
 * @export
 * @interface Order
 */
export interface Order {
  /**
   * order's id. Folder number for booking, or identifier for Stays without bookings (walk-ins...) and for mobility/activity bookings. Is always valued, cannot be null
   * @type {string}
   * @memberof Order
   */
  id: string
  /**
   *
   * @type {MetaInfo}
   * @memberof Order
   */
  metaInfo: MetaInfo
  /**
   * list of order items
   * @type {Array<OrderItem>}
   * @memberof Order
   */
  orderItems: Array<OrderItem>
  /**
   *
   * @type {LoyaltySavingsDatas}
   * @memberof Order
   */
  loyaltySavings: LoyaltySavingsDatas
  /**
   *
   * @type {Invoice}
   * @memberof Order
   */
  invoice?: Invoice
}
/**
 *
 * @export
 * @interface OrderItem
 */
export interface OrderItem {
  /**
   * id of the booking in the source system. karhoo id for karhoo. for TARS bookings, booking id, also known as numResa_ini, or bookingNumber. Is always valued, cannot be null
   * @type {string}
   * @memberof OrderItem
   */
  id: string
  /**
   * type of orders are <b>either</b> HOTEL_BOOKING (hotelBooking object below) / MOBILITY_BOOKING (mobilityBooking object below)/ ACTIVITY_BOOKING (activityBooking object below)/ …Is always valued, cannot be null
   * @type {string}
   * @memberof OrderItem
   */
  orderType: string
  /**
   *
   * @type {HotelBooking}
   * @memberof OrderItem
   */
  hotelBooking?: HotelBooking
  /**
   *
   * @type {MobilityBooking}
   * @memberof OrderItem
   */
  mobilityBooking?: MobilityBooking
}
/**
 * This type represents the dynamodb item of an orderItem in the database for 'order_items' table. It's declared here for generating TypeScript code, or Avro Schema
 * @export
 * @interface OrderItemDynamodb
 */
export interface OrderItemDynamodb {
  /**
   * Hash key
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  orderId: string
  /**
   * Sort key
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  orderItemId: string
  /**
   * The pmid
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  pmid?: string
  /**
   * gsi_pmid_sortDate
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  sortDate?: string
  /**
   * Hotel code
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  hotelCode?: string
  /**
   * The first reservation number
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  numResaIni?: string
  /**
   * The lastest reservation number, its value can be the same as numResaIni
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  numResaFin?: string
  /**
   *
   * @type {OrderItem}
   * @memberof OrderItemDynamodb
   */
  orderItem: OrderItem
  /**
   * PERIMETER, list of digital gift
   * @type {Array<DigitalGift>}
   * @memberof OrderItemDynamodb
   */
  digitalGifts?: Array<DigitalGift>
  /**
   * PERIMETER, list of stays (from LUKE) that have been associated with this orderItem. Updated by sync-stay-into-order
   * @type {Array<StayItem>}
   * @memberof OrderItemDynamodb
   */
  stayDetails?: Array<StayItem>
  /**
   * PERIMETER, list of payment transactions for this orderItem. Updated by sync-order-perimeter
   * @type {Array<HotelBookingPaymentTransaction>}
   * @memberof OrderItemDynamodb
   */
  paymentTransactions?: Array<HotelBookingPaymentTransaction>
  /**
   *
   * @type {any}
   * @memberof OrderItemDynamodb
   */
  loyaltySimulationPoints?: any
  /**
   *
   * @type {any}
   * @memberof OrderItemDynamodb
   */
  softBenefits?: any
  /**
   *
   * @type {any}
   * @memberof OrderItemDynamodb
   */
  tdts?: any
  /**
   * The external confirmation number
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  externalConfirmationNumber?: string
  /**
   * The external Id from orderItem.hotelBooking?.reservation?.externalConnectivity?.externalId for GSI
   * @type {string}
   * @memberof OrderItemDynamodb
   */
  externalId?: string
}
/**
 * This type represents the dynamodb Key of a row in the database for 'order_items_by_pmid' table. It's declared here for generating TypeScript code, or Avro Schema
 * @export
 * @interface OrderItemDynamodbByPmidCompositePrimaryKey
 */
export interface OrderItemDynamodbByPmidCompositePrimaryKey {
  /**
   * Hash key
   * @type {string}
   * @memberof OrderItemDynamodbByPmidCompositePrimaryKey
   */
  pmid: string
  /**
   * Sort key
   * @type {string}
   * @memberof OrderItemDynamodbByPmidCompositePrimaryKey
   */
  orderItemId: string
}
/**
 * This type represents the diff event of a modification fof 'order_items_by_pmid' table for has oder. It's declared here for generating TypeScript code, or Avro Schema
 * @export
 * @interface OrderItemDynamodbByPmidStreamDiff
 */
export interface OrderItemDynamodbByPmidStreamDiff {
  /**
   * Hash key
   * @type {string}
   * @memberof OrderItemDynamodbByPmidStreamDiff
   */
  pmid: string
  /**
   * Sort key
   * @type {string}
   * @memberof OrderItemDynamodbByPmidStreamDiff
   */
  orderItemId: string
  /**
   * D for deletion, I for insertion or update
   * @type {string}
   * @memberof OrderItemDynamodbByPmidStreamDiff
   */
  dmlType?: string
}
/**
 * Contact information of the partyRole. Can be null
 * @export
 * @interface PartyRole
 */
export interface PartyRole {
  /**
   *
   * @type {PartyRoleEnum}
   * @memberof PartyRole
   */
  role?: PartyRoleEnum
  /**
   * Personal Member IDentifier. Unique id in all ACCOR's information system
   * @type {string}
   * @memberof PartyRole
   */
  pmid?: string
  /**
   * nationality of the mainBeneficiary
   * @type {string}
   * @memberof PartyRole
   */
  nationality?: string
  /**
   * language of communication of the mainBeneficiary
   * @type {string}
   * @memberof PartyRole
   */
  language?: string
  /**
   * contract code of the buyer
   * @type {string}
   * @memberof PartyRole
   */
  accountCode?: string
  /**
   * flag the party role as buyer
   * @type {boolean}
   * @memberof PartyRole
   */
  isBuyer?: boolean
  /**
   * contact of the buyer
   * @type {string}
   * @memberof PartyRole
   */
  contact?: string
  /**
   * client type of the buyer , for exp AGV for travel agency
   * @type {string}
   * @memberof PartyRole
   */
  clientType?: string
  /**
   * IntraComVat of the partyRole
   * @type {string}
   * @memberof PartyRole
   */
  intraComVatIdNumber?: string
  /**
   * age of the guest when it is a child
   * @type {number}
   * @memberof PartyRole
   */
  childrenAge?: number
  /**
   *
   * @type {Array<PartyRoleName>}
   * @memberof PartyRole
   */
  names?: Array<PartyRoleName>
  /**
   *
   * @type {Array<PartyRoleCard>}
   * @memberof PartyRole
   */
  cards?: Array<PartyRoleCard>
  /**
   *
   * @type {Array<PartyRoleCard>}
   * @memberof PartyRole
   */
  externalCards?: Array<PartyRoleCard>
  /**
   *
   * @type {ContactMedium}
   * @memberof PartyRole
   */
  contactMedium?: ContactMedium
}
/**
 * Party Role Card. Can be null
 * @export
 * @interface PartyRoleCard
 */
export interface PartyRoleCard {
  /**
   * type of the loyalty card
   * @type {string}
   * @memberof PartyRoleCard
   */
  type?: string
  /**
   * number of the loyalty card
   * @type {string}
   * @memberof PartyRoleCard
   */
  number?: string
  /**
   * cardHolderName on the loyalty card
   * @type {string}
   * @memberof PartyRoleCard
   */
  cardHolderName?: string
}
/**
 * type of the customer ENUM [MAIN_BENEFICIARY_COMPANY, INVOICED, INTERMEDIARY, OTHER, MAIN_BENEFICIARY, GUEST]. Always valued, cannot be null
 * @export
 * @enum {string}
 */
export enum PartyRoleEnum {
  MAINBENEFICIARY = <any>'MAIN_BENEFICIARY',
  GUEST = <any>'GUEST',
  INVOICED = <any>'INVOICED',
  MAINBENEFICIARYCOMPANY = <any>'MAIN_BENEFICIARY_COMPANY',
  INTERMEDIARY = <any>'INTERMEDIARY',
  OTHER = <any>'OTHER'
}
/**
 * Party Role Name. Can be null
 * @export
 * @interface PartyRoleName
 */
export interface PartyRoleName {
  /**
   * Last name
   * @type {string}
   * @memberof PartyRoleName
   */
  lastName?: string
  /**
   * First name
   * @type {string}
   * @memberof PartyRoleName
   */
  firstName?: string
  /**
   * Title
   * @type {string}
   * @memberof PartyRoleName
   */
  title?: string
  /**
   * Last name non latin
   * @type {string}
   * @memberof PartyRoleName
   */
  lastNameNonLatin?: string
  /**
   * First name non latin
   * @type {string}
   * @memberof PartyRoleName
   */
  firstNameNonLatin?: string
  /**
   * Commercial name
   * @type {string}
   * @memberof PartyRoleName
   */
  commercialName?: string
}
/**
 *
 * @export
 * @interface PmidByOrderItemId
 */
export interface PmidByOrderItemId {
  /**
   *
   * @type {string}
   * @memberof PmidByOrderItemId
   */
  orderItemId?: string
  /**
   *
   * @type {string}
   * @memberof PmidByOrderItemId
   */
  pmid?: string
  /**
   *
   * @type {string}
   * @memberof PmidByOrderItemId
   */
  reason?: string
}
/**
 *
 * @export
 * @interface PreferenceModel
 */
export interface PreferenceModel {
  /**
   *
   * @type {string}
   * @memberof PreferenceModel
   */
  familyCode?: string
  /**
   *
   * @type {string}
   * @memberof PreferenceModel
   */
  favouriteCentral?: string
  /**
   *
   * @type {string}
   * @memberof PreferenceModel
   */
  codeHotel?: string
  /**
   *
   * @type {string}
   * @memberof PreferenceModel
   */
  comments?: string
  /**
   *
   * @type {string}
   * @memberof PreferenceModel
   */
  valueCode?: string
  /**
   *
   * @type {string}
   * @memberof PreferenceModel
   */
  valueIntegrationId?: string
  /**
   *
   * @type {string}
   * @memberof PreferenceModel
   */
  prefName?: string
  /**
   *
   * @type {string}
   * @memberof PreferenceModel
   */
  prefMonoMulti?: string
}
/**
 * booking
 * @export
 * @interface Reservation
 */
export interface Reservation {
  /**
   *
   * @type {ReservationPrePay}
   * @memberof Reservation
   */
  prePay?: ReservationPrePay
  /**
   *
   * @type {ReservationOnlineCheckIn}
   * @memberof Reservation
   */
  onlineCheckIn?: ReservationOnlineCheckIn
}
/**
 * information on external connectivity (OTA / GDS)
 * @export
 * @interface ReservationExternalConnectivity
 */
export interface ReservationExternalConnectivity {
  /**
   * date and time the reservation was received from OTA/GDS
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  receptionDatetime?: string
  /**
   * confirmation number in the OTA/GDS system. Should be the Id the client receives. Will be searchable in the near future.
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  confirmationNumber?: string
  /**
   * cancellation number in the OTA/GDS system.
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  cancellationNumber?: string
  /**
   * product code in the OTA/GDS system. No referrential
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  productCode?: string
  /**
   * hotel code in the OTA/GDS system. No referrential
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  hotelCode?: string
  /**
   * Accor's GDS code for the OTA/GDS partner.
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  gdsPartnerCode?: string
  /**
   * folder number in the OTA/GDS system. for BKG and EXP, they are the same as TARS's folder number. For other GDS/OTA like SAB or AMA, it is a different one. Will be searchable in the near future.
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  recordLocator?: string
  /**
   * external (technical) id in the OTA/GDS system.
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  externalId?: string
  /**
   * external (technical) id complement in the OTA/GDS system.
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  externalIdComplement?: string
  /**
   * not 100% clear, but seems like \"E\" is normal and \"O\" is when the booking was cancelled on OTA/GDS side
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  statusProc?: string
  /**
   * the type of OTA/GDS message received. Signification unknown. oberved values : AE,BS,AS,AC,BC,BX,AX
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  tx?: string
  /**
   * linked information for certain partner like Expedia, to distinguish the provenance (MrJet, Expedia... for example). known values are A-Expedia,A-Expedia Affiliate Network,A-Hotels.com,Expedia,Expedia Affiliate Network,GDS_PartnerPrecision,Hotels.com
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  gdsPartnerPrecision?: string
  /**
   * the first name of the beneficiary in the OTA/GDS system, as it was sent to accor.
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  beneficiaryFirstName?: string
  /**
   * the last name of the beneficiary in the OTA/GDS system, as it was sent to accor.
   * @type {string}
   * @memberof ReservationExternalConnectivity
   */
  beneficiaryLastName?: string
}
/**
 * OnlineCheckIn
 * @export
 * @interface ReservationOnlineCheckIn
 */
export interface ReservationOnlineCheckIn {
  /**
   * smsRequested
   * @type {string}
   * @memberof ReservationOnlineCheckIn
   */
  smsRequested?: string
  /**
   * status
   * @type {string}
   * @memberof ReservationOnlineCheckIn
   */
  status?: string
  /**
   *
   * @type {ReservationOnlineCheckInPreAuthorization}
   * @memberof ReservationOnlineCheckIn
   */
  preAuthorization?: ReservationOnlineCheckInPreAuthorization
}
/**
 * PreAuthorization
 * @export
 * @interface ReservationOnlineCheckInPreAuthorization
 */
export interface ReservationOnlineCheckInPreAuthorization {
  /**
   * status of PreAuthorization
   * @type {string}
   * @memberof ReservationOnlineCheckInPreAuthorization
   */
  status?: string
  /**
   *
   * @type {ReservationOnlineCheckInPreAuthorizationAmount}
   * @memberof ReservationOnlineCheckInPreAuthorization
   */
  amount?: ReservationOnlineCheckInPreAuthorizationAmount
}
/**
 * amount of PreAuthorization
 * @export
 * @interface ReservationOnlineCheckInPreAuthorizationAmount
 */
export interface ReservationOnlineCheckInPreAuthorizationAmount {
  /**
   * value of the PreAuthorization
   * @type {string}
   * @memberof ReservationOnlineCheckInPreAuthorizationAmount
   */
  value?: string
  /**
   * currency of the PreAuthorization
   * @type {string}
   * @memberof ReservationOnlineCheckInPreAuthorizationAmount
   */
  currency?: string
}
/**
 * filled using refs : local..HOTPROD / local..PRODUIT / local..PRODUCT_FAMILY for attachedProducts (VPC, options...)
 * @export
 * @interface ReservationOtherOfferComponentProduct
 */
export interface ReservationOtherOfferComponentProduct {
  /**
   * the product's code found in the order
   * @type {string}
   * @memberof ReservationOtherOfferComponentProduct
   */
  code: string
  /**
   * from local..HOTPROD - if HOTPROD.libmkt1 == 47 char : CONCAT(HOTPROD.libmkt1+HOTPROD.libmkt2) else : CONCAT(HOTPROD.libmkt1+\" \"+HOTPROD.libmkt2) elseif HOTPROD.libmkt1 is null : from local..PRODUCT - if PRODUCT.libmkt1 == 47 char : CONCAT(PRODUCT.libmkt1+PRODUCT.libmkt2) else : CONCAT(PRODUCT.libmkt1+\" \"+PRODUCT.libmkt2) elseif PRODUCT.libmkt1 is null : PRODUCT.NOMPRODUIT
   * @type {string}
   * @memberof ReservationOtherOfferComponentProduct
   */
  label?: string
  /**
   * from local..HOTPROD.INFOPRODUIT
   * @type {string}
   * @memberof ReservationOtherOfferComponentProduct
   */
  description?: string
  /**
   * from local..PRODUIT.CATEGORIE
   * @type {string}
   * @memberof ReservationOtherOfferComponentProduct
   */
  category?: string
  /**
   * from local..PRODUIT.CODETYPEPRODUIT (code) and local..PRODUIT.NOMPRODUIT (label)
   * @type {CodeLabel}
   * @memberof ReservationOtherOfferComponentProduct
   */
  type?: CodeLabel
  /**
   * from local..PRODUIT.FLAGTYPE (code) and local..PRODUCT_FAMILY.LABEL (label) where PRODUIT.FLAGTYPE ==  PRODUCT_FAMILY.FLAGTYPE
   * @type {CodeLabel}
   * @memberof ReservationOtherOfferComponentProduct
   */
  family?: CodeLabel
  /**
   * from local..PRODUIT.OncePerStay
   * @type {boolean}
   * @memberof ReservationOtherOfferComponentProduct
   */
  oncePerStay?: boolean
  /**
   * représente le nombre de personne comprise dans le service, par exemple nbPax=2 alors le services est pour 2 personnes. Correspondance MPD : resaprod.nbpax
   * @type {number}
   * @memberof ReservationOtherOfferComponentProduct
   */
  nbPax?: number
}
/**
 * prepaid info of the booking
 * @export
 * @interface ReservationPrePay
 */
export interface ReservationPrePay {
  /**
   * amount of the prepaiment
   * @type {string}
   * @memberof ReservationPrePay
   */
  value?: string
  /**
   * currency of the prepaiment
   * @type {string}
   * @memberof ReservationPrePay
   */
  currency?: string
}
/**
 *
 * @export
 * @interface ReservationPreference
 */
export interface ReservationPreference {
  /**
   *
   * @type {ReservationOtherOfferComponentProduct}
   * @memberof ReservationPreference
   */
  product?: ReservationOtherOfferComponentProduct
  /**
   *
   * @type {number}
   * @memberof ReservationPreference
   */
  quantity?: number
  /**
   * when true, means the preference will be ACCEPTED or REFUSED by the hotel Staff at some point. When false, the preference has been automatically accepted upon booking
   * @type {boolean}
   * @memberof ReservationPreference
   */
  noGuaranty?: boolean
  /**
   * possible values are : UNPROCESSED : Will be validated by hotel (noGuaranty = true) -- VALIDATED_BY_DEFAULT : automatically accepted (noGuaranty = false) --VALIDATED : preference has been accepted by hotel -- REFUSED: preference has been refused by hotel
   * @type {string}
   * @memberof ReservationPreference
   */
  validationStatus?: string
  /**
   * the date when the preference was processed by Hotel (when noGuaranty=true and validationStatus!=UNPROCESSED)
   * @type {string}
   * @memberof ReservationPreference
   */
  processingDate?: string
  /**
   * when true, the preference applies to the whole order (therefore, for all order-items). When false, the preference only applies to this order-item
   * @type {boolean}
   * @memberof ReservationPreference
   */
  isFolderPreference?: boolean
}
/**
 * Informations liées à l'offre de référence sur laquelle se base la promotion
 * @export
 * @interface ReservationReferenceOffer
 */
export interface ReservationReferenceOffer {
  /**
   * Tarskey de l'offre de reference, Correspondance MPD : typeCode = ResaDiscountRef.codetypetarskey, code=ResaDiscountRef.codetarskey
   * @type {HotelBookingRate}
   * @memberof ReservationReferenceOffer
   */
  tkpk?: HotelBookingRate
  /**
   * Rate level de l'offre de reference, Correspondance MPD : ResaDiscountRef.codeTarif, Correspondance Ref BasicsWeb : LOCAL..TARIF.CODETARIF and LOCAL..TARIF.NOMTARIF
   * @type {CodeLabel}
   * @memberof ReservationReferenceOffer
   */
  rateLevel?: CodeLabel
  /**
   * amounts of the reference offer of the discount
   * @type {HotelBookingAmounts}
   * @memberof ReservationReferenceOffer
   */
  amounts?: HotelBookingAmounts
}
/**
 *
 * @export
 * @interface ReservationRoomAmenity
 */
export interface ReservationRoomAmenity {
  /**
   *
   * @type {string}
   * @memberof ReservationRoomAmenity
   */
  name?: string
  /**
   * label / translated using language query param (en by default)
   * @type {string}
   * @memberof ReservationRoomAmenity
   */
  label?: string
  /**
   *
   * @type {Array<ReservationRoomAmenityAmenities>}
   * @memberof ReservationRoomAmenity
   */
  amenities?: Array<ReservationRoomAmenityAmenities>
  /**
   *
   * @type {Array<ReservationRoomAmenityFacilities>}
   * @memberof ReservationRoomAmenity
   */
  facilities?: Array<ReservationRoomAmenityFacilities>
}
/**
 *
 * @export
 * @interface ReservationRoomAmenityAmenities
 */
export interface ReservationRoomAmenityAmenities {
  /**
   *
   * @type {string}
   * @memberof ReservationRoomAmenityAmenities
   */
  value?: string
  /**
   *
   * @type {string}
   * @memberof ReservationRoomAmenityAmenities
   */
  code?: string
}
/**
 *
 * @export
 * @interface ReservationRoomAmenityFacilities
 */
export interface ReservationRoomAmenityFacilities {
  /**
   *
   * @type {string}
   * @memberof ReservationRoomAmenityFacilities
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof ReservationRoomAmenityFacilities
   */
  label?: string
  /**
   *
   * @type {Array<ReservationRoomAmenityItems>}
   * @memberof ReservationRoomAmenityFacilities
   */
  items?: Array<ReservationRoomAmenityItems>
}
/**
 *
 * @export
 * @interface ReservationRoomAmenityItems
 */
export interface ReservationRoomAmenityItems {
  /**
   *
   * @type {string}
   * @memberof ReservationRoomAmenityItems
   */
  code?: string
  /**
   *
   * @type {string}
   * @memberof ReservationRoomAmenityItems
   */
  name?: string
  /**
   *
   * @type {boolean}
   * @memberof ReservationRoomAmenityItems
   */
  paying?: boolean
}
/**
 * filled using WC-REF /catalog/v1/hotels/{hotelCode}/products/accommodations for rooms
 * @export
 * @interface ReservationRoomOfferComponentProduct
 */
export interface ReservationRoomOfferComponentProduct {
  /**
   *
   * @type {string}
   * @memberof ReservationRoomOfferComponentProduct
   */
  code?: string
  /**
   *
   * @type {string}
   * @memberof ReservationRoomOfferComponentProduct
   */
  label?: string
  /**
   *
   * @type {string}
   * @memberof ReservationRoomOfferComponentProduct
   */
  shortLabel?: string
  /**
   *
   * @type {string}
   * @memberof ReservationRoomOfferComponentProduct
   */
  description?: string
  /**
   *
   * @type {boolean}
   * @memberof ReservationRoomOfferComponentProduct
   */
  extendedStay?: boolean
  /**
   *
   * @type {Array<ReservationRoomOfferComponentProductConfiguration>}
   * @memberof ReservationRoomOfferComponentProduct
   */
  configuration?: Array<ReservationRoomOfferComponentProductConfiguration>
  /**
   *
   * @type {ReservationRoomOfferComponentProductClassification}
   * @memberof ReservationRoomOfferComponentProduct
   */
  classification?: ReservationRoomOfferComponentProductClassification
  /**
   *
   * @type {ReservationRoomOfferComponentProductFloorSpace}
   * @memberof ReservationRoomOfferComponentProduct
   */
  floorSpace?: ReservationRoomOfferComponentProductFloorSpace
  /**
   *
   * @type {Array<string>}
   * @memberof ReservationRoomOfferComponentProduct
   */
  upsells?: Array<string>
  /**
   *
   * @type {ReservationRoomOfferComponentProductSurface}
   * @memberof ReservationRoomOfferComponentProduct
   */
  surface?: ReservationRoomOfferComponentProductSurface
  /**
   *
   * @type {Array<ReservationRoomAmenity>}
   * @memberof ReservationRoomOfferComponentProduct
   */
  amenities?: Array<ReservationRoomAmenity>
  /**
   * translated using language query param (en by default)
   * @type {Array<string>}
   * @memberof ReservationRoomOfferComponentProduct
   */
  topAmenities?: Array<string>
  /**
   *
   * @type {ReservationRoomOfferComponentProductMedias}
   * @memberof ReservationRoomOfferComponentProduct
   */
  medias?: ReservationRoomOfferComponentProductMedias
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductBeddings
 */
export interface ReservationRoomOfferComponentProductBeddings {
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductBeddings
   */
  singleBed?: number
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductBeddings
   */
  doubleBed?: number
  /**
   *
   * @type {ReservationRoomOfferComponentProductBeddingsExtra}
   * @memberof ReservationRoomOfferComponentProductBeddings
   */
  extra?: ReservationRoomOfferComponentProductBeddingsExtra
  /**
   *
   * @type {Array<ReservationRoomOfferComponentProductBeddingsDetails>}
   * @memberof ReservationRoomOfferComponentProductBeddings
   */
  details?: Array<ReservationRoomOfferComponentProductBeddingsDetails>
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductBeddingsDetails
 */
export interface ReservationRoomOfferComponentProductBeddingsDetails {
  /**
   *
   * @type {string}
   * @memberof ReservationRoomOfferComponentProductBeddingsDetails
   */
  type?: string
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductBeddingsDetails
   */
  quantity?: number
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductBeddingsExtra
 */
export interface ReservationRoomOfferComponentProductBeddingsExtra {
  /**
   *
   * @type {boolean}
   * @memberof ReservationRoomOfferComponentProductBeddingsExtra
   */
  childBed?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ReservationRoomOfferComponentProductBeddingsExtra
   */
  adultBed?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ReservationRoomOfferComponentProductBeddingsExtra
   */
  crib?: boolean
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductClassification
 */
export interface ReservationRoomOfferComponentProductClassification {
  /**
   *
   * @type {string}
   * @memberof ReservationRoomOfferComponentProductClassification
   */
  type?: string
  /**
   *
   * @type {string}
   * @memberof ReservationRoomOfferComponentProductClassification
   */
  standard?: string
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductConfiguration
 */
export interface ReservationRoomOfferComponentProductConfiguration {
  /**
   *
   * @type {ReservationRoomOfferComponentProductBeddings}
   * @memberof ReservationRoomOfferComponentProductConfiguration
   */
  beddings?: ReservationRoomOfferComponentProductBeddings
  /**
   *
   * @type {ReservationRoomOfferComponentProductMaxOccupancy}
   * @memberof ReservationRoomOfferComponentProductConfiguration
   */
  maxOccupancy?: ReservationRoomOfferComponentProductMaxOccupancy
  /**
   *
   * @type {ReservationRoomOfferComponentProductSituation}
   * @memberof ReservationRoomOfferComponentProductConfiguration
   */
  situation?: ReservationRoomOfferComponentProductSituation
  /**
   *
   * @type {Array<string>}
   * @memberof ReservationRoomOfferComponentProductConfiguration
   */
  assets?: Array<string>
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductFloorSpace
 */
export interface ReservationRoomOfferComponentProductFloorSpace {
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductFloorSpace
   */
  value?: number
  /**
   *
   * @type {string}
   * @memberof ReservationRoomOfferComponentProductFloorSpace
   */
  unit?: string
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductMaxOccupancy
 */
export interface ReservationRoomOfferComponentProductMaxOccupancy {
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductMaxOccupancy
   */
  pax?: number
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductMaxOccupancy
   */
  adult?: number
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductMaxOccupancy
   */
  children?: number
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductMaxOccupancy
   */
  maxChildAge?: number
}
/**
 * a small selection of medias to display. for more medias such as room images, consult /catalog/v1/hotels/$code/medias
 * @export
 * @interface ReservationRoomOfferComponentProductMedias
 */
export interface ReservationRoomOfferComponentProductMedias {
  /**
   * medias size
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductMedias
   */
  total?: number
  /**
   * Room's photos detail
   * @type {Array<{ [key: string]: string; }>}
   * @memberof ReservationRoomOfferComponentProductMedias
   */
  photos?: Array<{ [key: string]: string }>
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductSituation
 */
export interface ReservationRoomOfferComponentProductSituation {
  /**
   *
   * @type {boolean}
   * @memberof ReservationRoomOfferComponentProductSituation
   */
  accessibility?: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof ReservationRoomOfferComponentProductSituation
   */
  views?: Array<string>
}
/**
 *
 * @export
 * @interface ReservationRoomOfferComponentProductSurface
 */
export interface ReservationRoomOfferComponentProductSurface {
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductSurface
   */
  squareMeter?: number
  /**
   *
   * @type {number}
   * @memberof ReservationRoomOfferComponentProductSurface
   */
  squareFeet?: number
}
/**
 * a RoomStay is a room within a booking.
 * @export
 * @interface ReservationRoomStay
 */
export interface ReservationRoomStay {
  /**
   * the quantity of rooms will only be present for family or group bookings. Will mostly be null and you can assume 1 room
   * @type {number}
   * @memberof ReservationRoomStay
   */
  quantity?: number
  /**
   * The main rate for the room. other rates will be described in the rateDetails node below. TK Primaire. Correspondance MPD : resaprod.typetarskeyprimaire/tarskeyprimaire Attention, RESAweb ne stocke pas la TK primaire dans le cas où le tarif a été modifié manuellement (MTM)
   * @type {HotelBookingRate}
   * @memberof ReservationRoomStay
   */
  primaryTkpk?: HotelBookingRate
  /**
   *
   * @type {string}
   * @memberof ReservationRoomStay
   */
  roomNumber?: string
  /**
   *
   * @type {ReservationRoomStayOfferComponent}
   * @memberof ReservationRoomStay
   */
  offerComponent?: ReservationRoomStayOfferComponent
  /**
   * rate details for the offerComponent (the product associated with the rates). rates will be aggregated (grouped by) by rateCode and price and mealPlan
   * @type {Array<ReservationRoomStayRateDetail>}
   * @memberof ReservationRoomStay
   */
  rateDetails?: Array<ReservationRoomStayRateDetail>
  /**
   * rate details for the additional attached products (aka options, vpc...).
   * @type {Array<ReservationRoomStayAttachedProduct>}
   * @memberof ReservationRoomStay
   */
  attachedProducts?: Array<ReservationRoomStayAttachedProduct>
}
/**
 * each element represents an attached product
 * @export
 * @interface ReservationRoomStayAttachedProduct
 */
export interface ReservationRoomStayAttachedProduct {
  /**
   * an array of dates, ordered by date 'asc' to which this product applies
   * @type {Array<string>}
   * @memberof ReservationRoomStayAttachedProduct
   */
  dates?: Array<string>
  /**
   * Base physique : resaprod.qteprodresa
   * @type {number}
   * @memberof ReservationRoomStayAttachedProduct
   */
  quantity?: number
  /**
   * Correspondance MPD : resaprod.ordreproduit
   * @type {number}
   * @memberof ReservationRoomStayAttachedProduct
   */
  productOrder?: number
  /**
   *
   * @type {ReservationOtherOfferComponentProduct}
   * @memberof ReservationRoomStayAttachedProduct
   */
  product?: ReservationOtherOfferComponentProduct
  /**
   * Referrential in : BASICSweb > Properties > Amenities > Meal plans (local..mealplan.codemealplan and local..mealplan.nommealplan)
   * @type {CodeLabel}
   * @memberof ReservationRoomStayAttachedProduct
   */
  mealPlan?: CodeLabel
  /**
   * aggregate prices for the option (aka attachedProduct) for all the days this option applies
   * @type {HotelBookingAmounts}
   * @memberof ReservationRoomStayAttachedProduct
   */
  amounts?: HotelBookingAmounts
  /**
   * the prices for this product for 1 day
   * @type {HotelBookingRatePrice}
   * @memberof ReservationRoomStayAttachedProduct
   */
  price?: HotelBookingRatePrice
}
/**
 *
 * @export
 * @interface ReservationRoomStayOfferComponent
 */
export interface ReservationRoomStayOfferComponent {
  /**
   *
   * @type {number}
   * @memberof ReservationRoomStayOfferComponent
   */
  productOrder?: number
  /**
   * Correspondance MPD : resaprod.nbpax
   * @type {number}
   * @memberof ReservationRoomStayOfferComponent
   */
  nbPax?: number
  /**
   *
   * @type {ReservationRoomOfferComponentProduct}
   * @memberof ReservationRoomStayOfferComponent
   */
  product?: ReservationRoomOfferComponentProduct
  /**
   * aggregate prices for the room (options or attachedProducts prices are not included in this aggregation)
   * @type {HotelBookingAmounts}
   * @memberof ReservationRoomStayOfferComponent
   */
  amounts?: HotelBookingAmounts
}
/**
 * each element is a groupment of rate & price
 * @export
 * @interface ReservationRoomStayRateDetail
 */
export interface ReservationRoomStayRateDetail {
  /**
   * an array of dates, ordered by date 'asc' to which this rate groupment applies
   * @type {Array<string>}
   * @memberof ReservationRoomStayRateDetail
   */
  dates?: Array<string>
  /**
   * The rate for this groupment. will mostly be the same as primaryTkpk, but can be different in case of an MTA or MTM.
   * @type {HotelBookingRate}
   * @memberof ReservationRoomStayRateDetail
   */
  rate?: HotelBookingRate
  /**
   * Referrential in : BASICSweb > Properties > Amenities > Meal plans (local..mealplan.codemealplan and local..mealplan.nommealplan)
   * @type {CodeLabel}
   * @memberof ReservationRoomStayRateDetail
   */
  mealPlan?: CodeLabel
  /**
   * values to consider are NEGOCIATED_RATE, CHAIN_DISCOUNT and OTHER (no referrential)
   * @type {string}
   * @memberof ReservationRoomStayRateDetail
   */
  offerTypeCode?: string
  /**
   * Only when offerTypeCode = CHAIN_DISCOUNT (no referrential)
   * @type {string}
   * @memberof ReservationRoomStayRateDetail
   */
  complementCode?: string
  /**
   * freenight number when it applies. indicates this rate for this day is a freenight
   * @type {string}
   * @memberof ReservationRoomStayRateDetail
   */
  freeNightNumber?: string
  /**
   * the price of the rate for 1 day (aggregation is in offerComponent.amounts)
   * @type {HotelBookingRatePrice}
   * @memberof ReservationRoomStayRateDetail
   */
  price?: HotelBookingRatePrice
  /**
   * calculate the total price of the rate, totalPrice = price.unitaryAmounts.unitarySalePrice.value X dates.length
   * @type {number}
   * @memberof ReservationRoomStayRateDetail
   */
  totalPrice?: number
  /**
   *
   * @type {ReservationRoomStayRateDetailTotalFees}
   * @memberof ReservationRoomStayRateDetail
   */
  totalFees?: ReservationRoomStayRateDetailTotalFees
}
/**
 * todo
 * @export
 * @interface ReservationRoomStayRateDetailTotalFees
 */
export interface ReservationRoomStayRateDetailTotalFees {
  /**
   * fee of the rate, fee = sum(price.taxes[family.code=='FEE'][*].effectiveAmount.value) X dates.length
   * @type {number}
   * @memberof ReservationRoomStayRateDetailTotalFees
   */
  fees?: number
  /**
   * array of feeType, list of all fee code of the rate
   * @type {Array<string>}
   * @memberof ReservationRoomStayRateDetailTotalFees
   */
  feeTypes?: Array<string>
}
/**
 *
 * @export
 * @interface ResponseChoiceModel
 */
export interface ResponseChoiceModel {
  /**
   * id of the choice
   * @type {string}
   * @memberof ResponseChoiceModel
   */
  id?: string
  /**
   * id of the choice
   * @type {string}
   * @memberof ResponseChoiceModel
   */
  choiceId?: string
  /**
   * label of the choice
   * @type {string}
   * @memberof ResponseChoiceModel
   */
  choiceLabel?: string
  /**
   * rank of the choice
   * @type {number}
   * @memberof ResponseChoiceModel
   */
  choiceRank?: number
  /**
   * type of the choice
   * @type {string}
   * @memberof ResponseChoiceModel
   */
  choiceType?: string
  /**
   *
   * @type {Array<string>}
   * @memberof ResponseChoiceModel
   */
  choiceToolTip?: Array<string>
  /**
   * array of tooltip, no return on GET Order
   * @type {Array<ToolTip>}
   * @memberof ResponseChoiceModel
   */
  toolTips?: Array<ToolTip>
}
/**
 *
 * @export
 * @interface SatisfactionSurveyModel
 */
export interface SatisfactionSurveyModel {
  /**
   *
   * @type {boolean}
   * @memberof SatisfactionSurveyModel
   */
  itemScoreNumeric?: boolean
  /**
   *
   * @type {string}
   * @memberof SatisfactionSurveyModel
   */
  itemCode?: string
  /**
   *
   * @type {string}
   * @memberof SatisfactionSurveyModel
   */
  itemScore?: string
  /**
   *
   * @type {string}
   * @memberof SatisfactionSurveyModel
   */
  itemDisplay?: string
  /**
   *
   * @type {Date}
   * @memberof SatisfactionSurveyModel
   */
  dateCheckIn?: Date
  /**
   *
   * @type {Date}
   * @memberof SatisfactionSurveyModel
   */
  dateCheckOut?: Date
  /**
   *
   * @type {string}
   * @memberof SatisfactionSurveyModel
   */
  codeHotel?: string
}
/**
 *
 * @export
 * @interface SearchBookingModel
 */
export interface SearchBookingModel {
  /**
   *
   * @type {string}
   * @memberof SearchBookingModel
   */
  numResa?: string
  /**
   *
   * @type {number}
   * @memberof SearchBookingModel
   */
  bkgNbRoomNights?: number
  /**
   *
   * @type {string}
   * @memberof SearchBookingModel
   */
  codeHotel?: string
  /**
   *
   * @type {Date}
   * @memberof SearchBookingModel
   */
  dateCheckIn?: Date
  /**
   *
   * @type {Date}
   * @memberof SearchBookingModel
   */
  dateCheckOut?: Date
  /**
   *
   * @type {string}
   * @memberof SearchBookingModel
   */
  statusResa?: string
  /**
   *
   * @type {string}
   * @memberof SearchBookingModel
   */
  flagAffLois?: string
  /**
   *
   * @type {string}
   * @memberof SearchBookingModel
   */
  codeEligibilite?: string
  /**
   *
   * @type {string}
   * @memberof SearchBookingModel
   */
  mainCro?: string
  /**
   *
   * @type {string}
   * @memberof SearchBookingModel
   */
  subCro?: string
}
/**
 * calculated from hotelBooking.loyaltySimulationPoints. All the data in this object is a simulation and should not be taken into account after checkout. the appropriate warning should be displayed to the customer that this is simulation, ie a projection of what he might earn once he effectively stays at the hotel.
 * @export
 * @interface Simulation
 */
export interface Simulation {
  /**
   * a list of aberrantes that will prevent the booking from earning points. If an order-item does not have aberrantes, none will be shown here. If all order-items have aberrantes in their simulation, we will deduplicate them and list them here. This means the customer will earn 0 points. To know how many points the customer could have earned without the aberrantes, you can go through all the order-items hotelBooking.loyaltySimulationPoints (to complicated to aggregate). DEV : only if ALL orderItems[*].hotelBooking.loyaltySimulationPoints contain at least 1 campaignOperation[*].campaignCode == 'ABERRANT'. In this case, deduplicate all campaignOperation[campaignCode == 'ABERRANT'].ruleName
   * @type {Array<string>}
   * @memberof Simulation
   */
  aberrantes?: Array<string>
  /**
   * sum of rewardPoints in the order, excluding order-items where the simulation gives an Aberrante. totalRewardsPoints = sum(orderItems[*].hotelBooking.loyaltySimulationPoints.totalRewardsPoints) where orderItems[*].hotelBooking.loyaltySimulationPoints.campaignOperation[*].campaignCode != 'ABERRANT'
   * @type {number}
   * @memberof Simulation
   */
  totalRewardsPoints?: number
  /**
   * sum of statusPoints in the order , excluding order-items where the simulation gives an Aberrante. totalStatusPoints =  sum(orderItems[*].hotelBooking.loyaltySimulationPoints.totalStatusPoints) where orderItems[*].hotelBooking.loyaltySimulationPoints.campaignOperation[*].campaignCode != 'ABERRANT'
   * @type {number}
   * @memberof Simulation
   */
  totalStatusPoints?: number
  /**
   * one of the order-items will trigger an upgrade, excluding simulations where the simulation gives an Aberrante. go through orderItems[*].hotelBooking.loyaltySimulationPoints to know which tier if needed. in other words, at least 1 campaignOperations[] have 1 campaignCode TIERING AND 0 campaignCode ABERRANT. DEV : IN orderItems[*].hotelBooking.loyaltySimulationPoints.campaignOperation[*] : campaignCode =='TIERING'  AND campaignCode != 'ABERRANT' ? true:false
   * @type {boolean}
   * @memberof Simulation
   */
  hasUpgrade?: boolean
  /**
   * one of the order-items will trigger a bonus, excluding order-items where the simulation gives an Aberrante. in this case, go through orderItems[*].hotelBooking.loyaltySimulationPoints to know which bonus if needed. in other words, at least 1 campaignOperations[] have 1 campaignCode EARN_BONUS AND 0 campaignCode ABERRANT. DEV : IN orderItems[*].hotelBooking.loyaltySimulationPoints.campaignOperation[*] : campaignCode =='EARN_BONUS'  AND campaignCode != 'ABERRANT' ? true:false
   * @type {boolean}
   * @memberof Simulation
   */
  hasBonus?: boolean
}
/**
 *
 * @export
 * @interface StayAwardsUsage
 */
export interface StayAwardsUsage {
  /**
   * the id of the award in LUKE. LUKEDB : voucher_usage.ID
   * @type {number}
   * @memberof StayAwardsUsage
   */
  id?: number
  /**
   * the type of the award used in the stay item. relevant classes are SNU and DIN. LUKEDB : voucher_usage.TYPE
   * @type {string}
   * @memberof StayAwardsUsage
   */
  type?: string
  /**
   * the number of the reward award in the stay item.. LUKEDB : voucher_usage.VOUCHER_NUMBER
   * @type {string}
   * @memberof StayAwardsUsage
   */
  voucherNumber?: string
  /**
   * the last time the award was updated, probably upon receiving the stay. LUKEDB : voucher_usage.LAST_UPDATE_DATE
   * @type {string}
   * @memberof StayAwardsUsage
   */
  updateDate?: string
  /**
   * the date when the award was used. LUKEDB : voucher_usage.VALUE_DATE
   * @type {string}
   * @memberof StayAwardsUsage
   */
  valueDate?: string
  /**
   * should be the same as the $declaration.order.id, but sometimes it isn't because there are multiple orders for the same person, same dates and same hotel, and LUKE misassociates the award to the wrong order. This orderId is the \"real\" orderId when the award was used, in case there is a misassociation. However, the NO_EARN_ON_BURN policy is applied using the associated $declaration.order.id and not this one. LUKEDB : voucher_usage.BOOKING_NUMBER
   * @type {string}
   * @memberof StayAwardsUsage
   */
  orderId?: string
  /**
   *
   * @type {StayAwardsUsageAmounts}
   * @memberof StayAwardsUsage
   */
  amounts?: StayAwardsUsageAmounts
}
/**
 *
 * @export
 * @interface StayAwardsUsageAmounts
 */
export interface StayAwardsUsageAmounts {
  /**
   * the amount of the award used in the stay item, in the original currency. LUKEDB : voucher_usage.amount_in_currency and voucher_usage.CURRENCY_CODE
   * @type {CurrencyValue}
   * @memberof StayAwardsUsageAmounts
   */
  local?: CurrencyValue
  /**
   * the amount of the award used in the stay item, in Euros (EUR). LUKEDB : voucher_usage.AMOUNT_IN_EURO and \"EUR\"
   * @type {CurrencyValue}
   * @memberof StayAwardsUsageAmounts
   */
  reference?: CurrencyValue
}
/**
 * all the data will come from LUKE's DB table : DECLARATION WHERE DECLARATION_CLASS = \"LeahStayDeclaration\" AND PROCESSED != \"0\"  AND (d.STAY_ORIGIN != \"IMAGE_FINALE_SIMULATED\" OR d.STAY_ORIGIN IS NULL) AND PMID IS NOT NULL. Multiple declarations from different sources car represent the same stay.
 * @export
 * @interface StayDeclaration
 */
export interface StayDeclaration {
  /**
   * id of the stay in luke. LUKEDB : DECLARATION.DECLARATION_ID
   * @type {number}
   * @memberof StayDeclaration
   */
  id: number
  /**
   * the day the stay was declared in LUKE. LUKEDB : DECLARATION.ADD_DATE
   * @type {string}
   * @memberof StayDeclaration
   */
  addDate?: string
  /**
   * the day the stay was created in the source system (EARN PMS, UPE, ITD...). LUKEDB : DECLARATION.DECLARATION_DATE
   * @type {string}
   * @memberof StayDeclaration
   */
  declarationDate?: string
  /**
   * the day the stay was created in the source system (EARN PMS, UPE, ITD...). LUKEDB : DECLARATION.UPDATE_DATE
   * @type {string}
   * @memberof StayDeclaration
   */
  updateDate: string
  /**
   * comment of the stay in luke. usually indicates the type of aberrantes triggered, seperated by \";\" LUKEDB : DECLARATION.DECLARATION_COMMENT
   * @type {string}
   * @memberof StayDeclaration
   */
  declarationComment?: string
  /**
   * WCO will only take processed declarations from luke (!= 0). Possible values are 1 and A (when aberrante). LUKEDB : DECLARATION.PROCESSED
   * @type {string}
   * @memberof StayDeclaration
   */
  processed?: string
  /**
   *
   * @type {StayDeclarationAmounts}
   * @memberof StayDeclaration
   */
  amounts?: StayDeclarationAmounts
  /**
   * the cardNumber that will benefit from the stay \"results\". LUKEDB : DECLARATION.CARD_NUMBER
   * @type {string}
   * @memberof StayDeclaration
   */
  cardNumber?: string
  /**
   * check-in date of the stay. LUKEDB : DECLARATION.CHECK_IN_DATE
   * @type {string}
   * @memberof StayDeclaration
   */
  checkinDate: string
  /**
   * check-out date of the stay. LUKEDB : DECLARATION.CHECK_OUT_DATE
   * @type {string}
   * @memberof StayDeclaration
   */
  checkoutDate: string
  /**
   * number of nights for the stay. LUKEDB : DECLARATION.NUMBER_OF_NIGHTS
   * @type {number}
   * @memberof StayDeclaration
   */
  nbNights?: number
  /**
   * source of the stay. most values are one of DATA_SOURCE_PMS,DATA_SOURCE_HOTEL_UI,DATA_SOURCE_MANUAL,DATA_SOURCE_TPE,DATA_SOURCE_PMS_EXTRACTOR,DATA_SOURCE_BILLING_FORM. LUKEDB : DECLARATION.DATA_SOURCE
   * @type {string}
   * @memberof StayDeclaration
   */
  dataSource?: string
  /**
   * source of the stay. most values are one of FIDELIO,FOLS,IMAGE_FINALE,OPERA,SIHOT. LUKEDB : DECLARATION.STAY_ORIGIN
   * @type {string}
   * @memberof StayDeclaration
   */
  stayOrigin?: string
  /**
   * hotel code of the stay in luke. LUKEDB : DECLARATION.TARS_CODE
   * @type {string}
   * @memberof StayDeclaration
   */
  hotelCode: string
  /**
   * the room number of the stay in luke. LUKEDB : DECLARATION.ROOM_NUMBER
   * @type {string}
   * @memberof StayDeclaration
   */
  roomNumber?: string
  /**
   *
   * @type {StayDeclarationOrder}
   * @memberof StayDeclaration
   */
  order?: StayDeclarationOrder
}
/**
 *
 * @export
 * @interface StayDeclarationAmounts
 */
export interface StayDeclarationAmounts {
  /**
   * the amount of the stay item, in the original currency. LUKEDB : DECLARATION.TRANSACTION_AMOUNT and CURRENCY.CURRENCY_ID WHERE CURRENCY.AFNOR_CODE == DECLARATION.TRANSACTION_CURR_AFNOR_CODE
   * @type {CurrencyValue}
   * @memberof StayDeclarationAmounts
   */
  transaction?: CurrencyValue
  /**
   * the amount of the stay item in Euros (EUR). LUKEDB : DECLARATION.REFERENCE_GROSS_AMOUNT and \"EUR\"
   * @type {CurrencyValue}
   * @memberof StayDeclarationAmounts
   */
  referenceGross?: CurrencyValue
  /**
   * the amount of the stay item in Euros (EUR) after deduction of awards or points used for the stay (NO EARN ON BURN). the reference amount will be used to calculate points to be earned. LUKEDB : DECLARATION.REFERENCE_AMOUNT and \"EUR\"
   * @type {CurrencyValue}
   * @memberof StayDeclarationAmounts
   */
  reference?: CurrencyValue
}
/**
 * can be null when the order was not found (direct hotel, walk-in...)
 * @export
 * @interface StayDeclarationOrder
 */
export interface StayDeclarationOrder {
  /**
   * the orderId of the order related to the stay. LUKEDB : DECLARATION.BOOKING_FILE_NUMBER
   * @type {string}
   * @memberof StayDeclarationOrder
   */
  orderId?: string
  /**
   * the orderItemId of the order-item related to the stay-item. LUKEDB : DECLARATION.TARS_RESA_NUMBER
   * @type {string}
   * @memberof StayDeclarationOrder
   */
  orderItemId?: string
  /**
   * Cro that initiated the booking. LUKEDB : DECLARATION.BOOKING_CRO
   * @type {string}
   * @memberof StayDeclarationOrder
   */
  cro?: string
  /**
   * Sub Cro that initiated the booking. LUKEDB : DECLARATION.BOOKING_SUBCRO
   * @type {string}
   * @memberof StayDeclarationOrder
   */
  subCro?: string
  /**
   * tarskey family of the booking. LUKEDB : DECLARATION.BOOKING_TARS_KEY_FAMILY
   * @type {string}
   * @memberof StayDeclarationOrder
   */
  tarsKeyFamily?: string
  /**
   * tarskeys of the booking, seperated by \";\". LUKEDB : DECLARATION.BOOKING_TARS_KEYS
   * @type {string}
   * @memberof StayDeclarationOrder
   */
  tarsKeys?: string
  /**
   * rate codes of the booking, seperated by \"|\". LUKEDB : DECLARATION.RATE_CODES
   * @type {string}
   * @memberof StayDeclarationOrder
   */
  rateCode?: string
  /**
   * channelFamily code of the booking. Is equivalent to the bookings's HotelBookingOrigin.channelDetails.family.code
   * @type {string}
   * @memberof StayDeclarationOrder
   */
  channelFamilyCode?: string
}
/**
 * a stay item represents room. It is the equivalent of an order-item, but for a stay. It will contain the \"results\" of the stay such as upgrades, points (reward/status), accelerators, bonuses or \"aberrantes\" (the reason why the customer did not earn points for the stay).
 * @export
 * @interface StayItem
 */
export interface StayItem {
  /**
   * the PMID of the stay's main beneficiary. LUKEDB : DECLARATION.PMID.
   * @type {string}
   * @memberof StayItem
   */
  pmid: string
  /**
   *
   * @type {StayDeclaration}
   * @memberof StayItem
   */
  declaration: StayDeclaration
  /**
   * the rules triggered by the declaration. LUKE DB : SELECT rf.RULE_FIRED_ID, rf.DECLARATION_ID, r.NAME as RULE_NAME, r.RULE_CLASS, r.RULECOMMENT, o.OPERATION_ID, o.POINTS, o.STATUS_POINTS, o.NUMBER_OF_NIGHTS, o.ACCOUNT_ID, a.ANIMATION_CLASS, a.NAME as ANIMATION_NAME, a.ANIMATION_CODE, c.NAME, c.CAMPAIGN_CODE FROM rule_fired rf  LEFT OUTER JOIN RULE r ON rf.RULE_ID = r.RULE_ID LEFT OUTER JOIN OPERATION o ON o.RULE_FIRED_ID = rf.RULE_FIRED_ID LEFT OUTER JOIN ANIMATION a ON o.ANIMATION_ID = a.ANIMATION_ID LEFT OUTER JOIN CAMPAIGN c ON a.CAMPAIGN_ID = c.CAMPAIGN_ID WHERE rf.DECLARATION_ID = $declaration.id
   * @type {Array<StayRule>}
   * @memberof StayItem
   */
  rules?: Array<StayRule>
  /**
   * the rewards in points used for this stay-item . LUKE DB points : SELECT r.*, o.OPERATION_ID, o.RULE_FIRED_ID, o.PARENT_OPERATION_ID, o.CREATION_DATE, o.LABEL, o.POINTS, o.STATUS_POINTS, o.NUMBER_OF_NIGHTS, o.ACCOUNT_ID, a.ANIMATION_CLASS, a.NAME as ANIMATION_NAME, a.ANIMATION_CODE, c.NAME, c.CAMPAIGN_CODE  FROM reward r INNER JOIN operation o on o.OPERATION_ID = r.OPERATION_ID LEFT OUTER JOIN ANIMATION a ON o.ANIMATION_ID = a.ANIMATION_ID LEFT OUTER JOIN CAMPAIGN c ON a.CAMPAIGN_ID = c.CAMPAIGN_ID where r.DECLARATION_ID = $declaration.id
   * @type {Array<StayRewardsUsage>}
   * @memberof StayItem
   */
  rewardsUsage?: Array<StayRewardsUsage>
  /**
   * the awards (SNU, DIN...) used for this stay-item . LUKE DB points : SELECT * FROM voucher_usage WHERE STAY_ID = $declaration.id
   * @type {Array<StayAwardsUsage>}
   * @memberof StayItem
   */
  awardsUsage?: Array<StayAwardsUsage>
}
/**
 * This type represents the dynamodb item of a StayItem in the database for 'stay_items_by_order_id' table. It's declared here for generating TypeScript code, or Avro Schema. The alimentation of this table will come from LUKE's DB by streaming multiple sources
 * @export
 * @interface StayItemByOrderIdDynamodb
 */
export interface StayItemByOrderIdDynamodb {
  /**
   * the orderId linked to the stay. LUKEDB : DECLARATION.BOOKING_FILE_NUMBER
   * @type {string}
   * @memberof StayItemByOrderIdDynamodb
   */
  orderId: string
  /**
   * Hash key. LUKE DB : DECLARATION.DECLARATION_ID.
   * @type {number}
   * @memberof StayItemByOrderIdDynamodb
   */
  stayItemId: number
}
/**
 * This type represents the dynamodb item of a StayItem in the database table. It's declared here for generating TypeScript code, or Avro Schema. The alimentation of this table will come from LUKE's DB by streaming multiple sources
 * @export
 * @interface StayItemDynamodb
 */
export interface StayItemDynamodb {
  /**
   * Hash key. LUKE DB : DECLARATION.DECLARATION_ID.
   * @type {number}
   * @memberof StayItemDynamodb
   */
  stayItemId: number
  /**
   *
   * @type {StayItem}
   * @memberof StayItemDynamodb
   */
  stayItem: StayItem
}
/**
 * calculated from hotelBooking.stayDetails. Here you will find an aggregation of all the stay's \"results\". Aberrantes, earned points, points or awards used, upgrades, bonuses etc.
 * @export
 * @interface StayResults
 */
export interface StayResults {
  /**
   * total reward points earned on the stay. sum of orderItems[*].hotelBooking.stayDetails[*].rules[*].operation.rewardPoints  AND orderItems[*].hotelBooking.stayDetails[*].rules[*].linkedOperation.rewardPoints
   * @type {number}
   * @memberof StayResults
   */
  totalRewardPointsEarned?: number
  /**
   * total status points earned on the stay. sum of orderItems[*].hotelBooking.stayDetails[*].rules[*].operation.statusPoints  AND orderItems[*].hotelBooking.stayDetails[*].rules[*].linkedOperation.statusPoints
   * @type {number}
   * @memberof StayResults
   */
  totalStatusPointsEarned?: number
  /**
   * total accelerator (reward only) points earned on the stay. sum of orderItems[*].hotelBooking.stayDetails[*].rules[*].operation.rewardPoints  AND orderItems[*].hotelBooking.stayDetails[*].rules[*].linkedOperation.rewardPoints where orderItems[*].hotelBooking.stayDetails[*].rules[*].class == 'RuleAccelerator'.
   * @type {number}
   * @memberof StayResults
   */
  totalAcceleratorPointsEarned?: number
  /**
   * total bonus (reward only) points earned on the stay. sum of orderItems[*].hotelBooking.stayDetails[*].rules[*].operation.rewardPoints  AND orderItems[*].hotelBooking.stayDetails[*].rules[*].linkedOperation.rewardPoints where orderItems[*].hotelBooking.stayDetails[*].rules[*].class == 'RuleBonus'.
   * @type {number}
   * @memberof StayResults
   */
  totalBonusPointsEarned?: number
  /**
   * total status nights earned on the stay. sum of orderItems[*].hotelBooking.stayDetails[*].rules[*].operation.nbNights  AND orderItems[*].hotelBooking.stayDetails[*].rules[*].linkedOperation.nbNights.
   * @type {number}
   * @memberof StayResults
   */
  totalNightsEarned?: number
  /**
   * a list of aberrantes that prevented the stay from earning points. If an order-item does not have aberrantes, none will be shown here. If all order-items have aberrantes in their simulation, we will deduplicate them and list them here. orderItems[*].hotelBooking.stayDetails[*].rules[*].class == 'RuleAberrante'
   * @type {Array<string>}
   * @memberof StayResults
   */
  aberrantes?: Array<string>
  /**
   * the upgrade triggered by this stay. extracted from orderItems[*].hotelBooking.stayDetails[*].rules[*].name where orderItems[*].hotelBooking.stayDetails[*].rules[*].class  == 'RuleTiering'. Possible values are ('Tiering.upgrade.to.gold.rule','Tiering.upgrade.to.platinium.rule','Tiering.upgrade.to.silver.rule', 'Tiering.upgrade.aclub.acap.to.gold.rule','Tiering.upgrade.aclub.acap.to.platinum.rule','Tiering.upgrade.pap.to.platinum.rule', 'Tiering.upgrade.aclub.acap.to.diamond.rule','Tiering.upgrade.to.diamond.rule')
   * @type {TierUpgrade}
   * @memberof StayResults
   */
  upgrade?: TierUpgrade
  /**
   * total reward points burned on the stay. To know which type of burn (at checkout B4S or BWP), you need to look down inside stayDetails. Sum of orderItems[*].hotelBooking.stayDetails[*].rewardsUsage[*].operation.rewardPoints  AND orderItems[*].hotelBooking.stayDetails[*].rewardsUsage[*].linkedOperation.rewardPoints
   * @type {number}
   * @memberof StayResults
   */
  totalRewardPointsRedeemed?: number
  /**
   * total awards redeemed for the stay. To know which type of awards (DIN, SNU...), you need to look down inside stayDetails. Sum of orderItems[*].hotelBooking.stayDetails[*].awardsUsage[*].length()
   * @type {number}
   * @memberof StayResults
   */
  totalAwardsRedeemed?: number
}
/**
 * the operation that resulted from the rule, if there is one.
 * @export
 * @interface StayRewardsUsage
 */
export interface StayRewardsUsage {
  /**
   * the id of the reward in LUKE. LUKEDB : REWARD.REWARD_ID
   * @type {number}
   * @memberof StayRewardsUsage
   */
  id?: number
  /**
   * the class of the reward used in the stay item. relevant classes are BookingWithPoints and RewardBurnCheckOut. LUKEDB : REWARD.REWARD_CLASS
   * @type {string}
   * @memberof StayRewardsUsage
   */
  _class?: string
  /**
   * the code of the reward used in the stay item. relevant classes are EVOUBCO and EVOUBOL. LUKEDB : REWARD.REWARD_CODE
   * @type {string}
   * @memberof StayRewardsUsage
   */
  code?: string
  /**
   * LUKEDB : REWARD.UPDATE_DATE
   * @type {string}
   * @memberof StayRewardsUsage
   */
  updateDate?: string
  /**
   * the main operation triggered by the reward usage. LUKE DB : use REWARD.OPERATION_ID
   * @type {LoyaltyOperation}
   * @memberof StayRewardsUsage
   */
  operation?: LoyaltyOperation
  /**
   * indicates there is a linked operation to the one above. Usually a regularization used for cancellation of the main operation. LUKE DB : OPERATION.PARENT_OPERATION_ID == $operation.id  AND RULE_FIRED_ID IS NULL. It has been checked that there can be only one linked operation in this case. whenever a linked operation is found, the main operation will be flagged isCancelled = true
   * @type {LoyaltyOperation}
   * @memberof StayRewardsUsage
   */
  linkedOperation?: LoyaltyOperation
}
/**
 *
 * @export
 * @interface StayRule
 */
export interface StayRule {
  /**
   * the name of the rule triggered by the stay item. LUKEDB : RULE.RULE_NAME
   * @type {string}
   * @memberof StayRule
   */
  name?: string
  /**
   * the class of the rule triggered by the stay item. relevant classes are RuleAberrante,RuleAccelerator,RuleEarn,RuleTiering,RuleBonus,RuleBonusFastTrack and RuleBonusMeetingPlanner. LUKEDB : RULE.RULE_CLASS
   * @type {string}
   * @memberof StayRule
   */
  _class?: string
  /**
   * the comment of the rule triggered by the stay item. LUKEDB : RULE.RULECOMMENT
   * @type {string}
   * @memberof StayRule
   */
  comment?: string
  /**
   * for aberrante type rules, indicates there was an aberrante but it was \"skipped\", meaning the stay was forced to be processed to give points. LUKEDB : RULE_FIRED.SKIPPED
   * @type {boolean}
   * @memberof StayRule
   */
  skipped?: boolean
  /**
   * the main operation triggered by the rule, fired by the stay
   * @type {LoyaltyOperation}
   * @memberof StayRule
   */
  operation?: LoyaltyOperation
  /**
   * indicates there is a linked operation to the one above. Usually a regularization used for cancellation of the main operation. LUKE DB : OPERATION.PARENT_OPERATION_ID == $operation.id  AND RULE_FIRED_ID IS NULL. It has been checked that there can be only one linked operation in this case. whenever a linked operation is found, the main operation will be flagged isCancelled = true
   * @type {LoyaltyOperation}
   * @memberof StayRule
   */
  linkedOperation?: LoyaltyOperation
}
/**
 *
 * @export
 * @interface TarsModel
 */
export interface TarsModel {
  /**
   *
   * @type {string}
   * @memberof TarsModel
   */
  tarsReturnCode?: string
  /**
   *
   * @type {string}
   * @memberof TarsModel
   */
  sbLabel?: string
  /**
   *
   * @type {string}
   * @memberof TarsModel
   */
  sbRank?: string
  /**
   *
   * @type {string}
   * @memberof TarsModel
   */
  excluding?: string
  /**
   *
   * @type {string}
   * @memberof TarsModel
   */
  libelle?: string
}
/**
 * the ToDoToSay recommandation. Can be null
 * @export
 * @interface Tdts
 */
export interface Tdts {
  /**
   *
   * @type {Array<ResponseChoiceModel>}
   * @memberof Tdts
   */
  choices?: Array<ResponseChoiceModel>
}
/**
 *
 * @export
 * @interface ToolTip
 */
export interface ToolTip {
  /**
   * tooltip code
   * @type {string}
   * @memberof ToolTip
   */
  code?: string
  /**
   * tooltip label
   * @type {string}
   * @memberof ToolTip
   */
  label?: string
  /**
   * tooltip separator
   * @type {string}
   * @memberof ToolTip
   */
  separator?: string
}
/**
 * calculated fees data, todo after calculating totalfees by rate
 * @export
 * @interface TotalFees
 */
export interface TotalFees {
  /**
   * fee of the order, sum of all fee of orderItem, = sum(orderItems[*].hotelBooking.reservation.roomStays[0].rateDetails[*].totalFees.fee)
   * @type {number}
   * @memberof TotalFees
   */
  fees?: number
  /**
   * array of feeType, list of all feeType of the order
   * @type {Array<string>}
   * @memberof TotalFees
   */
  feeTypes?: Array<string>
  /**
   * charge and taxe of the order, sum of all ccSurcharge of orderItem, = sum(orderItems[*].hotelBooking.reservation.amounts.ccSurcharge.value)
   * @type {number}
   * @memberof TotalFees
   */
  ccSurcharges?: number
}
/**
 * aggregated and calculated payment data, todo after calculating all price and fees by rate
 * @export
 * @interface TotalOrderPrice
 */
export interface TotalOrderPrice {
  /**
   * the currency code of the order, orderItems[0].hotelBooking.reservation.amounts.tarsPriceAndVat.currencyCode if null then orderItems[0].hotelBooking.reservation.amounts.tarsPrice.currencyCode
   * @type {string}
   * @memberof TotalOrderPrice
   */
  currencyCode?: string
  /**
   *
   * @type {TotalPrice}
   * @memberof TotalOrderPrice
   */
  totalPrice?: TotalPrice
  /**
   *
   * @type {TotalPrice}
   * @memberof TotalOrderPrice
   */
  totalPriceCustomer?: TotalPrice
  /**
   *
   * @type {TotalFees}
   * @memberof TotalOrderPrice
   */
  totalFees?: TotalFees
  /**
   *
   * @type {TotalPrepayment}
   * @memberof TotalOrderPrice
   */
  totalPrepayment?: TotalPrepayment
}
/**
 * calculated prepayment data
 * @export
 * @interface TotalPrepayment
 */
export interface TotalPrepayment {
  /**
   * prepaidAmount of the order, sum of all prepaidAmount of orderItem, = sum(orderItems[*].hotelBooking.reservation.amounts.prepaidAmount.value)
   * @type {number}
   * @memberof TotalPrepayment
   */
  prepaidAmount?: number
  /**
   * remainingPayment of the order to be paid at the hotel , remainingPayment = netPriceIncludingTaxes - prepaidAmount - sum(orderItems[*].hotelBooking.awards[*].amount.value) - orderItems[*].hotelBooking.loyaltyVoucher.tarsAmount.value
   * @type {number}
   * @memberof TotalPrepayment
   */
  remainingPayment?: number
}
/**
 * aggregated and calculated payment data
 * @export
 * @interface TotalPrice
 */
export interface TotalPrice {
  /**
   * netPriceIncludingTaxes of the order, sum of all netPriceIncludingTaxes of orderItem, = sum(orderItems[*].hotelBooking.reservation.amounts.netPriceIncludingTaxes.value)
   * @type {number}
   * @memberof TotalPrice
   */
  netPriceIncludingTaxes?: number
  /**
   * tarsPriceAndVat of the order, sum of all tarsPriceAndVat of orderItem, = sum(orderItems[*].hotelBooking.reservation.amounts.tarsPriceAndVat.value)
   * @type {number}
   * @memberof TotalPrice
   */
  tarsPriceAndVat?: number
  /**
   * tarsPrice of the order, sum of all tarsPrice of orderItem, = sum(orderItems[*].hotelBooking.reservation.amounts.tarsPrice.value)
   * @type {number}
   * @memberof TotalPrice
   */
  tarsPrice?: number
  /**
   * taxAndFees of the order reservation, if netPriceIncludingTaxes exists and >0 then if tarsPriceAndVat exists and >0 then diff between the netPriceIncludingTaxes and tarsPriceAndVat of orderItem else diff between the netPriceIncludingTaxes and tarsPrice  else vide, = if netPriceIncludingTaxes exists and >0 {if tarsPriceAndVat exists and >0 {metaInfo.totalOrderPrice.totalPrice.netPriceIncludingTaxes - metaInfo.totalOrderPrice.totalPrice.tarsPriceAndVat} else {metaInfo.totalOrderPrice.totalPrice.netPriceIncludingTaxes - metaInfo.totalOrderPrice.totalPrice.tarsPrice}} else vide
   * @type {number}
   * @memberof TotalPrice
   */
  taxAndFees?: number
}

export interface Invoice {
  /**
   *
   * @type {string}
   * @memberof Invoice
   */
  url?: string
}
